!(function(e) {
  var t = {};
  function n(a) {
    if (t[a]) return t[a].exports;
    var d = (t[a] = { i: a, l: !1, exports: {} });
    return e[a].call(d.exports, d, d.exports, n), (d.l = !0), d.exports;
  }
  (n.m = e),
    (n.c = t),
    (n.d = function(e, t, a) {
      n.o(e, t) ||
        Object.defineProperty(e, t, {
          configurable: !1,
          enumerable: !0,
          get: a
        });
    }),
    (n.n = function(e) {
      var t =
        e && e.__esModule
          ? function() {
              return e.default;
            }
          : function() {
              return e;
            };
      return n.d(t, "a", t), t;
    }),
    (n.o = function(e, t) {
      return Object.prototype.hasOwnProperty.call(e, t);
    }),
    (n.p = "/"),
    n((n.s = 0));
})({
  "/jrT": function(e, t, n) {
    "use strict";
    (function(e) {
      var a = n("4PV6"),
        d = n.n(a),
        i = n("cyc7"),
        r = n.n(i);
      e.fetch = d.a;
      var o = "3db5db2af4ad226834c52b2d469d56bb",
        c = "shop.meetcircle.com";
      "cms.meetcircle.com" === window.location.hostname ||
      "develop.meetcircle.com" === window.location.hostname
        ? (console.log("Using Shopify staging..."),
          (o = "42393159760cc0e254348171b3e7741a"),
          (c = "meetcircledev.myshopify.com"))
        : console.log("Using Shopify production...");
      var s = r.a.buildClient({ storefrontAccessToken: o, domain: c });
      t.a = s;
    }.call(t, n("DuR2")));
  },
  0: function(e, t, n) {
    n("E+sx"), (e.exports = n("HFnr"));
  },
  "08WP": function(e, t, n) {
    var a;
    (a = function() {
      return (function(e) {
        function t(a) {
          if (n[a]) return n[a].exports;
          var d = (n[a] = { exports: {}, id: a, loaded: !1 });
          return (
            e[a].call(d.exports, d, d.exports, t), (d.loaded = !0), d.exports
          );
        }
        var n = {};
        return (t.m = e), (t.c = n), (t.p = ""), t(0);
      })([
        function(e, t, n) {
          "use strict";
          var a = (function(e) {
            return e && e.__esModule ? e : { default: e };
          })(n(2));
          e.exports = a.default;
        },
        function(e, t) {
          e.exports = function(e) {
            var t = typeof e;
            return null != e && ("object" == t || "function" == t);
          };
        },
        function(e, t, n) {
          "use strict";
          function a(e) {
            return e && e.__esModule ? e : { default: e };
          }
          Object.defineProperty(t, "__esModule", { value: !0 });
          var d = a(n(9)),
            i = a(n(3)),
            r = n(4);
          t.default = (function() {
            if ("undefined" != typeof window) {
              var e = { history: [] },
                t = { offset: {}, threshold: 0, test: r.inViewport },
                n = (0, d.default)(function() {
                  e.history.forEach(function(t) {
                    e[t].check();
                  });
                }, 100);
              ["scroll", "resize", "load"].forEach(function(e) {
                return addEventListener(e, n);
              }),
                window.MutationObserver &&
                  addEventListener("DOMContentLoaded", function() {
                    new MutationObserver(n).observe(document.body, {
                      attributes: !0,
                      childList: !0,
                      subtree: !0
                    });
                  });
              var a = function(n) {
                if ("string" == typeof n) {
                  var a = [].slice.call(document.querySelectorAll(n));
                  return (
                    e.history.indexOf(n) > -1
                      ? (e[n].elements = a)
                      : ((e[n] = (0, i.default)(a, t)), e.history.push(n)),
                    e[n]
                  );
                }
              };
              return (
                (a.offset = function(e) {
                  if (void 0 === e) return t.offset;
                  var n = function(e) {
                    return "number" == typeof e;
                  };
                  return (
                    ["top", "right", "bottom", "left"].forEach(
                      n(e)
                        ? function(n) {
                            return (t.offset[n] = e);
                          }
                        : function(a) {
                            return n(e[a]) ? (t.offset[a] = e[a]) : null;
                          }
                    ),
                    t.offset
                  );
                }),
                (a.threshold = function(e) {
                  return "number" == typeof e && e >= 0 && e <= 1
                    ? (t.threshold = e)
                    : t.threshold;
                }),
                (a.test = function(e) {
                  return "function" == typeof e ? (t.test = e) : t.test;
                }),
                (a.is = function(e) {
                  return t.test(e, t);
                }),
                a.offset(0),
                a
              );
            }
          })();
        },
        function(e, t) {
          "use strict";
          Object.defineProperty(t, "__esModule", { value: !0 });
          var n = (function() {
              function e(e, t) {
                for (var n = 0; n < t.length; n++) {
                  var a = t[n];
                  (a.enumerable = a.enumerable || !1),
                    (a.configurable = !0),
                    "value" in a && (a.writable = !0),
                    Object.defineProperty(e, a.key, a);
                }
              }
              return function(t, n, a) {
                return n && e(t.prototype, n), a && e(t, a), t;
              };
            })(),
            a = (function() {
              function e(t, n) {
                (function(e, t) {
                  if (!(e instanceof t))
                    throw new TypeError("Cannot call a class as a function");
                })(this, e),
                  (this.options = n),
                  (this.elements = t),
                  (this.current = []),
                  (this.handlers = { enter: [], exit: [] }),
                  (this.singles = { enter: [], exit: [] });
              }
              return (
                n(e, [
                  {
                    key: "check",
                    value: function() {
                      var e = this;
                      return (
                        this.elements.forEach(function(t) {
                          var n = e.options.test(t, e.options),
                            a = e.current.indexOf(t),
                            d = a > -1,
                            i = !n && d;
                          n && !d && (e.current.push(t), e.emit("enter", t)),
                            i && (e.current.splice(a, 1), e.emit("exit", t));
                        }),
                        this
                      );
                    }
                  },
                  {
                    key: "on",
                    value: function(e, t) {
                      return this.handlers[e].push(t), this;
                    }
                  },
                  {
                    key: "once",
                    value: function(e, t) {
                      return this.singles[e].unshift(t), this;
                    }
                  },
                  {
                    key: "emit",
                    value: function(e, t) {
                      for (; this.singles[e].length; ) this.singles[e].pop()(t);
                      for (var n = this.handlers[e].length; --n > -1; )
                        this.handlers[e][n](t);
                      return this;
                    }
                  }
                ]),
                e
              );
            })();
          t.default = function(e, t) {
            return new a(e, t);
          };
        },
        function(e, t) {
          "use strict";
          Object.defineProperty(t, "__esModule", { value: !0 }),
            (t.inViewport = function(e, t) {
              var n = e.getBoundingClientRect(),
                a = n.top,
                d = n.right,
                i = n.bottom,
                r = n.left,
                o = n.width,
                c = n.height,
                s = i,
                u = window.innerWidth - r,
                l = window.innerHeight - a,
                f = d,
                p = t.threshold * o,
                m = t.threshold * c;
              return (
                s > t.offset.top + m &&
                u > t.offset.right + p &&
                l > t.offset.bottom + m &&
                f > t.offset.left + p
              );
            });
        },
        function(e, t) {
          (function(t) {
            var n = "object" == typeof t && t && t.Object === Object && t;
            e.exports = n;
          }.call(
            t,
            (function() {
              return this;
            })()
          ));
        },
        function(e, t, n) {
          var a = n(5),
            d =
              "object" == typeof self && self && self.Object === Object && self,
            i = a || d || Function("return this")();
          e.exports = i;
        },
        function(e, t, n) {
          var a = n(1),
            d = n(8),
            i = n(10),
            r = "Expected a function",
            o = Math.max,
            c = Math.min;
          e.exports = function(e, t, n) {
            function s(t) {
              var n = m,
                a = g;
              return (m = g = void 0), (C = t), (y = e.apply(a, n));
            }
            function u(e) {
              var n = e - k;
              return void 0 === k || n >= t || n < 0 || (b && e - C >= h);
            }
            function l() {
              var e = d();
              return u(e)
                ? f(e)
                : void (v = setTimeout(
                    l,
                    (function(e) {
                      var n = t - (e - k);
                      return b ? c(n, h - (e - C)) : n;
                    })(e)
                  ));
            }
            function f(e) {
              return (v = void 0), A && m ? s(e) : ((m = g = void 0), y);
            }
            function p() {
              var e = d(),
                n = u(e);
              if (((m = arguments), (g = this), (k = e), n)) {
                if (void 0 === v)
                  return (function(e) {
                    return (C = e), (v = setTimeout(l, t)), F ? s(e) : y;
                  })(k);
                if (b) return (v = setTimeout(l, t)), s(k);
              }
              return void 0 === v && (v = setTimeout(l, t)), y;
            }
            var m,
              g,
              h,
              y,
              v,
              k,
              C = 0,
              F = !1,
              b = !1,
              A = !0;
            if ("function" != typeof e) throw new TypeError(r);
            return (
              (t = i(t) || 0),
              a(n) &&
                ((F = !!n.leading),
                (h = (b = "maxWait" in n) ? o(i(n.maxWait) || 0, t) : h),
                (A = "trailing" in n ? !!n.trailing : A)),
              (p.cancel = function() {
                void 0 !== v && clearTimeout(v),
                  (C = 0),
                  (m = k = g = v = void 0);
              }),
              (p.flush = function() {
                return void 0 === v ? y : f(d());
              }),
              p
            );
          };
        },
        function(e, t, n) {
          var a = n(6);
          e.exports = function() {
            return a.Date.now();
          };
        },
        function(e, t, n) {
          var a = n(7),
            d = n(1),
            i = "Expected a function";
          e.exports = function(e, t, n) {
            var r = !0,
              o = !0;
            if ("function" != typeof e) throw new TypeError(i);
            return (
              d(n) &&
                ((r = "leading" in n ? !!n.leading : r),
                (o = "trailing" in n ? !!n.trailing : o)),
              a(e, t, { leading: r, maxWait: t, trailing: o })
            );
          };
        },
        function(e, t) {
          e.exports = function(e) {
            return e;
          };
        }
      ]);
    }),
      (e.exports = a());
  },
  "4PV6": function(e, t, n) {
    "use strict";
    var a = (function() {
      if ("undefined" != typeof self) return self;
      if ("undefined" != typeof window) return window;
      if (void 0 !== a) return a;
      throw new Error("unable to locate global object");
    })();
    (e.exports = t = a.fetch),
      (t.default = a.fetch.bind(a)),
      (t.Headers = a.Headers),
      (t.Request = a.Request),
      (t.Response = a.Response);
  },
  "657T": function(e, t, n) {
    "use strict";
    var a = {
        update: null,
        begin: null,
        loopBegin: null,
        changeBegin: null,
        change: null,
        changeComplete: null,
        loopComplete: null,
        complete: null,
        loop: 1,
        direction: "normal",
        autoplay: !0,
        timelineOffset: 0
      },
      d = {
        duration: 1e3,
        delay: 0,
        endDelay: 0,
        easing: "easeOutElastic(1, .5)",
        round: 0
      },
      i = [
        "translateX",
        "translateY",
        "translateZ",
        "rotate",
        "rotateX",
        "rotateY",
        "rotateZ",
        "scale",
        "scaleX",
        "scaleY",
        "scaleZ",
        "skew",
        "skewX",
        "skewY",
        "perspective"
      ],
      r = { CSS: {}, springs: {} };
    function o(e, t, n) {
      return Math.min(Math.max(e, t), n);
    }
    function c(e, t) {
      return e.indexOf(t) > -1;
    }
    function s(e, t) {
      return e.apply(null, t);
    }
    var u = {
      arr: function(e) {
        return Array.isArray(e);
      },
      obj: function(e) {
        return c(Object.prototype.toString.call(e), "Object");
      },
      pth: function(e) {
        return u.obj(e) && e.hasOwnProperty("totalLength");
      },
      svg: function(e) {
        return e instanceof SVGElement;
      },
      inp: function(e) {
        return e instanceof HTMLInputElement;
      },
      dom: function(e) {
        return e.nodeType || u.svg(e);
      },
      str: function(e) {
        return "string" == typeof e;
      },
      fnc: function(e) {
        return "function" == typeof e;
      },
      und: function(e) {
        return void 0 === e;
      },
      hex: function(e) {
        return /(^#[0-9A-F]{6}$)|(^#[0-9A-F]{3}$)/i.test(e);
      },
      rgb: function(e) {
        return /^rgb/.test(e);
      },
      hsl: function(e) {
        return /^hsl/.test(e);
      },
      col: function(e) {
        return u.hex(e) || u.rgb(e) || u.hsl(e);
      },
      key: function(e) {
        return (
          !a.hasOwnProperty(e) &&
          !d.hasOwnProperty(e) &&
          "targets" !== e &&
          "keyframes" !== e
        );
      }
    };
    function l(e) {
      var t = /\(([^)]+)\)/.exec(e);
      return t
        ? t[1].split(",").map(function(e) {
            return parseFloat(e);
          })
        : [];
    }
    function f(e, t) {
      var n = l(e),
        a = o(u.und(n[0]) ? 1 : n[0], 0.1, 100),
        d = o(u.und(n[1]) ? 100 : n[1], 0.1, 100),
        i = o(u.und(n[2]) ? 10 : n[2], 0.1, 100),
        c = o(u.und(n[3]) ? 0 : n[3], 0.1, 100),
        s = Math.sqrt(d / a),
        f = i / (2 * Math.sqrt(d * a)),
        p = f < 1 ? s * Math.sqrt(1 - f * f) : 0,
        m = 1,
        g = f < 1 ? (f * s - c) / p : -c + s;
      function h(e) {
        var n = t ? (t * e) / 1e3 : e;
        return (
          (n =
            f < 1
              ? Math.exp(-n * f * s) *
                (m * Math.cos(p * n) + g * Math.sin(p * n))
              : (m + g * n) * Math.exp(-n * s)),
          0 === e || 1 === e ? e : 1 - n
        );
      }
      return t
        ? h
        : function() {
            var t = r.springs[e];
            if (t) return t;
            for (var n = 0, a = 0; ; )
              if (1 === h((n += 1 / 6))) {
                if (++a >= 16) break;
              } else a = 0;
            var d = n * (1 / 6) * 1e3;
            return (r.springs[e] = d), d;
          };
    }
    function p(e, t) {
      void 0 === e && (e = 1), void 0 === t && (t = 0.5);
      var n = o(e, 1, 10),
        a = o(t, 0.1, 2);
      return function(e) {
        return 0 === e || 1 === e
          ? e
          : -n *
              Math.pow(2, 10 * (e - 1)) *
              Math.sin(
                ((e - 1 - (a / (2 * Math.PI)) * Math.asin(1 / n)) *
                  (2 * Math.PI)) /
                  a
              );
      };
    }
    function m(e) {
      return (
        void 0 === e && (e = 10),
        function(t) {
          return Math.round(t * e) * (1 / e);
        }
      );
    }
    var g = (function() {
        var e = 11,
          t = 1 / (e - 1);
        function n(e, t) {
          return 1 - 3 * t + 3 * e;
        }
        function a(e, t) {
          return 3 * t - 6 * e;
        }
        function d(e) {
          return 3 * e;
        }
        function i(e, t, i) {
          return ((n(t, i) * e + a(t, i)) * e + d(t)) * e;
        }
        function r(e, t, i) {
          return 3 * n(t, i) * e * e + 2 * a(t, i) * e + d(t);
        }
        return function(n, a, d, o) {
          if (0 <= n && n <= 1 && 0 <= d && d <= 1) {
            var c = new Float32Array(e);
            if (n !== a || d !== o)
              for (var s = 0; s < e; ++s) c[s] = i(s * t, n, d);
            return function(e) {
              return n === a && d === o
                ? e
                : 0 === e || 1 === e
                ? e
                : i(u(e), a, o);
            };
          }
          function u(a) {
            for (var o = 0, s = 1, u = e - 1; s !== u && c[s] <= a; ++s) o += t;
            var l = o + ((a - c[--s]) / (c[s + 1] - c[s])) * t,
              f = r(l, n, d);
            return f >= 0.001
              ? (function(e, t, n, a) {
                  for (var d = 0; d < 4; ++d) {
                    var o = r(t, n, a);
                    if (0 === o) return t;
                    t -= (i(t, n, a) - e) / o;
                  }
                  return t;
                })(a, l, n, d)
              : 0 === f
              ? l
              : (function(e, t, n, a, d) {
                  var r,
                    o,
                    c = 0;
                  do {
                    (r = i((o = t + (n - t) / 2), a, d) - e) > 0
                      ? (n = o)
                      : (t = o);
                  } while (Math.abs(r) > 1e-7 && ++c < 10);
                  return o;
                })(a, o, o + t, n, d);
          }
        };
      })(),
      h = (function() {
        var e = [
            "Quad",
            "Cubic",
            "Quart",
            "Quint",
            "Sine",
            "Expo",
            "Circ",
            "Back",
            "Elastic"
          ],
          t = {
            In: [
              [0.55, 0.085, 0.68, 0.53],
              [0.55, 0.055, 0.675, 0.19],
              [0.895, 0.03, 0.685, 0.22],
              [0.755, 0.05, 0.855, 0.06],
              [0.47, 0, 0.745, 0.715],
              [0.95, 0.05, 0.795, 0.035],
              [0.6, 0.04, 0.98, 0.335],
              [0.6, -0.28, 0.735, 0.045],
              p
            ],
            Out: [
              [0.25, 0.46, 0.45, 0.94],
              [0.215, 0.61, 0.355, 1],
              [0.165, 0.84, 0.44, 1],
              [0.23, 1, 0.32, 1],
              [0.39, 0.575, 0.565, 1],
              [0.19, 1, 0.22, 1],
              [0.075, 0.82, 0.165, 1],
              [0.175, 0.885, 0.32, 1.275],
              function(e, t) {
                return function(n) {
                  return 1 - p(e, t)(1 - n);
                };
              }
            ],
            InOut: [
              [0.455, 0.03, 0.515, 0.955],
              [0.645, 0.045, 0.355, 1],
              [0.77, 0, 0.175, 1],
              [0.86, 0, 0.07, 1],
              [0.445, 0.05, 0.55, 0.95],
              [1, 0, 0, 1],
              [0.785, 0.135, 0.15, 0.86],
              [0.68, -0.55, 0.265, 1.55],
              function(e, t) {
                return function(n) {
                  return n < 0.5
                    ? p(e, t)(2 * n) / 2
                    : 1 - p(e, t)(-2 * n + 2) / 2;
                };
              }
            ]
          },
          n = { linear: [0.25, 0.25, 0.75, 0.75] },
          a = function(a) {
            t[a].forEach(function(t, d) {
              n["ease" + a + e[d]] = t;
            });
          };
        for (var d in t) a(d);
        return n;
      })();
    function y(e, t) {
      if (u.fnc(e)) return e;
      var n = e.split("(")[0],
        a = h[n],
        d = l(e);
      switch (n) {
        case "spring":
          return f(e, t);
        case "cubicBezier":
          return s(g, d);
        case "steps":
          return s(m, d);
        default:
          return u.fnc(a) ? s(a, d) : s(g, a);
      }
    }
    function v(e) {
      try {
        return document.querySelectorAll(e);
      } catch (e) {
        return;
      }
    }
    function k(e, t) {
      for (
        var n = e.length,
          a = arguments.length >= 2 ? arguments[1] : void 0,
          d = [],
          i = 0;
        i < n;
        i++
      )
        if (i in e) {
          var r = e[i];
          t.call(a, r, i, e) && d.push(r);
        }
      return d;
    }
    function C(e) {
      return e.reduce(function(e, t) {
        return e.concat(u.arr(t) ? C(t) : t);
      }, []);
    }
    function F(e) {
      return u.arr(e)
        ? e
        : (u.str(e) && (e = v(e) || e),
          e instanceof NodeList || e instanceof HTMLCollection
            ? [].slice.call(e)
            : [e]);
    }
    function b(e, t) {
      return e.some(function(e) {
        return e === t;
      });
    }
    function A(e) {
      var t = {};
      for (var n in e) t[n] = e[n];
      return t;
    }
    function P(e, t) {
      var n = A(e);
      for (var a in e) n[a] = t.hasOwnProperty(a) ? t[a] : e[a];
      return n;
    }
    function S(e, t) {
      var n = A(e);
      for (var a in t) n[a] = u.und(e[a]) ? t[a] : e[a];
      return n;
    }
    function _(e) {
      return u.rgb(e)
        ? (n = /rgb\((\d+,\s*[\d]+,\s*[\d]+)\)/g.exec((t = e)))
          ? "rgba(" + n[1] + ",1)"
          : t
        : u.hex(e)
        ? (function(e) {
            var t = e.replace(/^#?([a-f\d])([a-f\d])([a-f\d])$/i, function(
                e,
                t,
                n,
                a
              ) {
                return t + t + n + n + a + a;
              }),
              n = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(t);
            return (
              "rgba(" +
              parseInt(n[1], 16) +
              "," +
              parseInt(n[2], 16) +
              "," +
              parseInt(n[3], 16) +
              ",1)"
            );
          })(e)
        : u.hsl(e)
        ? (function(e) {
            var t,
              n,
              a,
              d =
                /hsl\((\d+),\s*([\d.]+)%,\s*([\d.]+)%\)/g.exec(e) ||
                /hsla\((\d+),\s*([\d.]+)%,\s*([\d.]+)%,\s*([\d.]+)\)/g.exec(e),
              i = parseInt(d[1], 10) / 360,
              r = parseInt(d[2], 10) / 100,
              o = parseInt(d[3], 10) / 100,
              c = d[4] || 1;
            function s(e, t, n) {
              return (
                n < 0 && (n += 1),
                n > 1 && (n -= 1),
                n < 1 / 6
                  ? e + 6 * (t - e) * n
                  : n < 0.5
                  ? t
                  : n < 2 / 3
                  ? e + (t - e) * (2 / 3 - n) * 6
                  : e
              );
            }
            if (0 == r) t = n = a = o;
            else {
              var u = o < 0.5 ? o * (1 + r) : o + r - o * r,
                l = 2 * o - u;
              (t = s(l, u, i + 1 / 3)),
                (n = s(l, u, i)),
                (a = s(l, u, i - 1 / 3));
            }
            return (
              "rgba(" + 255 * t + "," + 255 * n + "," + 255 * a + "," + c + ")"
            );
          })(e)
        : void 0;
      var t, n;
    }
    function O(e) {
      var t = /([\+\-]?[0-9#\.]+)(%|px|pt|em|rem|in|cm|mm|ex|ch|pc|vw|vh|vmin|vmax|deg|rad|turn)?$/.exec(
        e
      );
      if (t) return t[2];
    }
    function I(e, t) {
      return u.fnc(e) ? e(t.target, t.id, t.total) : e;
    }
    function E(e, t) {
      return e.getAttribute(t);
    }
    function w(e, t, n) {
      if (b([n, "deg", "rad", "turn"], O(t))) return t;
      var a = r.CSS[t + n];
      if (!u.und(a)) return a;
      var d = document.createElement(e.tagName),
        i =
          e.parentNode && e.parentNode !== document
            ? e.parentNode
            : document.body;
      i.appendChild(d),
        (d.style.position = "absolute"),
        (d.style.width = 100 + n);
      var o = 100 / d.offsetWidth;
      i.removeChild(d);
      var c = o * parseFloat(t);
      return (r.CSS[t + n] = c), c;
    }
    function x(e, t, n) {
      if (t in e.style) {
        var a = t.replace(/([a-z])([A-Z])/g, "$1-$2").toLowerCase(),
          d = e.style[t] || getComputedStyle(e).getPropertyValue(a) || "0";
        return n ? w(e, d, n) : d;
      }
    }
    function T(e, t) {
      return u.dom(e) && !u.inp(e) && (E(e, t) || (u.svg(e) && e[t]))
        ? "attribute"
        : u.dom(e) && b(i, t)
        ? "transform"
        : u.dom(e) && "transform" !== t && x(e, t)
        ? "css"
        : null != e[t]
        ? "object"
        : void 0;
    }
    function D(e) {
      if (u.dom(e)) {
        for (
          var t,
            n = e.style.transform || "",
            a = /(\w+)\(([^)]*)\)/g,
            d = new Map();
          (t = a.exec(n));

        )
          d.set(t[1], t[2]);
        return d;
      }
    }
    function V(e, t, n, a) {
      var d = c(t, "scale")
          ? 1
          : 0 +
            (function(e) {
              return c(e, "translate") || "perspective" === e
                ? "px"
                : c(e, "rotate") || c(e, "skew")
                ? "deg"
                : void 0;
            })(t),
        i = D(e).get(t) || d;
      return (
        n && (n.transforms.list.set(t, i), (n.transforms.last = t)),
        a ? w(e, i, a) : i
      );
    }
    function U(e, t, n, a) {
      switch (T(e, t)) {
        case "transform":
          return V(e, t, a, n);
        case "css":
          return x(e, t, n);
        case "attribute":
          return E(e, t);
        default:
          return e[t] || 0;
      }
    }
    function M(e, t) {
      var n = /^(\*=|\+=|-=)/.exec(e);
      if (!n) return e;
      var a = O(e) || 0,
        d = parseFloat(t),
        i = parseFloat(e.replace(n[0], ""));
      switch (n[0][0]) {
        case "+":
          return d + i + a;
        case "-":
          return d - i + a;
        case "*":
          return d * i + a;
      }
    }
    function N(e, t) {
      if (u.col(e)) return _(e);
      var n = O(e),
        a = n ? e.substr(0, e.length - n.length) : e;
      return t && !/\s/g.test(e) ? a + t : a;
    }
    function L(e, t) {
      return Math.sqrt(Math.pow(t.x - e.x, 2) + Math.pow(t.y - e.y, 2));
    }
    function B(e) {
      for (var t, n = e.points, a = 0, d = 0; d < n.numberOfItems; d++) {
        var i = n.getItem(d);
        d > 0 && (a += L(t, i)), (t = i);
      }
      return a;
    }
    function j(e) {
      if (e.getTotalLength) return e.getTotalLength();
      switch (e.tagName.toLowerCase()) {
        case "circle":
          return (function(e) {
            return 2 * Math.PI * E(e, "r");
          })(e);
        case "rect":
          return (function(e) {
            return 2 * E(e, "width") + 2 * E(e, "height");
          })(e);
        case "line":
          return (function(e) {
            return L(
              { x: E(e, "x1"), y: E(e, "y1") },
              { x: E(e, "x2"), y: E(e, "y2") }
            );
          })(e);
        case "polyline":
          return B(e);
        case "polygon":
          return (function(e) {
            var t = e.points;
            return B(e) + L(t.getItem(t.numberOfItems - 1), t.getItem(0));
          })(e);
      }
    }
    function q(e, t) {
      var n = t || {},
        a =
          n.el ||
          (function(e) {
            for (
              var t = e.parentNode;
              u.svg(t) && ((t = t.parentNode), u.svg(t.parentNode));

            );
            return t;
          })(e),
        d = a.getBoundingClientRect(),
        i = E(a, "viewBox"),
        r = d.width,
        o = d.height,
        c = n.viewBox || (i ? i.split(" ") : [0, 0, r, o]);
      return {
        el: a,
        viewBox: c,
        x: c[0] / 1,
        y: c[1] / 1,
        w: r / c[2],
        h: o / c[3]
      };
    }
    function R(e, t) {
      function n(n) {
        void 0 === n && (n = 0);
        var a = t + n >= 1 ? t + n : 0;
        return e.el.getPointAtLength(a);
      }
      var a = q(e.el, e.svg),
        d = n(),
        i = n(-1),
        r = n(1);
      switch (e.property) {
        case "x":
          return (d.x - a.x) * a.w;
        case "y":
          return (d.y - a.y) * a.h;
        case "angle":
          return (180 * Math.atan2(r.y - i.y, r.x - i.x)) / Math.PI;
      }
    }
    function G(e, t) {
      var n = /-?\d*\.?\d+/g,
        a = N(u.pth(e) ? e.totalLength : e, t) + "";
      return {
        original: a,
        numbers: a.match(n) ? a.match(n).map(Number) : [0],
        strings: u.str(e) || t ? a.split(n) : []
      };
    }
    function Q(e) {
      return k(e ? C(u.arr(e) ? e.map(F) : F(e)) : [], function(e, t, n) {
        return n.indexOf(e) === t;
      });
    }
    function H(e) {
      var t = Q(e);
      return t.map(function(e, n) {
        return {
          target: e,
          id: n,
          total: t.length,
          transforms: { list: D(e) }
        };
      });
    }
    function W(e, t) {
      var n = A(t);
      if ((/^spring/.test(n.easing) && (n.duration = f(n.easing)), u.arr(e))) {
        var a = e.length;
        2 === a && !u.obj(e[0])
          ? (e = { value: e })
          : u.fnc(t.duration) || (n.duration = t.duration / a);
      }
      var d = u.arr(e) ? e : [e];
      return d
        .map(function(e, n) {
          var a = u.obj(e) && !u.pth(e) ? e : { value: e };
          return (
            u.und(a.delay) && (a.delay = n ? 0 : t.delay),
            u.und(a.endDelay) &&
              (a.endDelay = n === d.length - 1 ? t.endDelay : 0),
            a
          );
        })
        .map(function(e) {
          return S(e, n);
        });
    }
    function $(e, t) {
      var n = [],
        a = t.keyframes;
      for (var d in (a &&
        (t = S(
          (function(e) {
            for (
              var t = k(
                  C(
                    e.map(function(e) {
                      return Object.keys(e);
                    })
                  ),
                  function(e) {
                    return u.key(e);
                  }
                ).reduce(function(e, t) {
                  return e.indexOf(t) < 0 && e.push(t), e;
                }, []),
                n = {},
                a = function(a) {
                  var d = t[a];
                  n[d] = e.map(function(e) {
                    var t = {};
                    for (var n in e)
                      u.key(n) ? n == d && (t.value = e[n]) : (t[n] = e[n]);
                    return t;
                  });
                },
                d = 0;
              d < t.length;
              d++
            )
              a(d);
            return n;
          })(a),
          t
        )),
      t))
        u.key(d) && n.push({ name: d, tweens: W(t[d], e) });
      return n;
    }
    function J(e, t) {
      var n;
      return e.tweens.map(function(a) {
        var d = (function(e, t) {
            var n = {};
            for (var a in e) {
              var d = I(e[a], t);
              u.arr(d) &&
                1 ===
                  (d = d.map(function(e) {
                    return I(e, t);
                  })).length &&
                (d = d[0]),
                (n[a] = d);
            }
            return (
              (n.duration = parseFloat(n.duration)),
              (n.delay = parseFloat(n.delay)),
              n
            );
          })(a, t),
          i = d.value,
          r = u.arr(i) ? i[1] : i,
          o = O(r),
          c = U(t.target, e.name, o, t),
          s = n ? n.to.original : c,
          l = u.arr(i) ? i[0] : s,
          f = O(l) || O(c),
          p = o || f;
        return (
          u.und(r) && (r = s),
          (d.from = G(l, p)),
          (d.to = G(M(r, l), p)),
          (d.start = n ? n.end : 0),
          (d.end = d.start + d.delay + d.duration + d.endDelay),
          (d.easing = y(d.easing, d.duration)),
          (d.isPath = u.pth(i)),
          (d.isColor = u.col(d.from.original)),
          d.isColor && (d.round = 1),
          (n = d),
          d
        );
      });
    }
    var z = {
      css: function(e, t, n) {
        return (e.style[t] = n);
      },
      attribute: function(e, t, n) {
        return e.setAttribute(t, n);
      },
      object: function(e, t, n) {
        return (e[t] = n);
      },
      transform: function(e, t, n, a, d) {
        if ((a.list.set(t, n), t === a.last || d)) {
          var i = "";
          a.list.forEach(function(e, t) {
            i += t + "(" + e + ") ";
          }),
            (e.style.transform = i);
        }
      }
    };
    function K(e, t) {
      H(e).forEach(function(e) {
        for (var n in t) {
          var a = I(t[n], e),
            d = e.target,
            i = O(a),
            r = U(d, n, i, e),
            o = M(N(a, i || O(r)), r),
            c = T(d, n);
          z[c](d, n, o, e.transforms, !0);
        }
      });
    }
    function Y(e, t) {
      return k(
        C(
          e.map(function(e) {
            return t.map(function(t) {
              return (function(e, t) {
                var n = T(e.target, t.name);
                if (n) {
                  var a = J(t, e),
                    d = a[a.length - 1];
                  return {
                    type: n,
                    property: t.name,
                    animatable: e,
                    tweens: a,
                    duration: d.end,
                    delay: a[0].delay,
                    endDelay: d.endDelay
                  };
                }
              })(e, t);
            });
          })
        ),
        function(e) {
          return !u.und(e);
        }
      );
    }
    function X(e, t) {
      var n = e.length,
        a = function(e) {
          return e.timelineOffset ? e.timelineOffset : 0;
        },
        d = {};
      return (
        (d.duration = n
          ? Math.max.apply(
              Math,
              e.map(function(e) {
                return a(e) + e.duration;
              })
            )
          : t.duration),
        (d.delay = n
          ? Math.min.apply(
              Math,
              e.map(function(e) {
                return a(e) + e.delay;
              })
            )
          : t.delay),
        (d.endDelay = n
          ? d.duration -
            Math.max.apply(
              Math,
              e.map(function(e) {
                return a(e) + e.duration - e.endDelay;
              })
            )
          : t.endDelay),
        d
      );
    }
    var Z = 0;
    var ee,
      te = [],
      ne = [],
      ae = (function() {
        function e() {
          ee = requestAnimationFrame(t);
        }
        function t(t) {
          var n = te.length;
          if (n) {
            for (var a = 0; a < n; ) {
              var d = te[a];
              if (d.paused) {
                var i = te.indexOf(d);
                i > -1 && (te.splice(i, 1), (n = te.length));
              } else d.tick(t);
              a++;
            }
            e();
          } else ee = cancelAnimationFrame(ee);
        }
        return e;
      })();
    function de(e) {
      void 0 === e && (e = {});
      var t,
        n = 0,
        i = 0,
        r = 0,
        c = 0,
        s = null;
      function u(e) {
        var t =
          window.Promise &&
          new Promise(function(e) {
            return (s = e);
          });
        return (e.finished = t), t;
      }
      var l = (function(e) {
        var t = P(a, e),
          n = P(d, e),
          i = $(n, e),
          r = H(e.targets),
          o = Y(r, i),
          c = X(o, n),
          s = Z;
        return (
          Z++,
          S(t, {
            id: s,
            children: [],
            animatables: r,
            animations: o,
            duration: c.duration,
            delay: c.delay,
            endDelay: c.endDelay
          })
        );
      })(e);
      u(l);
      function f() {
        var e = l.direction;
        "alternate" !== e &&
          (l.direction = "normal" !== e ? "normal" : "reverse"),
          (l.reversed = !l.reversed),
          t.forEach(function(e) {
            return (e.reversed = l.reversed);
          });
      }
      function p(e) {
        return l.reversed ? l.duration - e : e;
      }
      function m() {
        (n = 0), (i = p(l.currentTime) * (1 / de.speed));
      }
      function g(e, t) {
        t && t.seek(e - t.timelineOffset);
      }
      function h(e) {
        for (var t = 0, n = l.animations, a = n.length; t < a; ) {
          var d = n[t],
            i = d.animatable,
            r = d.tweens,
            c = r.length - 1,
            s = r[c];
          c &&
            (s =
              k(r, function(t) {
                return e < t.end;
              })[0] || s);
          for (
            var u = o(e - s.start - s.delay, 0, s.duration) / s.duration,
              f = isNaN(u) ? 1 : s.easing(u),
              p = s.to.strings,
              m = s.round,
              g = [],
              h = s.to.numbers.length,
              y = void 0,
              v = 0;
            v < h;
            v++
          ) {
            var C = void 0,
              F = s.to.numbers[v],
              b = s.from.numbers[v] || 0;
            (C = s.isPath ? R(s.value, f * F) : b + f * (F - b)),
              m && ((s.isColor && v > 2) || (C = Math.round(C * m) / m)),
              g.push(C);
          }
          var A = p.length;
          if (A) {
            y = p[0];
            for (var P = 0; P < A; P++) {
              p[P];
              var S = p[P + 1],
                _ = g[P];
              isNaN(_) || (y += S ? _ + S : _ + " ");
            }
          } else y = g[0];
          z[d.type](i.target, d.property, y, i.transforms),
            (d.currentValue = y),
            t++;
        }
      }
      function y(e) {
        l[e] && !l.passThrough && l[e](l);
      }
      function v(e) {
        var a = l.duration,
          d = l.delay,
          m = a - l.endDelay,
          v = p(e);
        (l.progress = o((v / a) * 100, 0, 100)),
          (l.reversePlayback = v < l.currentTime),
          t &&
            (function(e) {
              if (l.reversePlayback) for (var n = c; n--; ) g(e, t[n]);
              else for (var a = 0; a < c; a++) g(e, t[a]);
            })(v),
          !l.began &&
            l.currentTime > 0 &&
            ((l.began = !0), y("begin"), y("loopBegin")),
          v <= d && 0 !== l.currentTime && h(0),
          ((v >= m && l.currentTime !== a) || !a) && h(a),
          v > d && v < m
            ? (l.changeBegan ||
                ((l.changeBegan = !0),
                (l.changeCompleted = !1),
                y("changeBegin")),
              y("change"),
              h(v))
            : l.changeBegan &&
              ((l.changeCompleted = !0),
              (l.changeBegan = !1),
              y("changeComplete")),
          (l.currentTime = o(v, 0, a)),
          l.began && y("update"),
          e >= a &&
            ((i = 0),
            l.remaining && !0 !== l.remaining && l.remaining--,
            l.remaining
              ? ((n = r),
                y("loopComplete"),
                y("loopBegin"),
                "alternate" === l.direction && f())
              : ((l.paused = !0),
                l.completed ||
                  ((l.completed = !0),
                  y("loopComplete"),
                  y("complete"),
                  !l.passThrough && "Promise" in window && (s(), u(l)))));
      }
      return (
        (l.reset = function() {
          var e = l.direction;
          (l.passThrough = !1),
            (l.currentTime = 0),
            (l.progress = 0),
            (l.paused = !0),
            (l.began = !1),
            (l.changeBegan = !1),
            (l.completed = !1),
            (l.changeCompleted = !1),
            (l.reversePlayback = !1),
            (l.reversed = "reverse" === e),
            (l.remaining = l.loop),
            (t = l.children);
          for (var n = (c = t.length); n--; ) l.children[n].reset();
          ((l.reversed && !0 !== l.loop) ||
            ("alternate" === e && 1 === l.loop)) &&
            l.remaining++,
            h(0);
        }),
        (l.set = function(e, t) {
          return K(e, t), l;
        }),
        (l.tick = function(e) {
          (r = e), n || (n = r), v((r + (i - n)) * de.speed);
        }),
        (l.seek = function(e) {
          v(p(e));
        }),
        (l.pause = function() {
          (l.paused = !0), m();
        }),
        (l.play = function() {
          l.paused &&
            (l.completed && l.reset(),
            (l.paused = !1),
            te.push(l),
            m(),
            ee || ae());
        }),
        (l.reverse = function() {
          f(), m();
        }),
        (l.restart = function() {
          l.reset(), l.play();
        }),
        l.reset(),
        l.autoplay && l.play(),
        l
      );
    }
    function ie(e, t) {
      for (var n = t.length; n--; )
        b(e, t[n].animatable.target) && t.splice(n, 1);
    }
    "undefined" != typeof document &&
      document.addEventListener("visibilitychange", function() {
        document.hidden
          ? (te.forEach(function(e) {
              return e.pause();
            }),
            (ne = te.slice(0)),
            (te = []))
          : ne.forEach(function(e) {
              return e.play();
            });
      }),
      (de.version = "3.0.1"),
      (de.speed = 1),
      (de.running = te),
      (de.remove = function(e) {
        for (var t = Q(e), n = te.length; n--; ) {
          var a = te[n],
            d = a.animations,
            i = a.children;
          ie(t, d);
          for (var r = i.length; r--; ) {
            var o = i[r],
              c = o.animations;
            ie(t, c), c.length || o.children.length || i.splice(r, 1);
          }
          d.length || i.length || a.pause();
        }
      }),
      (de.get = U),
      (de.set = K),
      (de.convertPx = w),
      (de.path = function(e, t) {
        var n = u.str(e) ? v(e)[0] : e,
          a = t || 100;
        return function(e) {
          return {
            property: e,
            el: n,
            svg: q(n),
            totalLength: j(n) * (a / 100)
          };
        };
      }),
      (de.setDashoffset = function(e) {
        var t = j(e);
        return e.setAttribute("stroke-dasharray", t), t;
      }),
      (de.stagger = function(e, t) {
        void 0 === t && (t = {});
        var n = t.direction || "normal",
          a = t.easing ? y(t.easing) : null,
          d = t.grid,
          i = t.axis,
          r = t.from || 0,
          o = "first" === r,
          c = "center" === r,
          s = "last" === r,
          l = u.arr(e),
          f = l ? parseFloat(e[0]) : parseFloat(e),
          p = l ? parseFloat(e[1]) : 0,
          m = O(l ? e[1] : e) || 0,
          g = t.start || 0 + (l ? f : 0),
          h = [],
          v = 0;
        return function(e, t, u) {
          if (
            (o && (r = 0), c && (r = (u - 1) / 2), s && (r = u - 1), !h.length)
          ) {
            for (var y = 0; y < u; y++) {
              if (d) {
                var k = c ? (d[0] - 1) / 2 : r % d[0],
                  C = c ? (d[1] - 1) / 2 : Math.floor(r / d[0]),
                  F = k - (y % d[0]),
                  b = C - Math.floor(y / d[0]),
                  A = Math.sqrt(F * F + b * b);
                "x" === i && (A = -F), "y" === i && (A = -b), h.push(A);
              } else h.push(Math.abs(r - y));
              v = Math.max.apply(Math, h);
            }
            a &&
              (h = h.map(function(e) {
                return a(e / v) * v;
              })),
              "reverse" === n &&
                (h = h.map(function(e) {
                  return i ? (e < 0 ? -1 * e : -e) : Math.abs(v - e);
                }));
          }
          return g + (l ? (p - f) / v : f) * (Math.round(100 * h[t]) / 100) + m;
        };
      }),
      (de.timeline = function(e) {
        void 0 === e && (e = {});
        var t = de(e);
        return (
          (t.duration = 0),
          (t.add = function(n, a) {
            var i = te.indexOf(t),
              r = t.children;
            function o(e) {
              e.passThrough = !0;
            }
            i > -1 && te.splice(i, 1);
            for (var c = 0; c < r.length; c++) o(r[c]);
            var s = S(n, P(d, e));
            s.targets = s.targets || e.targets;
            var l = t.duration;
            (s.autoplay = !1),
              (s.direction = t.direction),
              (s.timelineOffset = u.und(a) ? l : M(a, l)),
              o(t),
              t.seek(s.timelineOffset);
            var f = de(s);
            o(f), r.push(f);
            var p = X(r, e);
            return (
              (t.delay = p.delay),
              (t.endDelay = p.endDelay),
              (t.duration = p.duration),
              t.seek(0),
              t.reset(),
              t.autoplay && t.play(),
              t
            );
          }),
          t
        );
      }),
      (de.easing = y),
      (de.penner = h),
      (de.random = function(e, t) {
        return Math.floor(Math.random() * (t - e + 1)) + e;
      }),
      (e.exports = de);
  },
  "7ZwJ": function(e, t, n) {
    var a;
    (a = function() {
      "use strict";
      function e(e) {
        for (var t = e.length, n = [], a = 0; a < t; a += 1) n.push(e[a]);
        return n;
      }
      function t(e) {
        return "scrollama__debug-offset--" + e.id;
      }
      function n(e) {
        !(function(e) {
          var n = e.id,
            a = e.offsetVal,
            d = e.stepClass,
            i = document.createElement("div");
          i.setAttribute("id", t({ id: n })),
            i.setAttribute("class", "scrollama__debug-offset"),
            (i.style.position = "fixed"),
            (i.style.left = "0"),
            (i.style.width = "100%"),
            (i.style.height = "0px"),
            (i.style.borderTop = "2px dashed black"),
            (i.style.zIndex = "9999");
          var r = document.createElement("p");
          (r.innerText = '".' + d + '" trigger: ' + a),
            (r.style.fontSize = "12px"),
            (r.style.fontFamily = "monospace"),
            (r.style.color = "black"),
            (r.style.margin = "0"),
            (r.style.padding = "6px"),
            i.appendChild(r),
            document.body.appendChild(i);
        })({
          id: e.id,
          offsetVal: e.offsetVal,
          stepClass: e.stepEl[0].getAttribute("class")
        });
      }
      function a(e) {
        var n = e.id,
          a = (e.stepOffsetHeight, e.offsetMargin);
        e.offsetVal;
        !(function(e) {
          var n = e.id,
            a = e.offsetMargin,
            d = (e.offsetVal, t({ id: n }));
          document.querySelector("#" + d).style.top = a + "px";
        })({ id: n, offsetMargin: a });
      }
      function d(e) {
        var t = e.id,
          n = e.index,
          a = e.state,
          d = (function(e) {
            return "scrollama__debug-step--" + e.id + "-" + e.i;
          })({ id: t, i: n }),
          i = document.querySelector("#" + d + "_above"),
          r = document.querySelector("#" + d + "_below"),
          o = "enter" === a ? "block" : "none";
        i && (i.style.display = o), r && (r.style.display = o);
      }
      return function() {
        var t = [
            "stepAbove",
            "stepBelow",
            "stepProgress",
            "viewportAbove",
            "viewportBelow"
          ],
          i = {
            stepEnter: function() {},
            stepExit: function() {},
            stepProgress: function() {}
          },
          r = {},
          o = null,
          c = [],
          s = [],
          u = [],
          l = [],
          f = 0,
          p = 0,
          m = 0,
          g = 0,
          h = 0,
          y = 0,
          v = !1,
          k = !1,
          C = !1,
          F = !1,
          b = !1,
          A = !1,
          P = "down",
          S = [];
        function _(e) {
          var t = 0;
          if (e.offsetParent)
            do {
              (t += e.offsetTop), (e = e.offsetParent);
            } while (e);
          return t < 0 ? 0 : t;
        }
        function O(e) {
          return +e.getAttribute("data-scrollama-index");
        }
        function I() {
          window.pageYOffset > h
            ? (P = "down")
            : window.pageYOffset < h && (P = "up"),
            (h = window.pageYOffset);
        }
        function E(e) {
          r[e] &&
            r[e].forEach(function(e) {
              return e.disconnect();
            });
        }
        function w() {
          var e, t;
          (m = window.innerHeight),
            (e = document.body),
            (t = document.documentElement),
            (g = Math.max(
              e.scrollHeight,
              e.offsetHeight,
              t.clientHeight,
              t.scrollHeight,
              t.offsetHeight
            )),
            (p = f * m),
            v &&
              ((s = c.map(function(e) {
                return e.offsetHeight;
              })),
              (u = c.map(_)),
              k && R()),
            C &&
              a({ id: o, stepOffsetHeight: s, offsetMargin: p, offsetVal: f });
        }
        function x(e) {
          if (e && !k) return v && R(), (k = !0), !0;
          t.forEach(E), (k = !1);
        }
        function T(e, t) {
          var n = O(e);
          void 0 !== t && (l[n].progress = t);
          var a = { element: e, index: n, progress: l[n].progress };
          "enter" === l[n].state && i.stepProgress(a);
        }
        function D(e, t) {
          if ("above" === t)
            for (var n = 0; n < e; n++) {
              var a = l[n];
              "enter" !== a.state && "down" !== a.direction
                ? (V(c[n], "down", !1), U(c[n], "down"))
                : "enter" === a.state && U(c[n], "down");
            }
          else if ("below" === t)
            for (var d = l.length - 1; d > e; d--) {
              var i = l[d];
              "enter" === i.state && U(c[d], "up"),
                "down" === i.direction && (V(c[d], "up", !1), U(c[d], "up"));
            }
        }
        function V(e, t, n) {
          void 0 === n && (n = !0);
          var a = O(e),
            r = { element: e, index: a, direction: t };
          (l[a].direction = t),
            (l[a].state = "enter"),
            b && n && "down" === t && D(a, "above"),
            b && n && "up" === t && D(a, "below"),
            i.stepEnter &&
              !S[a] &&
              (i.stepEnter(r, l),
              C && d({ id: o, index: a, state: "enter" }),
              A && (S[a] = !0)),
            F && T(e);
        }
        function U(e, t) {
          var n = O(e),
            a = { element: e, index: n, direction: t };
          F &&
            ("down" === t && l[n].progress < 1
              ? T(e, 1)
              : "up" === t && l[n].progress > 0 && T(e, 0)),
            (l[n].direction = t),
            (l[n].state = "exit"),
            i.stepExit(a, l),
            C && d({ id: o, index: n, state: "exit" });
        }
        function M(e) {
          var t = e[0];
          I();
          var n = t.isIntersecting,
            a = t.boundingClientRect,
            d = t.target,
            i = a.top,
            r = a.bottom,
            o = i - p,
            c = r - p,
            s = O(d),
            u = l[s];
          n &&
            o <= 0 &&
            c >= 0 &&
            "down" === P &&
            "enter" !== u.state &&
            V(d, P),
            !n && o > 0 && "up" === P && "enter" === u.state && U(d, P);
        }
        function N(e) {
          var t = e[0];
          I();
          var n = t.isIntersecting,
            a = t.boundingClientRect,
            d = t.target,
            i = a.top,
            r = a.bottom,
            o = i - p,
            c = r - p,
            s = O(d),
            u = l[s];
          n && o <= 0 && c >= 0 && "up" === P && "enter" !== u.state && V(d, P),
            !n && c < 0 && "down" === P && "enter" === u.state && U(d, P);
        }
        function L(e) {
          var t = e[0];
          I();
          var n = t.isIntersecting,
            a = t.target,
            d = O(a),
            i = l[d];
          n &&
            "down" === P &&
            "down" !== i.direction &&
            "enter" !== i.state &&
            (V(a, "down"), U(a, "down"));
        }
        function B(e) {
          var t = e[0];
          I();
          var n = t.isIntersecting,
            a = t.target,
            d = O(a),
            i = l[d];
          n &&
            "up" === P &&
            "down" === i.direction &&
            "enter" !== i.state &&
            (V(a, "up"), U(a, "up"));
        }
        function j(e) {
          var t = e[0];
          I();
          var n = t.isIntersecting,
            a = t.intersectionRatio,
            d = t.boundingClientRect,
            i = t.target,
            r = d.bottom;
          n && r - p >= 0 && T(i, +a.toFixed(3));
        }
        function q() {
          r.stepProgress = c.map(function(e, t) {
            var n = s[t] - p + "px 0px " + (-m + p) + "px 0px",
              a = (function(e) {
                for (
                  var t = Math.ceil(e / y), n = [], a = 1 / t, d = 0;
                  d < t;
                  d++
                )
                  n.push(d * a);
                return n;
              })(s[t]),
              d = new IntersectionObserver(j, { rootMargin: n, threshold: a });
            return d.observe(e), d;
          });
        }
        function R() {
          t.forEach(E),
            (r.viewportAbove = c.map(function(e, t) {
              var n = g - u[t],
                a = p - m - s[t],
                d = new IntersectionObserver(L, {
                  rootMargin: n + "px 0px " + a + "px 0px"
                });
              return d.observe(e), d;
            })),
            (r.viewportBelow = c.map(function(e, t) {
              var n = -p - s[t],
                a = p - m + s[t] + g,
                d = new IntersectionObserver(B, {
                  rootMargin: n + "px 0px " + a + "px 0px"
                });
              return d.observe(e), d;
            })),
            (r.stepAbove = c.map(function(e, t) {
              var n = -p + s[t],
                a = new IntersectionObserver(M, {
                  rootMargin: n + "px 0px " + (p - m) + "px 0px"
                });
              return a.observe(e), a;
            })),
            (r.stepAbove = c.map(function(e, t) {
              var n = -p,
                a = p - m + s[t],
                d = new IntersectionObserver(N, {
                  rootMargin: n + "px 0px " + a + "px 0px"
                });
              return d.observe(e), d;
            })),
            F && q();
        }
        var G = {};
        return (
          (G.setup = function(t) {
            var a = t.step,
              d = t.offset;
            void 0 === d && (d = 0.5);
            var i = t.progress;
            void 0 === i && (i = !1);
            var r = t.threshold;
            void 0 === r && (r = 4);
            var s = t.debug;
            void 0 === s && (s = !1);
            var u = t.order;
            void 0 === u && (u = !0);
            var p,
              m,
              g,
              h,
              k,
              P = t.once;
            return (
              void 0 === P && (P = !1),
              (m = (p = "abcdefghijklmnopqrstuv").length),
              (g = Date.now()),
              (o =
                "" +
                [0, 0, 0]
                  .map(function(e) {
                    return p[Math.floor(Math.random() * m)];
                  })
                  .join("") +
                g),
              (h = a),
              void 0 === k && (k = document),
              (c =
                "string" == typeof h
                  ? e(k.querySelectorAll(h))
                  : h instanceof Element
                  ? e([h])
                  : h instanceof NodeList
                  ? e(h)
                  : h instanceof Array
                  ? h
                  : []).length
                ? ((C = s),
                  (F = i),
                  (b = u),
                  (A = P),
                  G.offsetTrigger(d),
                  (y = Math.max(1, +r)),
                  (v = !0),
                  C && n({ id: o, stepEl: c, offsetVal: f }),
                  c.forEach(function(e, t) {
                    return e.setAttribute("data-scrollama-index", t);
                  }),
                  (l = c.map(function() {
                    return { direction: null, state: null, progress: 0 };
                  })),
                  w(),
                  G.enable(),
                  G)
                : (console.error("scrollama error: no step elements"), G)
            );
          }),
          (G.resize = function() {
            return w(), G;
          }),
          (G.enable = function() {
            return x(!0), G;
          }),
          (G.disable = function() {
            return x(!1), G;
          }),
          (G.destroy = function() {
            x(!1),
              Object.keys(i).forEach(function(e) {
                return (i[e] = null);
              }),
              Object.keys(r).forEach(function(e) {
                return (r[e] = null);
              });
          }),
          (G.offsetTrigger = function(e) {
            return e && !isNaN(e) ? ((f = Math.min(Math.max(0, e), 1)), G) : f;
          }),
          (G.onStepEnter = function(e) {
            return (
              "function" == typeof e
                ? (i.stepEnter = e)
                : console.error(
                    "scrollama error: onStepEnter requires a function"
                  ),
              G
            );
          }),
          (G.onStepExit = function(e) {
            return (
              "function" == typeof e
                ? (i.stepExit = e)
                : console.error(
                    "scrollama error: onStepExit requires a function"
                  ),
              G
            );
          }),
          (G.onStepProgress = function(e) {
            return (
              "function" == typeof e
                ? (i.stepProgress = e)
                : console.error(
                    "scrollama error: onStepProgress requires a function"
                  ),
              G
            );
          }),
          G
        );
      };
    }),
      (e.exports = a());
  },
  DuR2: function(e, t) {
    var n;
    n = (function() {
      return this;
    })();
    try {
      n = n || Function("return this")() || (0, eval)("this");
    } catch (e) {
      "object" == typeof window && (n = window);
    }
    e.exports = n;
  },
  "E+sx": function(e, t, n) {
    n("SFC4"),
      n("wa6o"),
      (window.shopify = n("lunf")),
      (window.inView = n("08WP")),
      n("QaKk"),
      n("cz0s"),
      $("body").removeClass("preload"),
      $(".no-orphan p, .no-orphan h2").each(function() {
        var e = $(this).html();
        (e = e.replace(/ ([^ ]*)$/, "&nbsp;$1")), $(this).html(e);
      }),
      // $(".toggle-modal").on("click", function(e) {
      //   e.preventDefault();
      //   var t = $(this).data("target");
      //   $("#modal-container .modal-body").html($(t).html()),
      //     $("#modal-container").modal("toggle");
      // }),
      $(".modal").on("hidden.bs.modal", function(e) {
        $("#modal-container .modal-body").html("");
      });
    var a = [
      "404moji-1.svg",
      "404moji-2.svg",
      "404moji-3.svg",
      "404moji-4.svg",
      "404moji-5.svg",
      "404moji-6.svg",
      "404moji-7.svg",
      "404moji-8.svg",
      "404moji-9.svg",
      "404moji-10.svg",
      "404moji-11.svg",
      "404moji-12.svg",
      "404moji-13.svg"
    ];
    $("#404_banner .full-width-text__icon").attr({
      src:
        "/meetcircle-v3/svgs/404mojis/" +
        a[Math.floor(Math.random() * a.length)]
    });
    var d,
      i,
      r = location.pathname.split("/");
    ["set-limits", "find-balance", "keep-tabs"].includes(r[1]) &&
      ((i = r[1]),
      $(".navigation__sub-nav-item a").on("click", function(e) {
        e.preventDefault();
        var t,
          n,
          a = $(this)
            .attr("href")
            .split("/");
        (t = this),
          (n = "navigation__sub-nav-link--active"),
          $("." + n).removeClass(n),
          $(t).addClass(n);
        var d = { feature: a[2] };
        history.pushState(d, a[2], "/" + i + "/" + a[2]),
          $("html, body").animate(
            {
              scrollTop:
                $("#feature-" + a[2]).outerHeight() > $(window).height()
                  ? $("#feature-" + a[2]).offset().top -
                    $("#navigation").outerHeight()
                  : $("#feature-" + a[2]).offset().top -
                    ($(window).height() / 2 -
                      $("#feature-" + a[2]).outerHeight() / 2) -
                    $("#navigation").outerHeight() / 2
            },
            800
          );
      }),
      "onhashchange" in window &&
        (d = r).length > 2 &&
        setTimeout(function() {
          $("html, body").animate(
            {
              scrollTop:
                $("#feature-" + d[2]).outerHeight() > $(window).height()
                  ? $("#feature-" + d[2]).offset().top -
                    $("#navigation").outerHeight()
                  : $("#feature-" + d[2]).offset().top -
                    ($(window).height() / 2 -
                      $("#feature-" + d[2]).outerHeight() / 2) -
                    $("#navigation").outerHeight() / 2
            },
            1250
          );
        }, 350),
      inView('[id^="feature-"]').on("enter", function(e) {
        var t = $(e)
          .attr("id")
          .replace("feature-", "");
        if (
          $('.navigation__sub-nav-link[href^="/' + r[1] + "/" + t + '"]').length
        ) {
          var n = "navigation__sub-nav-link--active";
          $("." + n).removeClass(n),
            $(
              '.navigation__sub-nav-link[href^="/' + r[1] + "/" + t + '"]'
            ).addClass(n);
        }
      }),
      inView.offset(window.innerHeight / 2));
    var o = document.querySelector(".stacked-images-horizontal-scroll");
    function c() {
      var e,
        t,
        n,
        a = window.scrollY,
        d =
          ((e = o.getBoundingClientRect()),
          (t = window.pageXOffset || document.documentElement.scrollLeft),
          (n = window.pageYOffset || document.documentElement.scrollTop),
          { top: e.top + n, left: e.left + t }),
        i = Math.abs(
          a -
            (d.top +
              o.getBoundingClientRect().height -
              window.innerHeight -
              o.getBoundingClientRect().height)
        );
      o.style.backgroundPosition = i / 10 + "% 50%";
    }
    if (o) {
      document.querySelector(".stacked-images-horizontal-scroll");
      window.addEventListener("scroll", function() {
        c();
      });
    }
    $(".slick-carousel").slick({
      dots: !0,
      infinite: !0,
      slidesToShow: 1,
      arrows: !1,
      speed: 450,
      cssEase: "ease-out"
    }),
      $(".image-carousel-container").each(function() {
        var e = $(this),
          t = $(".slick-carousel", e);
        $(".content-container ul li:eq(0)", e).addClass("active"),
          $(".content-container ul li", e).on("click", function() {
            t.slick("slickGoTo", $(this).index());
          }),
          t.on("beforeChange", function(t, n, a, d) {
            $(".content-container ul li.active", e).removeClass("active"),
              $(".content-container ul li:eq(" + d + ")", e).addClass("active");
          });
      }),
      $(".press-carousel-items").slick({
        dots: !1,
        infinite: !0,
        slidesToShow: 1,
        arrows: !1,
        autoplaySpeed: 4500,
        responsive: [{ breakpoint: 768, settings: { dots: !0 } }]
      });
    var s = document.querySelectorAll(".press-carousel-indicators li");
    function u(e) {
      var t = e.target.closest(".press-carousel"),
        n = Math.abs(e.target.parentElement.dataset.index - 1);
      $(".press-carousel-items", t).slick("slickGoTo", n);
    }
    $(".press-carousel-items").on("beforeChange", function(e, t, n, a) {
      var d = e.target.closest(".press-carousel");
      $(".press-carousel-indicators li.active", d).removeClass("active"),
        $(".press-carousel-indicators li:eq(" + a + ")", d).addClass("active");
    }),
      s &&
        s.forEach(function(e) {
          e.addEventListener("click", u, !1);
        });
    var l = document.querySelector("#buy-module");
    l && shopify.getProductData(l.dataset.product);
    window.addEventListener("load", function() {
      // window.cookieconsent.initialise({
      //   palette: {
      //     popup: { background: "#ffffff", text: "#001871" },
      //     button: { background: "#00aec7", text: "#ffffff" }
      //   },
      //   content: {
      //     message:
      //       "This site uses cookies to provide you the smoothest possible experience. By using meetcircle.com, you accept our use of cookies.",
      //     dismiss: "Got it",
      //     link: "Learn more",
      //     href: "https://meetcircle.com/legal/privacy"
      //   }
      // });
    });
  },
  HFnr: function(e, t) {},
  QaKk: function(e, t, n) {
    n("657T");
    var a = n("7ZwJ"),
      d = function(e, t) {
        var n = !1;
        n ||
          (e.call(),
          (n = !0),
          setTimeout(function() {
            n = !1;
          }, t));
      };
    function i(e, t, n) {
      var a = e.element;
      a.querySelectorAll(".animate-item"),
        a.querySelectorAll(".animate-image"),
        a.querySelectorAll(".animate-icon");
    }
    var r = document.querySelectorAll(".animate-items");
    if (r.length > 0) {
      i({ element: r[0] });
      var o = [].slice.call(r, 1);
      if (o.length > 0) {
        var c = a(),
          s = window.innerWidth < 768 ? 1 : 0.85;
        c
          .setup({ step: o, once: !0, offset: s, debug: !1, order: !0 })
          .onStepEnter(i)
          .onStepExit(function(e, t, n) {}),
          window.addEventListener("resize", function() {
            d(c.resize, 500);
          });
      }
    }
    var u = document.querySelectorAll(".animate-lines");
    if (u.length > 0) {
      var l = a();
      l
        .setup({ step: u, once: !0, offset: 0.75 })
        .onStepEnter(function(e, t, n) {
          e.element.querySelectorAll(".animate-line");
        }),
        window.addEventListener("resize", function() {
          d(l.resize, 500);
        });
    }
    var f = function(e) {
        return new Promise(function(t) {
          var n = new Image();
          (n.onload = function() {
            return t({ path: e, status: "ok" });
          }),
            (n.onerror = function() {
              return t({ path: e, status: "error" });
            }),
            (n.src = e);
        });
      },
      p = document.querySelector(".hero-image img");
    if (p) {
      var m = p.currentSrc;
      (p.src = m),
        function() {
          for (var e = arguments.length, t = Array(e), n = 0; n < e; n++)
            t[n] = arguments[n];
          return Promise.all(t.map(f));
        }
          .apply(
            void 0,
            (function(e) {
              if (Array.isArray(e)) {
                for (var t = 0, n = Array(e.length); t < e.length; t++)
                  n[t] = e[t];
                return n;
              }
              return Array.from(e);
            })(p)
          )
          .then(function() {});
    }
  },
  SFC4: function(e, t, n) {
    "use strict";
    Object.defineProperty(t, "__esModule", { value: !0 });
    var a = function(e, t) {
        var n = !1;
        n ||
          (e.call(),
          (n = !0),
          setTimeout(function() {
            n = !1;
          }, t));
      },
      d = n("och6"),
      i = d.disableBodyScroll,
      r = d.enableBodyScroll,
      o = document.getElementById("navigation-md"),
      c = [].slice.call(
        document.querySelectorAll('[data-js-module="navigation"]')
      ),
      s = document.querySelectorAll(".navbar-toggler");
    s &&
      s.forEach(function(e) {
        e.addEventListener("click", function(e) {
          l();
        });
      });
    var u = !1,
      l = function() {
        var e = document.body;
        u
          ? (e.classList.remove("mobile-nav--is-open"), (u = !1), r(o))
          : (e.classList.add("mobile-nav--is-open"), (u = !0), i(o));
      },
      f = function() {
        var e =
          (window.pageYOffset || document.scrollTop) -
          (document.clientTop || 0);
        c.forEach(function(t) {
          e > 100
            ? t.classList.add("navigation--is-sticky")
            : t.classList.remove("navigation--is-sticky");
        });
      };
    window.onscroll = function() {
      a(f, 500);
    };
    t.default = "Navigation module ran successfully";
  },
  cyc7: function(e, t, n) {
    "use strict";
    var a =
        "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
          ? function(e) {
              return typeof e;
            }
          : function(e) {
              return e &&
                "function" == typeof Symbol &&
                e.constructor === Symbol &&
                e !== Symbol.prototype
                ? "symbol"
                : typeof e;
            },
      d = function(e, t) {
        if (!(e instanceof t))
          throw new TypeError("Cannot call a class as a function");
      },
      i = (function() {
        function e(e, t) {
          for (var n = 0; n < t.length; n++) {
            var a = t[n];
            (a.enumerable = a.enumerable || !1),
              (a.configurable = !0),
              "value" in a && (a.writable = !0),
              Object.defineProperty(e, a.key, a);
          }
        }
        return function(t, n, a) {
          return n && e(t.prototype, n), a && e(t, a), t;
        };
      })(),
      r = function(e, t) {
        if ("function" != typeof t && null !== t)
          throw new TypeError(
            "Super expression must either be null or a function, not " +
              typeof t
          );
        (e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            enumerable: !1,
            writable: !0,
            configurable: !0
          }
        })),
          t &&
            (Object.setPrototypeOf
              ? Object.setPrototypeOf(e, t)
              : (e.__proto__ = t));
      },
      o = function(e, t) {
        if (!e)
          throw new ReferenceError(
            "this hasn't been initialised - super() hasn't been called"
          );
        return !t || ("object" != typeof t && "function" != typeof t) ? e : t;
      };
    function c() {
      for (var e = arguments.length, t = Array(e), n = 0; n < e; n++)
        t[n] = arguments[n];
      return t.join(" ");
    }
    function s(e) {
      return (
        Boolean(e) &&
        "[object Object]" === Object.prototype.toString.call(e.valueOf())
      );
    }
    function u(e, t) {
      var n =
          arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : null,
        a = e.types[t];
      if (a) return a;
      if (n && "INTERFACE" === n.kind) return n;
      throw new Error("No type of " + t + " found in schema");
    }
    var l = function(e, t) {
        if (!(e instanceof t))
          throw new TypeError("Cannot call a class as a function");
      },
      f = (function() {
        function e(e, t) {
          for (var n = 0; n < t.length; n++) {
            var a = t[n];
            (a.enumerable = a.enumerable || !1),
              (a.configurable = !0),
              "value" in a && (a.writable = !0),
              Object.defineProperty(e, a.key, a);
          }
        }
        return function(t, n, a) {
          return n && e(t.prototype, n), a && e(t, a), t;
        };
      })(),
      p =
        Object.assign ||
        function(e) {
          for (var t = 1; t < arguments.length; t++) {
            var n = arguments[t];
            for (var a in n)
              Object.prototype.hasOwnProperty.call(n, a) && (e[a] = n[a]);
          }
          return e;
        },
      m = function(e, t) {
        if ("function" != typeof t && null !== t)
          throw new TypeError(
            "Super expression must either be null or a function, not " +
              (void 0 === t ? "undefined" : a(t))
          );
        (e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            enumerable: !1,
            writable: !0,
            configurable: !0
          }
        })),
          t &&
            (Object.setPrototypeOf
              ? Object.setPrototypeOf(e, t)
              : (e.__proto__ = t));
      },
      g = function(e, t) {
        if (!e)
          throw new ReferenceError(
            "this hasn't been initialised - super() hasn't been called"
          );
        return !t ||
          ("object" !== (void 0 === t ? "undefined" : a(t)) &&
            "function" != typeof t)
          ? e
          : t;
      },
      h = (function() {
        return function(e, t) {
          if (Array.isArray(e)) return e;
          if (Symbol.iterator in Object(e))
            return (function(e, t) {
              var n = [],
                a = !0,
                d = !1,
                i = void 0;
              try {
                for (
                  var r, o = e[Symbol.iterator]();
                  !(a = (r = o.next()).done) &&
                  (n.push(r.value), !t || n.length !== t);
                  a = !0
                );
              } catch (e) {
                (d = !0), (i = e);
              } finally {
                try {
                  !a && o.return && o.return();
                } finally {
                  if (d) throw i;
                }
              }
              return n;
            })(e, t);
          throw new TypeError(
            "Invalid attempt to destructure non-iterable instance"
          );
        };
      })(),
      y = function(e) {
        if (Array.isArray(e)) {
          for (var t = 0, n = Array(e.length); t < e.length; t++) n[t] = e[t];
          return n;
        }
        return Array.from(e);
      },
      v = (function() {
        function e(t, n, a) {
          l(this, e),
            (this.name = t),
            (this.type = n),
            (this.defaultValue = a),
            Object.freeze(this);
        }
        return (
          f(e, [
            {
              key: "toInputValueString",
              value: function() {
                return "$" + this.name;
              }
            },
            {
              key: "toString",
              value: function() {
                var e = this.defaultValue ? " = " + A(this.defaultValue) : "";
                return "$" + this.name + ":" + this.type + e;
              }
            }
          ]),
          e
        );
      })();
    function k(e) {
      return v.prototype.isPrototypeOf(e);
    }
    function C(e, t, n) {
      return new v(e, t, n);
    }
    var F = (function() {
        function e(t) {
          l(this, e), (this.key = t);
        }
        return (
          f(e, [
            {
              key: "toString",
              value: function() {
                return this.key;
              }
            },
            {
              key: "valueOf",
              value: function() {
                return this.key.valueOf();
              }
            }
          ]),
          e
        );
      })(),
      b = (function() {
        function e(t) {
          l(this, e), (this.value = t);
        }
        return (
          f(e, [
            {
              key: "toString",
              value: function() {
                return this.value.toString();
              }
            },
            {
              key: "valueOf",
              value: function() {
                return this.value.valueOf();
              }
            },
            {
              key: "unwrapped",
              get: function() {
                return this.value;
              }
            }
          ]),
          e
        );
      })();
    function A(e) {
      return v.prototype.isPrototypeOf(e)
        ? e.toInputValueString()
        : F.prototype.isPrototypeOf(e)
        ? String(e)
        : b.prototype.isPrototypeOf(e)
        ? JSON.stringify(e.valueOf())
        : Array.isArray(e)
        ? "[" + c.apply(void 0, y(e.map(A))) + "]"
        : s(e)
        ? P(e, "{", "}")
        : JSON.stringify(e);
    }
    function P(e) {
      var t =
          arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "",
        n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : "",
        a = Object.keys(e).map(function(t) {
          return t + ": " + A(e[t]);
        });
      return "" + t + c.apply(void 0, y(a)) + n;
    }
    var S = function() {},
      _ = S,
      O = S;
    function I(e) {
      var t = S,
        n = {},
        a = null;
      if (2 === e.length)
        if ("function" == typeof e[1]) {
          var d = h(e, 2);
          (n = d[0]), (t = d[1]);
        } else {
          var i = h(e, 2);
          (n = i[0]), (a = i[1]);
        }
      else
        1 === e.length &&
          (U.prototype.isPrototypeOf(e[0])
            ? (a = e[0])
            : "function" == typeof e[0]
            ? (t = e[0])
            : (n = e[0]));
      return { options: n, selectionSet: a, callback: t };
    }
    var E = Object.freeze({}),
      w = (function() {
        function e(t, n, a) {
          l(this, e),
            (this.name = t),
            (this.alias = n.alias || null),
            (this.responseKey = this.alias || this.name),
            (this.args = n.args
              ? (function e(t, n) {
                  return t(n)
                    ? n
                    : s(n)
                    ? Object.freeze(
                        Object.keys(n).reduce(function(a, d) {
                          return (a[d] = e(t, n[d])), a;
                        }, {})
                      )
                    : Array.isArray(n)
                    ? Object.freeze(
                        n.map(function(n) {
                          return e(t, n);
                        })
                      )
                    : n;
                })(k, n.args)
              : E),
            (this.selectionSet = a),
            Object.freeze(this);
        }
        return (
          f(e, [
            {
              key: "toString",
              value: function() {
                var e;
                return (
                  "" +
                  (this.alias ? this.alias + ": " : "") +
                  this.name +
                  ((e = this.args),
                  Object.keys(e).length ? " (" + P(e) + ")" : "") +
                  this.selectionSet
                );
              }
            }
          ]),
          e
        );
      })(),
      x = function e() {
        l(this, e);
      },
      T = (function(e) {
        function t(e, n) {
          l(this, t);
          var a = g(this, (t.__proto__ || Object.getPrototypeOf(t)).call(this));
          return (a.typeName = e), (a.selectionSet = n), Object.freeze(a), a;
        }
        return (
          m(t, x),
          f(t, [
            {
              key: "toString",
              value: function() {
                return "... on " + this.typeName + this.selectionSet;
              }
            }
          ]),
          t
        );
      })(),
      D = (function(e) {
        function t(e) {
          l(this, t);
          var n = g(this, (t.__proto__ || Object.getPrototypeOf(t)).call(this));
          return (
            (n.name = e.name),
            (n.selectionSet = e.selectionSet),
            Object.freeze(n),
            n
          );
        }
        return (
          m(t, x),
          f(t, [
            {
              key: "toString",
              value: function() {
                return "..." + this.name;
              }
            },
            {
              key: "toDefinition",
              value: function() {
                return new V(
                  this.name,
                  this.selectionSet.typeSchema.name,
                  this.selectionSet
                );
              }
            }
          ]),
          t
        );
      })(),
      V = (function() {
        function e(t, n, a) {
          l(this, e),
            (this.name = t),
            (this.typeName = n),
            (this.selectionSet = a),
            (this.spread = new D(this)),
            Object.freeze(this);
        }
        return (
          f(e, [
            {
              key: "toString",
              value: function() {
                return (
                  "fragment " +
                  this.name +
                  " on " +
                  this.typeName +
                  " " +
                  this.selectionSet
                );
              }
            }
          ]),
          e
        );
      })();
    var U = (function() {
        function e(t, n, a) {
          l(this, e),
            (this.typeSchema = "string" == typeof n ? u(t, n) : n),
            _(this.typeSchema.name),
            (this.typeBundle = t),
            (this.selections = []),
            a && a(new M(this.typeBundle, this.typeSchema, this.selections)),
            (this.typeSchema.implementsNode ||
              "Node" === this.typeSchema.name) &&
              ((function e(t) {
                return t.some(function(t) {
                  return w.prototype.isPrototypeOf(t)
                    ? "id" === t.name
                    : !(
                        !x.prototype.isPrototypeOf(t) ||
                        !t.selectionSet.typeSchema.implementsNode
                      ) && e(t.selectionSet.selections);
                });
              })(this.selections) ||
                this.selections.unshift(new w("id", {}, new e(t, "ID")))),
            "INTERFACE" === this.typeSchema.kind &&
              ((function e(t) {
                return t.some(function(t) {
                  return w.prototype.isPrototypeOf(t)
                    ? "__typename" === t.name
                    : !(
                        !x.prototype.isPrototypeOf(t) ||
                        !t.selectionSet.typeSchema.implementsNode
                      ) && e(t.selectionSet.selections);
                });
              })(this.selections) ||
                this.selections.unshift(
                  new w("__typename", {}, new e(t, "String"))
                )),
            (this.selectionsByResponseKey = (function(e) {
              function t(e, t, n) {
                Array.isArray(e[t]) ? e[t].push(n) : (e[t] = [n]);
              }
              var n = e.reduce(function(e, n) {
                return (
                  n.responseKey
                    ? t(e, n.responseKey, n)
                    : Object.keys(
                        n.selectionSet.selectionsByResponseKey
                      ).forEach(function(a) {
                        t(e, a, n);
                      }),
                  e
                );
              }, {});
              return (
                Object.keys(n).forEach(function(e) {
                  Object.freeze(n[e]);
                }),
                Object.freeze(n)
              );
            })(this.selections)),
            Object.freeze(this.selections),
            Object.freeze(this);
        }
        return (
          f(e, [
            {
              key: "toString",
              value: function() {
                return "SCALAR" === this.typeSchema.kind ||
                  "ENUM" === this.typeSchema.kind
                  ? ""
                  : " { " + c(this.selections) + " }";
              }
            }
          ]),
          e
        );
      })(),
      M = (function() {
        function e(t, n, a) {
          l(this, e),
            (this.typeBundle = t),
            (this.typeSchema = n),
            (this.selections = a);
        }
        return (
          f(e, [
            {
              key: "hasSelectionWithResponseKey",
              value: function(e) {
                return this.selections.some(function(t) {
                  return t.responseKey === e;
                });
              }
            },
            {
              key: "add",
              value: function(e) {
                var t = void 0;
                if ("[object String]" === Object.prototype.toString.call(e)) {
                  O(this.typeSchema.name, e);
                  for (
                    var n = arguments.length,
                      a = Array(n > 1 ? n - 1 : 0),
                      d = 1;
                    d < n;
                    d++
                  )
                    a[d - 1] = arguments[d];
                  t = this.field.apply(this, [e].concat(a));
                } else
                  w.prototype.isPrototypeOf(e) &&
                    O(this.typeSchema.name, e.name),
                    (t = e);
                if (
                  t.responseKey &&
                  this.hasSelectionWithResponseKey(t.responseKey)
                )
                  throw new Error(
                    "The field name or alias '" +
                      t.responseKey +
                      "' has already been added."
                  );
                this.selections.push(t);
              }
            },
            {
              key: "field",
              value: function(e) {
                for (
                  var t = arguments.length, n = Array(t > 1 ? t - 1 : 0), a = 1;
                  a < t;
                  a++
                )
                  n[a - 1] = arguments[a];
                var d = I(n),
                  i = d.options,
                  r = d.callback,
                  o = d.selectionSet;
                if (!o) {
                  if (!this.typeSchema.fieldBaseTypes[e])
                    throw new Error(
                      'No field of name "' +
                        e +
                        '" found on type "' +
                        this.typeSchema.name +
                        '" in schema'
                    );
                  var c = u(this.typeBundle, this.typeSchema.fieldBaseTypes[e]);
                  o = new U(this.typeBundle, c, r);
                }
                return new w(e, i, o);
              }
            },
            {
              key: "inlineFragmentOn",
              value: function(e) {
                var t =
                    arguments.length > 1 && void 0 !== arguments[1]
                      ? arguments[1]
                      : S,
                  n = void 0;
                return (
                  (n = U.prototype.isPrototypeOf(t)
                    ? t
                    : new U(this.typeBundle, u(this.typeBundle, e), t)),
                  new T(e, n)
                );
              }
            },
            {
              key: "addField",
              value: function(e) {
                for (
                  var t = arguments.length, n = Array(t > 1 ? t - 1 : 0), a = 1;
                  a < t;
                  a++
                )
                  n[a - 1] = arguments[a];
                this.add.apply(this, [e].concat(n));
              }
            },
            {
              key: "addConnection",
              value: function(e) {
                for (
                  var t = arguments.length, n = Array(t > 1 ? t - 1 : 0), a = 1;
                  a < t;
                  a++
                )
                  n[a - 1] = arguments[a];
                var d = I(n),
                  i = d.options,
                  r = d.callback,
                  o = d.selectionSet;
                this.add(e, i, function(e) {
                  e.add("pageInfo", {}, function(e) {
                    e.add("hasNextPage"), e.add("hasPreviousPage");
                  }),
                    e.add("edges", {}, function(e) {
                      e.add("cursor"), e.addField("node", {}, o || r);
                    });
                });
              }
            },
            {
              key: "addInlineFragmentOn",
              value: function(e) {
                var t =
                  arguments.length > 1 && void 0 !== arguments[1]
                    ? arguments[1]
                    : S;
                this.add(this.inlineFragmentOn(e, t));
              }
            },
            {
              key: "addFragment",
              value: function(e) {
                this.add(e);
              }
            }
          ]),
          e
        );
      })();
    var N = (function() {
        function e(t) {
          l(this, e),
            (this.variableDefinitions = t ? [].concat(y(t)) : []),
            Object.freeze(this.variableDefinitions),
            Object.freeze(this);
        }
        return (
          f(e, [
            {
              key: "toString",
              value: function() {
                return 0 === this.variableDefinitions.length
                  ? ""
                  : " (" + c(this.variableDefinitions) + ") ";
              }
            }
          ]),
          e
        );
      })(),
      L = (function() {
        function e(t, n) {
          l(this, e);
          for (
            var a = arguments.length, d = Array(a > 2 ? a - 2 : 0), i = 2;
            i < a;
            i++
          )
            d[i - 2] = arguments[i];
          var r = (function(e) {
              var t = void 0,
                n = void 0,
                a = void 0;
              if (3 === e.length) {
                var d = h(e, 3);
                (t = d[0]), (n = d[1]), (a = d[2]);
              } else
                2 === e.length
                  ? ("[object String]" === Object.prototype.toString.call(e[0])
                      ? ((t = e[0]), (n = null))
                      : Array.isArray(e[0]) && ((n = e[0]), (t = null)),
                    (a = e[1]))
                  : ((a = e[0]), (t = null));
              return { name: t, variables: n, selectionSetCallback: a };
            })(d),
            o = r.name,
            c = r.variables,
            s = r.selectionSetCallback;
          (this.typeBundle = t),
            (this.name = o),
            (this.variableDefinitions = new N(c)),
            (this.operationType = n),
            "query" === n
              ? ((this.selectionSet = new U(t, t.queryType, s)),
                (this.typeSchema = u(t, t.queryType)))
              : ((this.selectionSet = new U(t, t.mutationType, s)),
                (this.typeSchema = u(t, t.mutationType))),
            Object.freeze(this);
        }
        return (
          f(e, [
            {
              key: "toString",
              value: function() {
                var e = this.name ? " " + this.name : "";
                return (
                  "" +
                  this.operationType +
                  e +
                  this.variableDefinitions +
                  this.selectionSet
                );
              }
            },
            {
              key: "isAnonymous",
              get: function() {
                return !this.name;
              }
            }
          ]),
          e
        );
      })(),
      B = (function(e) {
        function t(e) {
          var n;
          l(this, t);
          for (
            var a = arguments.length, d = Array(a > 1 ? a - 1 : 0), i = 1;
            i < a;
            i++
          )
            d[i - 1] = arguments[i];
          return g(
            this,
            (n = t.__proto__ || Object.getPrototypeOf(t)).call.apply(
              n,
              [this, e, "query"].concat(d)
            )
          );
        }
        return m(t, L), t;
      })(),
      j = (function(e) {
        function t(e) {
          var n;
          l(this, t);
          for (
            var a = arguments.length, d = Array(a > 1 ? a - 1 : 0), i = 1;
            i < a;
            i++
          )
            d[i - 1] = arguments[i];
          return g(
            this,
            (n = t.__proto__ || Object.getPrototypeOf(t)).call.apply(
              n,
              [this, e, "mutation"].concat(d)
            )
          );
        }
        return m(t, L), t;
      })();
    function q(e) {
      return e.isAnonymous;
    }
    function R(e) {
      return (
        1 !== e.length &&
        ((function(e) {
          return e.some(q);
        })(e) ||
          (function(e) {
            var t = e.map(function(e) {
              return e.name;
            });
            return t.reduce(function(e, n, a) {
              return e || t.indexOf(n) !== a;
            }, !1);
          })(e))
      );
    }
    var G = (function() {
        function e(t) {
          l(this, e), (this.typeBundle = t), (this.definitions = []);
        }
        return (
          f(e, [
            {
              key: "toString",
              value: function() {
                return c(this.definitions);
              }
            },
            {
              key: "addOperation",
              value: function(e) {
                for (
                  var t = arguments.length, n = Array(t > 1 ? t - 1 : 0), a = 1;
                  a < t;
                  a++
                )
                  n[a - 1] = arguments[a];
                var d = function(e, t) {
                  for (
                    var n = arguments.length,
                      a = Array(n > 2 ? n - 2 : 0),
                      d = 2;
                    d < n;
                    d++
                  )
                    a[d - 2] = arguments[d];
                  return L.prototype.isPrototypeOf(a[0])
                    ? a[0]
                    : "query" === t
                    ? new (Function.prototype.bind.apply(
                        B,
                        [null].concat([e], a)
                      ))()
                    : new (Function.prototype.bind.apply(
                        j,
                        [null].concat([e], a)
                      ))();
                }.apply(void 0, [this.typeBundle, e].concat(n));
                if (R(this.operations.concat(d)))
                  throw new Error(
                    "All operations must be uniquely named on a multi-operation document"
                  );
                this.definitions.push(d);
              }
            },
            {
              key: "addQuery",
              value: function() {
                for (var e = arguments.length, t = Array(e), n = 0; n < e; n++)
                  t[n] = arguments[n];
                this.addOperation.apply(this, ["query"].concat(t));
              }
            },
            {
              key: "addMutation",
              value: function() {
                for (var e = arguments.length, t = Array(e), n = 0; n < e; n++)
                  t[n] = arguments[n];
                this.addOperation.apply(this, ["mutation"].concat(t));
              }
            },
            {
              key: "defineFragment",
              value: function(e, t, n) {
                if (
                  (function(e, t) {
                    return e.some(function(e) {
                      return e.name === t;
                    });
                  })(this.fragmentDefinitions, e)
                )
                  throw new Error(
                    "All fragments must be uniquely named on a multi-fragment document"
                  );
                var a = new U(this.typeBundle, t, n),
                  d = new V(e, t, a);
                return this.definitions.push(d), d.spread;
              }
            },
            {
              key: "operations",
              get: function() {
                return this.definitions.filter(function(e) {
                  return L.prototype.isPrototypeOf(e);
                });
              }
            },
            {
              key: "fragmentDefinitions",
              get: function() {
                return this.definitions.filter(function(e) {
                  return V.prototype.isPrototypeOf(e);
                });
              }
            }
          ]),
          e
        );
      })(),
      Q = function e(t) {
        var n = this;
        l(this, e),
          Object.defineProperty(this, "attrs", { value: t, enumerable: !1 }),
          Object.keys(this.attrs)
            .filter(function(e) {
              return !(e in n);
            })
            .forEach(function(e) {
              var a = void 0;
              (a =
                null === t[e]
                  ? {
                      enumerable: !0,
                      get: function() {
                        return null;
                      }
                    }
                  : {
                      enumerable: !0,
                      get: function() {
                        return this.attrs[e].valueOf();
                      }
                    }),
                Object.defineProperty(n, e, a);
            });
      },
      H = (function() {
        function e() {
          l(this, e), (this.classStore = {});
        }
        return (
          f(e, [
            {
              key: "registerClassForType",
              value: function(e, t) {
                this.classStore[t] = e;
              }
            },
            {
              key: "unregisterClassForType",
              value: function(e) {
                delete this.classStore[e];
              }
            },
            {
              key: "classForType",
              value: function(e) {
                return this.classStore[e] || Q;
              }
            }
          ]),
          e
        );
      })();
    function W(e) {
      return (
        "[object Null]" !== Object.prototype.toString.call(e) &&
        "[object Undefined]" !== Object.prototype.toString.call(e)
      );
    }
    function $(e) {
      return e.selection.selectionSet.typeSchema.implementsNode;
    }
    function J(e, t) {
      var n = t[t.length - 1],
        a = n.selection.args.first,
        d = Object.keys(n.selection.args)
          .filter(function(e) {
            return k(n.selection.args[e]);
          })
          .map(function(e) {
            return n.selection.args[e];
          }),
        i = d.find(function(e) {
          return "first" === e.name;
        });
      return (
        i || ((i = C("first", "Int", a)), d.push(i)),
        [new G(e.selection.selectionSet.typeBundle), d, i]
      );
    }
    function z(e, t, n, a) {
      var d = t.shift();
      if ((n.push(d.selection.responseKey), t.length))
        e.add(
          d.selection.name,
          { alias: d.selection.alias, args: d.selection.args },
          function(e) {
            z(e, t, n, a);
          }
        );
      else {
        var i = d.selection.selectionSet.selections
            .find(function(e) {
              return "edges" === e.name;
            })
            .selectionSet.selections.find(function(e) {
              return "node" === e.name;
            }),
          r = void 0;
        r = k(d.selection.args.first)
          ? d.selection.args.first
          : C("first", "Int", d.selection.args.first);
        var o = {
          alias: d.selection.alias,
          args: Object.assign({}, d.selection.args, { after: a, first: r })
        };
        e.addConnection(d.selection.name, o, i.selectionSet);
      }
    }
    function K(e) {
      return e.reduce(function(e, t) {
        return (
          D.prototype.isPrototypeOf(t) && e.push(t.toDefinition()),
          e.push.apply(e, y(K(t.selectionSet.selections))),
          e
        );
      }, []);
    }
    function Y(e, t) {
      var n = (function e(t) {
        return null == t ? null : $(t) ? t : e(t.parent);
      })(e);
      return n
        ? function() {
            var a,
              d = [],
              i = n.selection.selectionSet.typeSchema,
              r = n.responseData.id,
              o = (function e(t) {
                return t.selection.selectionSet.typeSchema.implementsNode
                  ? [t]
                  : e(t.parent).concat(t);
              })(e),
              c = J(e, o),
              s = h(c, 2),
              u = s[0],
              l = s[1];
            u.addQuery(l, function(e) {
              d.push("node"),
                e.add("node", { args: { id: r } }, function(e) {
                  e.addInlineFragmentOn(i.name, function(e) {
                    z(e, o.slice(1), d, t);
                  });
                });
            });
            var f = K(u.operations[0].selectionSet.selections);
            return (a = u.definitions).unshift.apply(a, y(f)), [u, d];
          }
        : function() {
            var n,
              a = [],
              d = (function e(t) {
                return t.parent ? e(t.parent).concat(t) : [t];
              })(e),
              i = J(e, d),
              r = h(i, 2),
              o = r[0],
              c = r[1];
            o.addQuery(c, function(e) {
              z(e, d.slice(1), a, t);
            });
            var s = K(o.operations[0].selectionSet.selections);
            return (n = o.definitions).unshift.apply(n, y(s)), [o, a];
          };
    }
    function X(e) {
      return function(t, n) {
        if (
          (function(e) {
            return e.selection.selectionSet.typeSchema.name.endsWith(
              "Connection"
            );
          })(t)
        ) {
          if (
            !(
              n.pageInfo &&
              n.pageInfo.hasOwnProperty("hasNextPage") &&
              n.pageInfo.hasOwnProperty("hasPreviousPage")
            )
          )
            throw new Error(
              'Connections must include the selections "pageInfo { hasNextPage, hasPreviousPage }".'
            );
          return n.edges.map(function(a) {
            return Object.assign(a.node, {
              nextPageQueryAndPath: Y(t, a.cursor),
              hasNextPage: (function(e, t) {
                return t !== e.edges[e.edges.length - 1]
                  ? new b(!0)
                  : e.pageInfo.hasNextPage;
              })(n, a),
              hasPreviousPage: (function(e, t) {
                return t !== e.edges[0]
                  ? new b(!0)
                  : e.pageInfo.hasPreviousPage;
              })(n, a),
              variableValues: e
            });
          });
        }
        return n;
      };
    }
    var Z = (function() {
      function e(t, n) {
        var a =
          arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : null;
        l(this, e),
          (this.selection = t),
          (this.responseData = n),
          (this.parent = a),
          Object.freeze(this);
      }
      return (
        f(e, [
          {
            key: "contextForObjectProperty",
            value: function(t) {
              var n = this.selection.selectionSet.selectionsByResponseKey[t],
                a = n && n[0],
                d = void 0;
              if (
                ((d = x.prototype.isPrototypeOf(a)
                  ? new e(a, this.responseData, this.parent)
                  : new e(a, this.responseData[t], this)),
                !a)
              )
                throw new Error(
                  'Unexpected response key "' +
                    t +
                    '", not found in selection set: ' +
                    this.selection.selectionSet
                );
              return w.prototype.isPrototypeOf(a)
                ? d
                : d.contextForObjectProperty(t);
            }
          },
          {
            key: "contextForArrayItem",
            value: function(t) {
              return new e(this.selection, t, this.parent);
            }
          }
        ]),
        e
      );
    })();
    function ee(e, t) {
      var n = e.responseData;
      return (
        Array.isArray(n)
          ? (n = (function(e, t) {
              return e.responseData.map(function(n) {
                return ee(e.contextForArrayItem(n), t);
              });
            })(e, t))
          : s(n) &&
            (n = (function(e, t) {
              return Object.keys(e.responseData).reduce(function(n, a) {
                return (n[a] = ee(e.contextForObjectProperty(a), t)), n;
              }, {});
            })(e, t)),
        (function(e, t, n) {
          return e.reduce(function(e, n) {
            return n(t, e);
          }, n);
        })(t, e, n)
      );
    }
    function te(e, t) {
      return (
        W(t) &&
          $(e) &&
          (t.refetchQuery = function() {
            return new B(e.selection.selectionSet.typeBundle, function(t) {
              t.add("node", { args: { id: e.responseData.id } }, function(t) {
                t.addInlineFragmentOn(
                  e.selection.selectionSet.typeSchema.name,
                  e.selection.selectionSet
                );
              });
            });
          }),
        t
      );
    }
    function ne(e, t) {
      if (W(t)) {
        if ("SCALAR" === e.selection.selectionSet.typeSchema.kind)
          return new b(t);
        if ("ENUM" === e.selection.selectionSet.typeSchema.kind)
          return new F(t);
      }
      return t;
    }
    function ae(e, t) {
      var n = e.selection.selectionSet,
        a = n.typeBundle,
        d = n.typeSchema;
      return (
        W(t) &&
          (t.__typename ? (t.type = u(a, t.__typename, d)) : (t.type = d)),
        t
      );
    }
    function de(e) {
      var t = e.classRegistry,
        n = void 0 === t ? new H() : t;
      return [
        ne,
        te,
        X(e.variableValues),
        ae,
        (function(e) {
          return function(t, n) {
            return s(n)
              ? new (e.classForType(t.selection.selectionSet.typeSchema.name))(
                  n
                )
              : n;
          };
        })(n)
      ];
    }
    var ie = (function() {
        function e(t, n) {
          var a = n.url,
            d = n.fetcherOptions,
            i = n.fetcher,
            r = n.registry,
            o = void 0 === r ? new H() : r;
          if (
            (l(this, e),
            (this.typeBundle = t),
            (this.classRegistry = o),
            a && i)
          )
            throw new Error(
              "Arguments not supported: supply either `url` and optional `fetcherOptions` OR use a `fetcher` function for further customization."
            );
          if (a)
            this.fetcher = (function(e) {
              var t =
                arguments.length > 1 && void 0 !== arguments[1]
                  ? arguments[1]
                  : {};
              return function(n, a) {
                return fetch(
                  e,
                  p(
                    { body: JSON.stringify(n), method: "POST", mode: "cors" },
                    t,
                    {
                      headers: p(
                        {
                          "Content-Type": "application/json",
                          Accept: "application/json"
                        },
                        t.headers,
                        a
                      )
                    }
                  )
                ).then(function(e) {
                  return e.headers
                    .get("content-type")
                    .indexOf("application/json") > -1
                    ? e.json()
                    : e.text().then(function(e) {
                        return { text: e };
                      });
                });
              };
            })(a, d);
          else {
            if (!i)
              throw new Error(
                "Invalid arguments: one of `url` or `fetcher` is needed."
              );
            if (d)
              throw new Error(
                "Arguments not supported: when specifying your own `fetcher`, set options through it and not with `fetcherOptions`"
              );
            this.fetcher = i;
          }
        }
        return (
          f(e, [
            {
              key: "document",
              value: function() {
                return new G(this.typeBundle);
              }
            },
            {
              key: "query",
              value: function() {
                for (var e = arguments.length, t = Array(e), n = 0; n < e; n++)
                  t[n] = arguments[n];
                return new (Function.prototype.bind.apply(
                  B,
                  [null].concat([this.typeBundle], t)
                ))();
              }
            },
            {
              key: "mutation",
              value: function() {
                for (var e = arguments.length, t = Array(e), n = 0; n < e; n++)
                  t[n] = arguments[n];
                return new (Function.prototype.bind.apply(
                  j,
                  [null].concat([this.typeBundle], t)
                ))();
              }
            },
            {
              key: "send",
              value: function(e) {
                var t =
                    arguments.length > 1 && void 0 !== arguments[1]
                      ? arguments[1]
                      : null,
                  n = this,
                  a =
                    arguments.length > 2 && void 0 !== arguments[2]
                      ? arguments[2]
                      : null,
                  d =
                    arguments.length > 3 && void 0 !== arguments[3]
                      ? arguments[3]
                      : null,
                  i = void 0,
                  r = {
                    query: (i = Function.prototype.isPrototypeOf(e)
                      ? e(this)
                      : e).toString()
                  };
                t && (r.variables = t), Object.assign(r, a);
                var o = void 0;
                if (L.prototype.isPrototypeOf(i)) o = i;
                else {
                  var c = i;
                  if (1 === c.operations.length) o = c.operations[0];
                  else {
                    if (!a.operationName)
                      throw new Error(
                        "\n          A document must contain exactly one operation, or an operationName\n          must be specified. Example:\n\n            client.send(document, null, {operationName: 'myFancyQuery'});\n        "
                      );
                    o = c.operations.find(function(e) {
                      return e.name === a.operationName;
                    });
                  }
                }
                return this.fetcher(r, d).then(function(e) {
                  return (
                    e.data &&
                      (e.model = (function(e, t) {
                        var n =
                            arguments.length > 2 && void 0 !== arguments[2]
                              ? arguments[2]
                              : {},
                          a = n.transformers || de(n);
                        return ee(new Z(e, t), a);
                      })(o, e.data, {
                        classRegistry: n.classRegistry,
                        variableValues: t
                      })),
                    e
                  );
                });
              }
            },
            {
              key: "fetchNextPage",
              value: function(e, t) {
                var n = void 0,
                  a = (n = Array.isArray(e)
                    ? e[e.length - 1]
                    : e).nextPageQueryAndPath(),
                  d = h(a, 2),
                  i = d[0],
                  r = d[1],
                  o = void 0;
                return (
                  (n.variableValues || t) &&
                    (o = Object.assign({}, n.variableValues, t)),
                  this.send(i, o).then(function(e) {
                    return (
                      (e.model = r.reduce(function(e, t) {
                        return e[t];
                      }, e.model)),
                      e
                    );
                  })
                );
              }
            },
            {
              key: "fetchAllPages",
              value: function(e, t) {
                var n = this,
                  a = t.pageSize;
                return (function(e) {
                  return e && e.length && e[e.length - 1].hasNextPage;
                })(e)
                  ? this.fetchNextPage(e, { first: a }).then(function(t) {
                      var d = t.model,
                        i = e.concat(d);
                      return n.fetchAllPages(i, { pageSize: a });
                    })
                  : Promise.resolve(e);
              }
            },
            {
              key: "refetch",
              value: function(e) {
                if (!e)
                  throw new Error(
                    "'client#refetch' must be called with a non-null instance of a Node."
                  );
                if (!e.type.implementsNode)
                  throw new Error(
                    "'client#refetch' must be called with a type that implements Node. Received " +
                      e.type.name +
                      "."
                  );
                return this.send(e.refetchQuery()).then(function(e) {
                  return e.model.node;
                });
              }
            },
            {
              key: "variable",
              value: function(e, t, n) {
                return C(e, t, n);
              }
            },
            {
              key: "enum",
              value: function(e) {
                return (function(e) {
                  return new F(e);
                })(e);
              }
            }
          ]),
          e
        );
      })(),
      re = (function() {
        function e(t) {
          var n = this;
          d(this, e),
            Object.keys(this.deprecatedProperties).forEach(function(e) {
              t.hasOwnProperty(e) &&
                (console.warn(
                  "[ShopifyBuy] Config property " +
                    e +
                    " is deprecated as of v1.0, please use " +
                    n.deprecatedProperties[e] +
                    " instead."
                ),
                (t[n.deprecatedProperties[e]] = t[e]));
            }),
            this.requiredProperties.forEach(function(e) {
              if (!t.hasOwnProperty(e))
                throw new Error("new Config() requires the option '" + e + "'");
              n[e] = t[e];
            });
        }
        return (
          i(e, [
            {
              key: "requiredProperties",
              get: function() {
                return ["storefrontAccessToken", "domain"];
              }
            },
            {
              key: "deprecatedProperties",
              get: function() {
                return {
                  accessToken: "storefrontAccessToken",
                  apiKey: "storefrontAccessToken"
                };
              }
            }
          ]),
          e
        );
      })(),
      oe = function e(t) {
        d(this, e), (this.graphQLClient = t);
      },
      ce = [{ message: "an unknown error has occured." }];
    function se(e) {
      var t = e.split(".");
      return function(e) {
        var n = e.model,
          a = e.errors;
        return new Promise(function(e, d) {
          try {
            e(
              t.reduce(function(e, t) {
                return e[t];
              }, n)
            );
          } catch (e) {
            d(a || ce);
          }
        });
      };
    }
    function ue(e, t) {
      var n = [].concat(e);
      return Promise.all(
        n.reduce(function(e, n) {
          return (
            e.push(
              t.fetchAllPages(n.images, { pageSize: 250 }).then(function(e) {
                n.attrs.images = e;
              })
            ),
            e.push(
              t.fetchAllPages(n.variants, { pageSize: 250 }).then(function(e) {
                n.attrs.variants = e;
              })
            ),
            e
          );
        }, [])
      );
    }
    function le(e) {
      return function(t) {
        return ue(t, e).then(function() {
          return t;
        });
      };
    }
    function fe(e) {
      return function(t) {
        var n = [].concat(t);
        return Promise.all(
          n.reduce(function(t, n) {
            return t.concat(ue(n.products, e));
          }, [])
        ).then(function() {
          return t;
        });
      };
    }
    var pe = {
      variantForOptions: function(e, t) {
        return e.variants.find(function(e) {
          return e.selectedOptions.every(function(e) {
            return t[e.name] === e.value.valueOf();
          });
        });
      }
    };
    function me(e) {
      var t = e.document(),
        n = {},
        a = { __defaultOperation__: {} };
      return (
        (a.__defaultOperation__.id = e.variable("id", "ID!")),
        (n.VariantFragment = t.defineFragment(
          "VariantFragment",
          "ProductVariant",
          function(e) {
            e.add("id"),
              e.add("title"),
              e.add("price"),
              e.add("weight"),
              e.add("availableForSale", { alias: "available" }),
              e.add("sku"),
              e.add("compareAtPrice"),
              e.add("image", function(e) {
                e.add("id"),
                  e.add("originalSrc", { alias: "src" }),
                  e.add("altText");
              }),
              e.add("selectedOptions", function(e) {
                e.add("name"), e.add("value");
              });
          }
        )),
        (n.ProductFragment = t.defineFragment(
          "ProductFragment",
          "Product",
          function(e) {
            e.add("id"),
              e.add("availableForSale"),
              e.add("createdAt"),
              e.add("updatedAt"),
              e.add("descriptionHtml"),
              e.add("description"),
              e.add("handle"),
              e.add("productType"),
              e.add("title"),
              e.add("vendor"),
              e.add("publishedAt"),
              e.add("onlineStoreUrl"),
              e.add("options", function(e) {
                e.add("name"), e.add("values");
              }),
              e.add("images", { args: { first: 250 } }, function(e) {
                e.add("pageInfo", function(e) {
                  e.add("hasNextPage"), e.add("hasPreviousPage");
                }),
                  e.add("edges", function(e) {
                    e.add("cursor"),
                      e.add("node", function(e) {
                        e.add("id"), e.add("src"), e.add("altText");
                      });
                  });
              }),
              e.add("variants", { args: { first: 250 } }, function(e) {
                e.add("pageInfo", function(e) {
                  e.add("hasNextPage"), e.add("hasPreviousPage");
                }),
                  e.add("edges", function(e) {
                    e.add("cursor"),
                      e.add("node", function(e) {
                        e.addFragment(n.VariantFragment);
                      });
                  });
              });
          }
        )),
        t.addQuery([a.__defaultOperation__.id], function(e) {
          e.add("node", { args: { id: a.__defaultOperation__.id } }, function(
            e
          ) {
            e.addFragment(n.ProductFragment);
          });
        }),
        t
      );
    }
    function ge(e) {
      var t = e.document(),
        n = {},
        a = { __defaultOperation__: {} };
      return (
        (a.__defaultOperation__.ids = e.variable("ids", "[ID!]!")),
        (n.VariantFragment = t.defineFragment(
          "VariantFragment",
          "ProductVariant",
          function(e) {
            e.add("id"),
              e.add("title"),
              e.add("price"),
              e.add("weight"),
              e.add("availableForSale", { alias: "available" }),
              e.add("sku"),
              e.add("compareAtPrice"),
              e.add("image", function(e) {
                e.add("id"),
                  e.add("originalSrc", { alias: "src" }),
                  e.add("altText");
              }),
              e.add("selectedOptions", function(e) {
                e.add("name"), e.add("value");
              });
          }
        )),
        (n.ProductFragment = t.defineFragment(
          "ProductFragment",
          "Product",
          function(e) {
            e.add("id"),
              e.add("availableForSale"),
              e.add("createdAt"),
              e.add("updatedAt"),
              e.add("descriptionHtml"),
              e.add("description"),
              e.add("handle"),
              e.add("productType"),
              e.add("title"),
              e.add("vendor"),
              e.add("publishedAt"),
              e.add("onlineStoreUrl"),
              e.add("options", function(e) {
                e.add("name"), e.add("values");
              }),
              e.add("images", { args: { first: 250 } }, function(e) {
                e.add("pageInfo", function(e) {
                  e.add("hasNextPage"), e.add("hasPreviousPage");
                }),
                  e.add("edges", function(e) {
                    e.add("cursor"),
                      e.add("node", function(e) {
                        e.add("id"), e.add("src"), e.add("altText");
                      });
                  });
              }),
              e.add("variants", { args: { first: 250 } }, function(e) {
                e.add("pageInfo", function(e) {
                  e.add("hasNextPage"), e.add("hasPreviousPage");
                }),
                  e.add("edges", function(e) {
                    e.add("cursor"),
                      e.add("node", function(e) {
                        e.addFragment(n.VariantFragment);
                      });
                  });
              });
          }
        )),
        t.addQuery([a.__defaultOperation__.ids], function(e) {
          e.add(
            "nodes",
            { args: { ids: a.__defaultOperation__.ids } },
            function(e) {
              e.addFragment(n.ProductFragment);
            }
          );
        }),
        t
      );
    }
    function he(e) {
      var t = e.document(),
        n = {},
        a = { __defaultOperation__: {} };
      return (
        (a.__defaultOperation__.first = e.variable("first", "Int!")),
        (a.__defaultOperation__.query = e.variable("query", "String")),
        (a.__defaultOperation__.sortKey = e.variable(
          "sortKey",
          "ProductSortKeys"
        )),
        (a.__defaultOperation__.reverse = e.variable("reverse", "Boolean")),
        (n.VariantFragment = t.defineFragment(
          "VariantFragment",
          "ProductVariant",
          function(e) {
            e.add("id"),
              e.add("title"),
              e.add("price"),
              e.add("weight"),
              e.add("availableForSale", { alias: "available" }),
              e.add("sku"),
              e.add("compareAtPrice"),
              e.add("image", function(e) {
                e.add("id"),
                  e.add("originalSrc", { alias: "src" }),
                  e.add("altText");
              }),
              e.add("selectedOptions", function(e) {
                e.add("name"), e.add("value");
              });
          }
        )),
        (n.ProductFragment = t.defineFragment(
          "ProductFragment",
          "Product",
          function(e) {
            e.add("id"),
              e.add("availableForSale"),
              e.add("createdAt"),
              e.add("updatedAt"),
              e.add("descriptionHtml"),
              e.add("description"),
              e.add("handle"),
              e.add("productType"),
              e.add("title"),
              e.add("vendor"),
              e.add("publishedAt"),
              e.add("onlineStoreUrl"),
              e.add("options", function(e) {
                e.add("name"), e.add("values");
              }),
              e.add("images", { args: { first: 250 } }, function(e) {
                e.add("pageInfo", function(e) {
                  e.add("hasNextPage"), e.add("hasPreviousPage");
                }),
                  e.add("edges", function(e) {
                    e.add("cursor"),
                      e.add("node", function(e) {
                        e.add("id"), e.add("src"), e.add("altText");
                      });
                  });
              }),
              e.add("variants", { args: { first: 250 } }, function(e) {
                e.add("pageInfo", function(e) {
                  e.add("hasNextPage"), e.add("hasPreviousPage");
                }),
                  e.add("edges", function(e) {
                    e.add("cursor"),
                      e.add("node", function(e) {
                        e.addFragment(n.VariantFragment);
                      });
                  });
              });
          }
        )),
        t.addQuery(
          [
            a.__defaultOperation__.first,
            a.__defaultOperation__.query,
            a.__defaultOperation__.sortKey,
            a.__defaultOperation__.reverse
          ],
          function(e) {
            e.add(
              "products",
              {
                args: {
                  first: a.__defaultOperation__.first,
                  query: a.__defaultOperation__.query,
                  sortKey: a.__defaultOperation__.sortKey,
                  reverse: a.__defaultOperation__.reverse
                }
              },
              function(e) {
                e.add("pageInfo", function(e) {
                  e.add("hasNextPage"), e.add("hasPreviousPage");
                }),
                  e.add("edges", function(e) {
                    e.add("cursor"),
                      e.add("node", function(e) {
                        e.addFragment(n.ProductFragment);
                      });
                  });
              }
            );
          }
        ),
        t
      );
    }
    function ye(e) {
      var t = e.document(),
        n = {},
        a = { __defaultOperation__: {} };
      return (
        (a.__defaultOperation__.handle = e.variable("handle", "String!")),
        (n.VariantFragment = t.defineFragment(
          "VariantFragment",
          "ProductVariant",
          function(e) {
            e.add("id"),
              e.add("title"),
              e.add("price"),
              e.add("weight"),
              e.add("availableForSale", { alias: "available" }),
              e.add("sku"),
              e.add("compareAtPrice"),
              e.add("image", function(e) {
                e.add("id"),
                  e.add("originalSrc", { alias: "src" }),
                  e.add("altText");
              }),
              e.add("selectedOptions", function(e) {
                e.add("name"), e.add("value");
              });
          }
        )),
        (n.ProductFragment = t.defineFragment(
          "ProductFragment",
          "Product",
          function(e) {
            e.add("id"),
              e.add("availableForSale"),
              e.add("createdAt"),
              e.add("updatedAt"),
              e.add("descriptionHtml"),
              e.add("description"),
              e.add("handle"),
              e.add("productType"),
              e.add("title"),
              e.add("vendor"),
              e.add("publishedAt"),
              e.add("onlineStoreUrl"),
              e.add("options", function(e) {
                e.add("name"), e.add("values");
              }),
              e.add("images", { args: { first: 250 } }, function(e) {
                e.add("pageInfo", function(e) {
                  e.add("hasNextPage"), e.add("hasPreviousPage");
                }),
                  e.add("edges", function(e) {
                    e.add("cursor"),
                      e.add("node", function(e) {
                        e.add("id"), e.add("src"), e.add("altText");
                      });
                  });
              }),
              e.add("variants", { args: { first: 250 } }, function(e) {
                e.add("pageInfo", function(e) {
                  e.add("hasNextPage"), e.add("hasPreviousPage");
                }),
                  e.add("edges", function(e) {
                    e.add("cursor"),
                      e.add("node", function(e) {
                        e.addFragment(n.VariantFragment);
                      });
                  });
              });
          }
        )),
        t.addQuery([a.__defaultOperation__.handle], function(e) {
          e.add(
            "productByHandle",
            { args: { handle: a.__defaultOperation__.handle } },
            function(e) {
              e.addFragment(n.ProductFragment);
            }
          );
        }),
        t
      );
    }
    var ve = (function(e) {
      function t() {
        return (
          d(this, t),
          o(
            this,
            (t.__proto__ || Object.getPrototypeOf(t)).apply(this, arguments)
          )
        );
      }
      return (
        r(t, oe),
        i(t, [
          {
            key: "fetchAll",
            value: function() {
              var e =
                arguments.length > 0 && void 0 !== arguments[0]
                  ? arguments[0]
                  : 20;
              return this.graphQLClient
                .send(he, { first: e })
                .then(se("products"))
                .then(le(this.graphQLClient));
            }
          },
          {
            key: "fetch",
            value: function(e) {
              return this.graphQLClient
                .send(me, { id: e })
                .then(se("node"))
                .then(le(this.graphQLClient));
            }
          },
          {
            key: "fetchMultiple",
            value: function(e) {
              return this.graphQLClient
                .send(ge, { ids: e })
                .then(se("nodes"))
                .then(le(this.graphQLClient));
            }
          },
          {
            key: "fetchByHandle",
            value: function(e) {
              return this.graphQLClient
                .send(ye, { handle: e })
                .then(se("productByHandle"))
                .then(le(this.graphQLClient));
            }
          },
          {
            key: "fetchQuery",
            value: function() {
              var e =
                  arguments.length > 0 && void 0 !== arguments[0]
                    ? arguments[0]
                    : {},
                t = e.first,
                n = void 0 === t ? 20 : t,
                a = e.sortKey,
                d = void 0 === a ? "ID" : a,
                i = e.query,
                r = e.reverse;
              return this.graphQLClient
                .send(he, { first: n, sortKey: d, query: i, reverse: r })
                .then(se("products"))
                .then(le(this.graphQLClient));
            }
          },
          {
            key: "helpers",
            get: function() {
              return pe;
            }
          }
        ]),
        t
      );
    })();
    function ke(e) {
      var t = e.document(),
        n = {},
        a = { __defaultOperation__: {} };
      return (
        (a.__defaultOperation__.id = e.variable("id", "ID!")),
        (n.CollectionFragment = t.defineFragment(
          "CollectionFragment",
          "Collection",
          function(e) {
            e.add("id"),
              e.add("handle"),
              e.add("description"),
              e.add("descriptionHtml"),
              e.add("updatedAt"),
              e.add("title"),
              e.add("image", function(e) {
                e.add("id"),
                  e.add("originalSrc", { alias: "src" }),
                  e.add("altText");
              });
          }
        )),
        t.addQuery([a.__defaultOperation__.id], function(e) {
          e.add("node", { args: { id: a.__defaultOperation__.id } }, function(
            e
          ) {
            e.addFragment(n.CollectionFragment);
          });
        }),
        t
      );
    }
    function Ce(e) {
      var t = e.document(),
        n = {},
        a = { __defaultOperation__: {} };
      return (
        (a.__defaultOperation__.id = e.variable("id", "ID!")),
        (n.VariantFragment = t.defineFragment(
          "VariantFragment",
          "ProductVariant",
          function(e) {
            e.add("id"),
              e.add("title"),
              e.add("price"),
              e.add("weight"),
              e.add("availableForSale", { alias: "available" }),
              e.add("sku"),
              e.add("compareAtPrice"),
              e.add("image", function(e) {
                e.add("id"),
                  e.add("originalSrc", { alias: "src" }),
                  e.add("altText");
              }),
              e.add("selectedOptions", function(e) {
                e.add("name"), e.add("value");
              });
          }
        )),
        (n.ProductFragment = t.defineFragment(
          "ProductFragment",
          "Product",
          function(e) {
            e.add("id"),
              e.add("availableForSale"),
              e.add("createdAt"),
              e.add("updatedAt"),
              e.add("descriptionHtml"),
              e.add("description"),
              e.add("handle"),
              e.add("productType"),
              e.add("title"),
              e.add("vendor"),
              e.add("publishedAt"),
              e.add("onlineStoreUrl"),
              e.add("options", function(e) {
                e.add("name"), e.add("values");
              }),
              e.add("images", { args: { first: 250 } }, function(e) {
                e.add("pageInfo", function(e) {
                  e.add("hasNextPage"), e.add("hasPreviousPage");
                }),
                  e.add("edges", function(e) {
                    e.add("cursor"),
                      e.add("node", function(e) {
                        e.add("id"), e.add("src"), e.add("altText");
                      });
                  });
              }),
              e.add("variants", { args: { first: 250 } }, function(e) {
                e.add("pageInfo", function(e) {
                  e.add("hasNextPage"), e.add("hasPreviousPage");
                }),
                  e.add("edges", function(e) {
                    e.add("cursor"),
                      e.add("node", function(e) {
                        e.addFragment(n.VariantFragment);
                      });
                  });
              });
          }
        )),
        (n.CollectionFragment = t.defineFragment(
          "CollectionFragment",
          "Collection",
          function(e) {
            e.add("id"),
              e.add("handle"),
              e.add("description"),
              e.add("descriptionHtml"),
              e.add("updatedAt"),
              e.add("title"),
              e.add("image", function(e) {
                e.add("id"),
                  e.add("originalSrc", { alias: "src" }),
                  e.add("altText");
              });
          }
        )),
        (n.CollectionsProductsFragment = t.defineFragment(
          "CollectionsProductsFragment",
          "Collection",
          function(e) {
            e.add("products", { args: { first: 20 } }, function(e) {
              e.add("pageInfo", function(e) {
                e.add("hasNextPage"), e.add("hasPreviousPage");
              }),
                e.add("edges", function(e) {
                  e.add("cursor"),
                    e.add("node", function(e) {
                      e.addFragment(n.ProductFragment);
                    });
                });
            });
          }
        )),
        t.addQuery([a.__defaultOperation__.id], function(e) {
          e.add("node", { args: { id: a.__defaultOperation__.id } }, function(
            e
          ) {
            e.addFragment(n.CollectionFragment),
              e.addFragment(n.CollectionsProductsFragment);
          });
        }),
        t
      );
    }
    function Fe(e) {
      var t = e.document(),
        n = {},
        a = { __defaultOperation__: {} };
      return (
        (a.__defaultOperation__.first = e.variable("first", "Int!")),
        (a.__defaultOperation__.query = e.variable("query", "String")),
        (a.__defaultOperation__.sortKey = e.variable(
          "sortKey",
          "CollectionSortKeys"
        )),
        (a.__defaultOperation__.reverse = e.variable("reverse", "Boolean")),
        (n.CollectionFragment = t.defineFragment(
          "CollectionFragment",
          "Collection",
          function(e) {
            e.add("id"),
              e.add("handle"),
              e.add("description"),
              e.add("descriptionHtml"),
              e.add("updatedAt"),
              e.add("title"),
              e.add("image", function(e) {
                e.add("id"),
                  e.add("originalSrc", { alias: "src" }),
                  e.add("altText");
              });
          }
        )),
        t.addQuery(
          [
            a.__defaultOperation__.first,
            a.__defaultOperation__.query,
            a.__defaultOperation__.sortKey,
            a.__defaultOperation__.reverse
          ],
          function(e) {
            e.add(
              "collections",
              {
                args: {
                  first: a.__defaultOperation__.first,
                  query: a.__defaultOperation__.query,
                  sortKey: a.__defaultOperation__.sortKey,
                  reverse: a.__defaultOperation__.reverse
                }
              },
              function(e) {
                e.add("pageInfo", function(e) {
                  e.add("hasNextPage"), e.add("hasPreviousPage");
                }),
                  e.add("edges", function(e) {
                    e.add("cursor"),
                      e.add("node", function(e) {
                        e.addFragment(n.CollectionFragment);
                      });
                  });
              }
            );
          }
        ),
        t
      );
    }
    function be(e) {
      var t = e.document(),
        n = {},
        a = { __defaultOperation__: {} };
      return (
        (a.__defaultOperation__.first = e.variable("first", "Int!")),
        (a.__defaultOperation__.query = e.variable("query", "String")),
        (a.__defaultOperation__.sortKey = e.variable(
          "sortKey",
          "CollectionSortKeys"
        )),
        (a.__defaultOperation__.reverse = e.variable("reverse", "Boolean")),
        (a.__defaultOperation__.productsFirst = e.variable(
          "productsFirst",
          "Int!"
        )),
        (n.VariantFragment = t.defineFragment(
          "VariantFragment",
          "ProductVariant",
          function(e) {
            e.add("id"),
              e.add("title"),
              e.add("price"),
              e.add("weight"),
              e.add("availableForSale", { alias: "available" }),
              e.add("sku"),
              e.add("compareAtPrice"),
              e.add("image", function(e) {
                e.add("id"),
                  e.add("originalSrc", { alias: "src" }),
                  e.add("altText");
              }),
              e.add("selectedOptions", function(e) {
                e.add("name"), e.add("value");
              });
          }
        )),
        (n.CollectionFragment = t.defineFragment(
          "CollectionFragment",
          "Collection",
          function(e) {
            e.add("id"),
              e.add("handle"),
              e.add("description"),
              e.add("descriptionHtml"),
              e.add("updatedAt"),
              e.add("title"),
              e.add("image", function(e) {
                e.add("id"),
                  e.add("originalSrc", { alias: "src" }),
                  e.add("altText");
              });
          }
        )),
        (n.ProductFragment = t.defineFragment(
          "ProductFragment",
          "Product",
          function(e) {
            e.add("id"),
              e.add("availableForSale"),
              e.add("createdAt"),
              e.add("updatedAt"),
              e.add("descriptionHtml"),
              e.add("description"),
              e.add("handle"),
              e.add("productType"),
              e.add("title"),
              e.add("vendor"),
              e.add("publishedAt"),
              e.add("onlineStoreUrl"),
              e.add("options", function(e) {
                e.add("name"), e.add("values");
              }),
              e.add("images", { args: { first: 250 } }, function(e) {
                e.add("pageInfo", function(e) {
                  e.add("hasNextPage"), e.add("hasPreviousPage");
                }),
                  e.add("edges", function(e) {
                    e.add("cursor"),
                      e.add("node", function(e) {
                        e.add("id"), e.add("src"), e.add("altText");
                      });
                  });
              }),
              e.add("variants", { args: { first: 250 } }, function(e) {
                e.add("pageInfo", function(e) {
                  e.add("hasNextPage"), e.add("hasPreviousPage");
                }),
                  e.add("edges", function(e) {
                    e.add("cursor"),
                      e.add("node", function(e) {
                        e.addFragment(n.VariantFragment);
                      });
                  });
              });
          }
        )),
        t.addQuery(
          [
            a.__defaultOperation__.first,
            a.__defaultOperation__.query,
            a.__defaultOperation__.sortKey,
            a.__defaultOperation__.reverse,
            a.__defaultOperation__.productsFirst
          ],
          function(e) {
            e.add(
              "collections",
              {
                args: {
                  first: a.__defaultOperation__.first,
                  query: a.__defaultOperation__.query,
                  sortKey: a.__defaultOperation__.sortKey,
                  reverse: a.__defaultOperation__.reverse
                }
              },
              function(e) {
                e.add("pageInfo", function(e) {
                  e.add("hasNextPage"), e.add("hasPreviousPage");
                }),
                  e.add("edges", function(e) {
                    e.add("cursor"),
                      e.add("node", function(e) {
                        e.addFragment(n.CollectionFragment),
                          e.add(
                            "products",
                            {
                              args: {
                                first: a.__defaultOperation__.productsFirst
                              }
                            },
                            function(e) {
                              e.add("pageInfo", function(e) {
                                e.add("hasNextPage"), e.add("hasPreviousPage");
                              }),
                                e.add("edges", function(e) {
                                  e.add("cursor"),
                                    e.add("node", function(e) {
                                      e.addFragment(n.ProductFragment);
                                    });
                                });
                            }
                          );
                      });
                  });
              }
            );
          }
        ),
        t
      );
    }
    function Ae(e) {
      var t = e.document(),
        n = {},
        a = { __defaultOperation__: {} };
      return (
        (a.__defaultOperation__.handle = e.variable("handle", "String!")),
        (n.VariantFragment = t.defineFragment(
          "VariantFragment",
          "ProductVariant",
          function(e) {
            e.add("id"),
              e.add("title"),
              e.add("price"),
              e.add("weight"),
              e.add("availableForSale", { alias: "available" }),
              e.add("sku"),
              e.add("compareAtPrice"),
              e.add("image", function(e) {
                e.add("id"),
                  e.add("originalSrc", { alias: "src" }),
                  e.add("altText");
              }),
              e.add("selectedOptions", function(e) {
                e.add("name"), e.add("value");
              });
          }
        )),
        (n.ProductFragment = t.defineFragment(
          "ProductFragment",
          "Product",
          function(e) {
            e.add("id"),
              e.add("availableForSale"),
              e.add("createdAt"),
              e.add("updatedAt"),
              e.add("descriptionHtml"),
              e.add("description"),
              e.add("handle"),
              e.add("productType"),
              e.add("title"),
              e.add("vendor"),
              e.add("publishedAt"),
              e.add("onlineStoreUrl"),
              e.add("options", function(e) {
                e.add("name"), e.add("values");
              }),
              e.add("images", { args: { first: 250 } }, function(e) {
                e.add("pageInfo", function(e) {
                  e.add("hasNextPage"), e.add("hasPreviousPage");
                }),
                  e.add("edges", function(e) {
                    e.add("cursor"),
                      e.add("node", function(e) {
                        e.add("id"), e.add("src"), e.add("altText");
                      });
                  });
              }),
              e.add("variants", { args: { first: 250 } }, function(e) {
                e.add("pageInfo", function(e) {
                  e.add("hasNextPage"), e.add("hasPreviousPage");
                }),
                  e.add("edges", function(e) {
                    e.add("cursor"),
                      e.add("node", function(e) {
                        e.addFragment(n.VariantFragment);
                      });
                  });
              });
          }
        )),
        (n.CollectionFragment = t.defineFragment(
          "CollectionFragment",
          "Collection",
          function(e) {
            e.add("id"),
              e.add("handle"),
              e.add("description"),
              e.add("descriptionHtml"),
              e.add("updatedAt"),
              e.add("title"),
              e.add("image", function(e) {
                e.add("id"),
                  e.add("originalSrc", { alias: "src" }),
                  e.add("altText");
              });
          }
        )),
        (n.CollectionsProductsFragment = t.defineFragment(
          "CollectionsProductsFragment",
          "Collection",
          function(e) {
            e.add("products", { args: { first: 20 } }, function(e) {
              e.add("pageInfo", function(e) {
                e.add("hasNextPage"), e.add("hasPreviousPage");
              }),
                e.add("edges", function(e) {
                  e.add("cursor"),
                    e.add("node", function(e) {
                      e.addFragment(n.ProductFragment);
                    });
                });
            });
          }
        )),
        t.addQuery([a.__defaultOperation__.handle], function(e) {
          e.add(
            "collectionByHandle",
            { args: { handle: a.__defaultOperation__.handle } },
            function(e) {
              e.addFragment(n.CollectionFragment),
                e.addFragment(n.CollectionsProductsFragment);
            }
          );
        }),
        t
      );
    }
    var Pe = (function(e) {
      function t() {
        return (
          d(this, t),
          o(
            this,
            (t.__proto__ || Object.getPrototypeOf(t)).apply(this, arguments)
          )
        );
      }
      return (
        r(t, oe),
        i(t, [
          {
            key: "fetchAll",
            value: function() {
              var e =
                arguments.length > 0 && void 0 !== arguments[0]
                  ? arguments[0]
                  : 20;
              return this.graphQLClient
                .send(Fe, { first: e })
                .then(se("collections"));
            }
          },
          {
            key: "fetchAllWithProducts",
            value: function() {
              var e =
                  arguments.length > 0 && void 0 !== arguments[0]
                    ? arguments[0]
                    : {},
                t = e.first,
                n = void 0 === t ? 20 : t,
                a = e.productsFirst,
                d = void 0 === a ? 20 : a;
              return this.graphQLClient
                .send(be, { first: n, productsFirst: d })
                .then(se("collections"))
                .then(fe(this.graphQLClient));
            }
          },
          {
            key: "fetch",
            value: function(e) {
              return this.graphQLClient.send(ke, { id: e }).then(se("node"));
            }
          },
          {
            key: "fetchWithProducts",
            value: function(e) {
              return this.graphQLClient
                .send(Ce, { id: e })
                .then(se("node"))
                .then(fe(this.graphQLClient));
            }
          },
          {
            key: "fetchByHandle",
            value: function(e) {
              return this.graphQLClient
                .send(Ae, { handle: e })
                .then(se("collectionByHandle"));
            }
          },
          {
            key: "fetchQuery",
            value: function() {
              var e =
                  arguments.length > 0 && void 0 !== arguments[0]
                    ? arguments[0]
                    : {},
                t = e.first,
                n = void 0 === t ? 20 : t,
                a = e.sortKey,
                d = void 0 === a ? "ID" : a,
                i = e.query,
                r = e.reverse;
              return this.graphQLClient
                .send(Fe, { first: n, sortKey: d, query: i, reverse: r })
                .then(se("collections"));
            }
          }
        ]),
        t
      );
    })();
    function Se(e) {
      var t = e.document();
      return (
        t.addQuery(function(e) {
          e.add("shop", function(e) {
            e.add("currencyCode"),
              e.add("description"),
              e.add("moneyFormat"),
              e.add("name"),
              e.add("primaryDomain", function(e) {
                e.add("host"), e.add("sslEnabled"), e.add("url");
              });
          });
        }),
        t
      );
    }
    function _e(e) {
      var t = e.document(),
        n = {};
      return (
        (n.PolicyFragment = t.defineFragment(
          "PolicyFragment",
          "ShopPolicy",
          function(e) {
            e.add("id"), e.add("title"), e.add("url"), e.add("body");
          }
        )),
        t.addQuery(function(e) {
          e.add("shop", function(e) {
            e.add("privacyPolicy", function(e) {
              e.addFragment(n.PolicyFragment);
            }),
              e.add("termsOfService", function(e) {
                e.addFragment(n.PolicyFragment);
              }),
              e.add("refundPolicy", function(e) {
                e.addFragment(n.PolicyFragment);
              });
          });
        }),
        t
      );
    }
    var Oe = (function(e) {
      function t() {
        return (
          d(this, t),
          o(
            this,
            (t.__proto__ || Object.getPrototypeOf(t)).apply(this, arguments)
          )
        );
      }
      return (
        r(t, oe),
        i(t, [
          {
            key: "fetchInfo",
            value: function() {
              return this.graphQLClient.send(Se).then(se("shop"));
            }
          },
          {
            key: "fetchPolicies",
            value: function() {
              return this.graphQLClient.send(_e).then(se("shop"));
            }
          }
        ]),
        t
      );
    })();
    function Ie(e, t) {
      return function(n) {
        var a = n.data,
          d = n.errors,
          i = n.model,
          r = a[e],
          o = i[e];
        return r && r.checkout
          ? t
              .fetchAllPages(o.checkout.lineItems, { pageSize: 250 })
              .then(function(e) {
                return (
                  (o.checkout.attrs.lineItems = e),
                  (o.checkout.errors = d),
                  (o.checkout.userErrors = o.userErrors),
                  o.checkout
                );
              })
          : d && d.length
          ? Promise.reject(new Error(JSON.stringify(d)))
          : r && r.checkoutUserErrors && r.checkoutUserErrors.length
          ? Promise.reject(new Error(JSON.stringify(r.checkoutUserErrors)))
          : r && r.userErrors && r.userErrors.length
          ? Promise.reject(new Error(JSON.stringify(r.userErrors)))
          : Promise.reject(
              new Error(
                "The " + e + " mutation failed due to an unknown error."
              )
            );
      };
    }
    function Ee(e) {
      var t = e.document(),
        n = {},
        a = { __defaultOperation__: {} };
      return (
        (a.__defaultOperation__.id = e.variable("id", "ID!")),
        (n.VariantFragment = t.defineFragment(
          "VariantFragment",
          "ProductVariant",
          function(e) {
            e.add("id"),
              e.add("title"),
              e.add("price"),
              e.add("weight"),
              e.add("availableForSale", { alias: "available" }),
              e.add("sku"),
              e.add("compareAtPrice"),
              e.add("image", function(e) {
                e.add("id"),
                  e.add("originalSrc", { alias: "src" }),
                  e.add("altText");
              }),
              e.add("selectedOptions", function(e) {
                e.add("name"), e.add("value");
              });
          }
        )),
        (n.DiscountApplicationFragment = t.defineFragment(
          "DiscountApplicationFragment",
          "DiscountApplication",
          function(e) {
            e.add("targetSelection"),
              e.add("allocationMethod"),
              e.add("targetType"),
              e.addInlineFragmentOn("ManualDiscountApplication", function(e) {
                e.add("title"), e.add("description");
              }),
              e.addInlineFragmentOn("DiscountCodeApplication", function(e) {
                e.add("code"), e.add("applicable");
              }),
              e.addInlineFragmentOn("ScriptDiscountApplication", function(e) {
                e.add("description");
              }),
              e.addInlineFragmentOn("AutomaticDiscountApplication", function(
                e
              ) {
                e.add("title");
              });
          }
        )),
        (n.AppliedGiftCardFragment = t.defineFragment(
          "AppliedGiftCardFragment",
          "AppliedGiftCard",
          function(e) {
            e.add("amountUsedV2", function(e) {
              e.add("amount"), e.add("currencyCode");
            }),
              e.add("balanceV2", function(e) {
                e.add("amount"), e.add("currencyCode");
              }),
              e.add("id"),
              e.add("lastCharacters");
          }
        )),
        (n.VariantWithProductFragment = t.defineFragment(
          "VariantWithProductFragment",
          "ProductVariant",
          function(e) {
            e.addFragment(n.VariantFragment),
              e.add("product", function(e) {
                e.add("id");
              });
          }
        )),
        (n.MailingAddressFragment = t.defineFragment(
          "MailingAddressFragment",
          "MailingAddress",
          function(e) {
            e.add("id"),
              e.add("address1"),
              e.add("address2"),
              e.add("city"),
              e.add("company"),
              e.add("country"),
              e.add("firstName"),
              e.add("formatted"),
              e.add("lastName"),
              e.add("latitude"),
              e.add("longitude"),
              e.add("phone"),
              e.add("province"),
              e.add("zip"),
              e.add("name"),
              e.add("countryCodeV2", { alias: "countryCode" }),
              e.add("provinceCode");
          }
        )),
        (n.CheckoutFragment = t.defineFragment(
          "CheckoutFragment",
          "Checkout",
          function(e) {
            e.add("id"),
              e.add("ready"),
              e.add("requiresShipping"),
              e.add("note"),
              e.add("paymentDue"),
              e.add("webUrl"),
              e.add("orderStatusUrl"),
              e.add("taxExempt"),
              e.add("taxesIncluded"),
              e.add("currencyCode"),
              e.add("totalTax"),
              e.add("lineItemsSubtotalPrice", function(e) {
                e.add("amount"), e.add("currencyCode");
              }),
              e.add("subtotalPrice"),
              e.add("totalPrice"),
              e.add("completedAt"),
              e.add("createdAt"),
              e.add("updatedAt"),
              e.add("email"),
              e.add("discountApplications", { args: { first: 10 } }, function(
                e
              ) {
                e.add("pageInfo", function(e) {
                  e.add("hasNextPage"), e.add("hasPreviousPage");
                }),
                  e.add("edges", function(e) {
                    e.add("node", function(e) {
                      e.addFragment(n.DiscountApplicationFragment);
                    });
                  });
              }),
              e.add("appliedGiftCards", function(e) {
                e.addFragment(n.AppliedGiftCardFragment);
              }),
              e.add("shippingAddress", function(e) {
                e.addFragment(n.MailingAddressFragment);
              }),
              e.add("shippingLine", function(e) {
                e.add("handle"), e.add("price"), e.add("title");
              }),
              e.add("customAttributes", function(e) {
                e.add("key"), e.add("value");
              }),
              e.add("order", function(e) {
                e.add("id"),
                  e.add("processedAt"),
                  e.add("orderNumber"),
                  e.add("subtotalPrice"),
                  e.add("totalShippingPrice"),
                  e.add("totalTax"),
                  e.add("totalPrice"),
                  e.add("currencyCode"),
                  e.add("totalRefunded"),
                  e.add("customerUrl"),
                  e.add("shippingAddress", function(e) {
                    e.addFragment(n.MailingAddressFragment);
                  }),
                  e.add("lineItems", { args: { first: 250 } }, function(e) {
                    e.add("pageInfo", function(e) {
                      e.add("hasNextPage"), e.add("hasPreviousPage");
                    }),
                      e.add("edges", function(e) {
                        e.add("cursor"),
                          e.add("node", function(e) {
                            e.add("title"),
                              e.add("variant", function(e) {
                                e.addFragment(n.VariantWithProductFragment);
                              }),
                              e.add("quantity"),
                              e.add("customAttributes", function(e) {
                                e.add("key"), e.add("value");
                              });
                          });
                      });
                  });
              }),
              e.add("lineItems", { args: { first: 250 } }, function(e) {
                e.add("pageInfo", function(e) {
                  e.add("hasNextPage"), e.add("hasPreviousPage");
                }),
                  e.add("edges", function(e) {
                    e.add("cursor"),
                      e.add("node", function(e) {
                        e.add("id"),
                          e.add("title"),
                          e.add("variant", function(e) {
                            e.addFragment(n.VariantWithProductFragment);
                          }),
                          e.add("quantity"),
                          e.add("customAttributes", function(e) {
                            e.add("key"), e.add("value");
                          }),
                          e.add("discountAllocations", function(e) {
                            e.add("allocatedAmount", function(e) {
                              e.add("amount"), e.add("currencyCode");
                            }),
                              e.add("discountApplication", function(e) {
                                e.addFragment(n.DiscountApplicationFragment);
                              });
                          });
                      });
                  });
              });
          }
        )),
        t.addQuery([a.__defaultOperation__.id], function(e) {
          e.add("node", { args: { id: a.__defaultOperation__.id } }, function(
            e
          ) {
            e.addFragment(n.CheckoutFragment);
          });
        }),
        t
      );
    }
    function we(e) {
      var t = e.document(),
        n = {},
        a = { __defaultOperation__: {} };
      return (
        (a.__defaultOperation__.input = e.variable(
          "input",
          "CheckoutCreateInput!"
        )),
        (n.VariantFragment = t.defineFragment(
          "VariantFragment",
          "ProductVariant",
          function(e) {
            e.add("id"),
              e.add("title"),
              e.add("price"),
              e.add("weight"),
              e.add("availableForSale", { alias: "available" }),
              e.add("sku"),
              e.add("compareAtPrice"),
              e.add("image", function(e) {
                e.add("id"),
                  e.add("originalSrc", { alias: "src" }),
                  e.add("altText");
              }),
              e.add("selectedOptions", function(e) {
                e.add("name"), e.add("value");
              });
          }
        )),
        (n.DiscountApplicationFragment = t.defineFragment(
          "DiscountApplicationFragment",
          "DiscountApplication",
          function(e) {
            e.add("targetSelection"),
              e.add("allocationMethod"),
              e.add("targetType"),
              e.addInlineFragmentOn("ManualDiscountApplication", function(e) {
                e.add("title"), e.add("description");
              }),
              e.addInlineFragmentOn("DiscountCodeApplication", function(e) {
                e.add("code"), e.add("applicable");
              }),
              e.addInlineFragmentOn("ScriptDiscountApplication", function(e) {
                e.add("description");
              }),
              e.addInlineFragmentOn("AutomaticDiscountApplication", function(
                e
              ) {
                e.add("title");
              });
          }
        )),
        (n.AppliedGiftCardFragment = t.defineFragment(
          "AppliedGiftCardFragment",
          "AppliedGiftCard",
          function(e) {
            e.add("amountUsedV2", function(e) {
              e.add("amount"), e.add("currencyCode");
            }),
              e.add("balanceV2", function(e) {
                e.add("amount"), e.add("currencyCode");
              }),
              e.add("id"),
              e.add("lastCharacters");
          }
        )),
        (n.VariantWithProductFragment = t.defineFragment(
          "VariantWithProductFragment",
          "ProductVariant",
          function(e) {
            e.addFragment(n.VariantFragment),
              e.add("product", function(e) {
                e.add("id");
              });
          }
        )),
        (n.UserErrorFragment = t.defineFragment(
          "UserErrorFragment",
          "UserError",
          function(e) {
            e.add("field"), e.add("message");
          }
        )),
        (n.CheckoutUserErrorFragment = t.defineFragment(
          "CheckoutUserErrorFragment",
          "CheckoutUserError",
          function(e) {
            e.add("field"), e.add("message"), e.add("code");
          }
        )),
        (n.MailingAddressFragment = t.defineFragment(
          "MailingAddressFragment",
          "MailingAddress",
          function(e) {
            e.add("id"),
              e.add("address1"),
              e.add("address2"),
              e.add("city"),
              e.add("company"),
              e.add("country"),
              e.add("firstName"),
              e.add("formatted"),
              e.add("lastName"),
              e.add("latitude"),
              e.add("longitude"),
              e.add("phone"),
              e.add("province"),
              e.add("zip"),
              e.add("name"),
              e.add("countryCodeV2", { alias: "countryCode" }),
              e.add("provinceCode");
          }
        )),
        (n.CheckoutFragment = t.defineFragment(
          "CheckoutFragment",
          "Checkout",
          function(e) {
            e.add("id"),
              e.add("ready"),
              e.add("requiresShipping"),
              e.add("note"),
              e.add("paymentDue"),
              e.add("webUrl"),
              e.add("orderStatusUrl"),
              e.add("taxExempt"),
              e.add("taxesIncluded"),
              e.add("currencyCode"),
              e.add("totalTax"),
              e.add("lineItemsSubtotalPrice", function(e) {
                e.add("amount"), e.add("currencyCode");
              }),
              e.add("subtotalPrice"),
              e.add("totalPrice"),
              e.add("completedAt"),
              e.add("createdAt"),
              e.add("updatedAt"),
              e.add("email"),
              e.add("discountApplications", { args: { first: 10 } }, function(
                e
              ) {
                e.add("pageInfo", function(e) {
                  e.add("hasNextPage"), e.add("hasPreviousPage");
                }),
                  e.add("edges", function(e) {
                    e.add("node", function(e) {
                      e.addFragment(n.DiscountApplicationFragment);
                    });
                  });
              }),
              e.add("appliedGiftCards", function(e) {
                e.addFragment(n.AppliedGiftCardFragment);
              }),
              e.add("shippingAddress", function(e) {
                e.addFragment(n.MailingAddressFragment);
              }),
              e.add("shippingLine", function(e) {
                e.add("handle"), e.add("price"), e.add("title");
              }),
              e.add("customAttributes", function(e) {
                e.add("key"), e.add("value");
              }),
              e.add("order", function(e) {
                e.add("id"),
                  e.add("processedAt"),
                  e.add("orderNumber"),
                  e.add("subtotalPrice"),
                  e.add("totalShippingPrice"),
                  e.add("totalTax"),
                  e.add("totalPrice"),
                  e.add("currencyCode"),
                  e.add("totalRefunded"),
                  e.add("customerUrl"),
                  e.add("shippingAddress", function(e) {
                    e.addFragment(n.MailingAddressFragment);
                  }),
                  e.add("lineItems", { args: { first: 250 } }, function(e) {
                    e.add("pageInfo", function(e) {
                      e.add("hasNextPage"), e.add("hasPreviousPage");
                    }),
                      e.add("edges", function(e) {
                        e.add("cursor"),
                          e.add("node", function(e) {
                            e.add("title"),
                              e.add("variant", function(e) {
                                e.addFragment(n.VariantWithProductFragment);
                              }),
                              e.add("quantity"),
                              e.add("customAttributes", function(e) {
                                e.add("key"), e.add("value");
                              });
                          });
                      });
                  });
              }),
              e.add("lineItems", { args: { first: 250 } }, function(e) {
                e.add("pageInfo", function(e) {
                  e.add("hasNextPage"), e.add("hasPreviousPage");
                }),
                  e.add("edges", function(e) {
                    e.add("cursor"),
                      e.add("node", function(e) {
                        e.add("id"),
                          e.add("title"),
                          e.add("variant", function(e) {
                            e.addFragment(n.VariantWithProductFragment);
                          }),
                          e.add("quantity"),
                          e.add("customAttributes", function(e) {
                            e.add("key"), e.add("value");
                          }),
                          e.add("discountAllocations", function(e) {
                            e.add("allocatedAmount", function(e) {
                              e.add("amount"), e.add("currencyCode");
                            }),
                              e.add("discountApplication", function(e) {
                                e.addFragment(n.DiscountApplicationFragment);
                              });
                          });
                      });
                  });
              });
          }
        )),
        t.addMutation([a.__defaultOperation__.input], function(e) {
          e.add(
            "checkoutCreate",
            { args: { input: a.__defaultOperation__.input } },
            function(e) {
              e.add("userErrors", function(e) {
                e.addFragment(n.UserErrorFragment);
              }),
                e.add("checkoutUserErrors", function(e) {
                  e.addFragment(n.CheckoutUserErrorFragment);
                }),
                e.add("checkout", function(e) {
                  e.addFragment(n.CheckoutFragment);
                });
            }
          );
        }),
        t
      );
    }
    function xe(e) {
      var t = e.document(),
        n = {},
        a = { __defaultOperation__: {} };
      return (
        (a.__defaultOperation__.checkoutId = e.variable("checkoutId", "ID!")),
        (a.__defaultOperation__.lineItems = e.variable(
          "lineItems",
          "[CheckoutLineItemInput!]!"
        )),
        (n.VariantFragment = t.defineFragment(
          "VariantFragment",
          "ProductVariant",
          function(e) {
            e.add("id"),
              e.add("title"),
              e.add("price"),
              e.add("weight"),
              e.add("availableForSale", { alias: "available" }),
              e.add("sku"),
              e.add("compareAtPrice"),
              e.add("image", function(e) {
                e.add("id"),
                  e.add("originalSrc", { alias: "src" }),
                  e.add("altText");
              }),
              e.add("selectedOptions", function(e) {
                e.add("name"), e.add("value");
              });
          }
        )),
        (n.DiscountApplicationFragment = t.defineFragment(
          "DiscountApplicationFragment",
          "DiscountApplication",
          function(e) {
            e.add("targetSelection"),
              e.add("allocationMethod"),
              e.add("targetType"),
              e.addInlineFragmentOn("ManualDiscountApplication", function(e) {
                e.add("title"), e.add("description");
              }),
              e.addInlineFragmentOn("DiscountCodeApplication", function(e) {
                e.add("code"), e.add("applicable");
              }),
              e.addInlineFragmentOn("ScriptDiscountApplication", function(e) {
                e.add("description");
              }),
              e.addInlineFragmentOn("AutomaticDiscountApplication", function(
                e
              ) {
                e.add("title");
              });
          }
        )),
        (n.AppliedGiftCardFragment = t.defineFragment(
          "AppliedGiftCardFragment",
          "AppliedGiftCard",
          function(e) {
            e.add("amountUsedV2", function(e) {
              e.add("amount"), e.add("currencyCode");
            }),
              e.add("balanceV2", function(e) {
                e.add("amount"), e.add("currencyCode");
              }),
              e.add("id"),
              e.add("lastCharacters");
          }
        )),
        (n.VariantWithProductFragment = t.defineFragment(
          "VariantWithProductFragment",
          "ProductVariant",
          function(e) {
            e.addFragment(n.VariantFragment),
              e.add("product", function(e) {
                e.add("id");
              });
          }
        )),
        (n.UserErrorFragment = t.defineFragment(
          "UserErrorFragment",
          "UserError",
          function(e) {
            e.add("field"), e.add("message");
          }
        )),
        (n.CheckoutUserErrorFragment = t.defineFragment(
          "CheckoutUserErrorFragment",
          "CheckoutUserError",
          function(e) {
            e.add("field"), e.add("message"), e.add("code");
          }
        )),
        (n.MailingAddressFragment = t.defineFragment(
          "MailingAddressFragment",
          "MailingAddress",
          function(e) {
            e.add("id"),
              e.add("address1"),
              e.add("address2"),
              e.add("city"),
              e.add("company"),
              e.add("country"),
              e.add("firstName"),
              e.add("formatted"),
              e.add("lastName"),
              e.add("latitude"),
              e.add("longitude"),
              e.add("phone"),
              e.add("province"),
              e.add("zip"),
              e.add("name"),
              e.add("countryCodeV2", { alias: "countryCode" }),
              e.add("provinceCode");
          }
        )),
        (n.CheckoutFragment = t.defineFragment(
          "CheckoutFragment",
          "Checkout",
          function(e) {
            e.add("id"),
              e.add("ready"),
              e.add("requiresShipping"),
              e.add("note"),
              e.add("paymentDue"),
              e.add("webUrl"),
              e.add("orderStatusUrl"),
              e.add("taxExempt"),
              e.add("taxesIncluded"),
              e.add("currencyCode"),
              e.add("totalTax"),
              e.add("lineItemsSubtotalPrice", function(e) {
                e.add("amount"), e.add("currencyCode");
              }),
              e.add("subtotalPrice"),
              e.add("totalPrice"),
              e.add("completedAt"),
              e.add("createdAt"),
              e.add("updatedAt"),
              e.add("email"),
              e.add("discountApplications", { args: { first: 10 } }, function(
                e
              ) {
                e.add("pageInfo", function(e) {
                  e.add("hasNextPage"), e.add("hasPreviousPage");
                }),
                  e.add("edges", function(e) {
                    e.add("node", function(e) {
                      e.addFragment(n.DiscountApplicationFragment);
                    });
                  });
              }),
              e.add("appliedGiftCards", function(e) {
                e.addFragment(n.AppliedGiftCardFragment);
              }),
              e.add("shippingAddress", function(e) {
                e.addFragment(n.MailingAddressFragment);
              }),
              e.add("shippingLine", function(e) {
                e.add("handle"), e.add("price"), e.add("title");
              }),
              e.add("customAttributes", function(e) {
                e.add("key"), e.add("value");
              }),
              e.add("order", function(e) {
                e.add("id"),
                  e.add("processedAt"),
                  e.add("orderNumber"),
                  e.add("subtotalPrice"),
                  e.add("totalShippingPrice"),
                  e.add("totalTax"),
                  e.add("totalPrice"),
                  e.add("currencyCode"),
                  e.add("totalRefunded"),
                  e.add("customerUrl"),
                  e.add("shippingAddress", function(e) {
                    e.addFragment(n.MailingAddressFragment);
                  }),
                  e.add("lineItems", { args: { first: 250 } }, function(e) {
                    e.add("pageInfo", function(e) {
                      e.add("hasNextPage"), e.add("hasPreviousPage");
                    }),
                      e.add("edges", function(e) {
                        e.add("cursor"),
                          e.add("node", function(e) {
                            e.add("title"),
                              e.add("variant", function(e) {
                                e.addFragment(n.VariantWithProductFragment);
                              }),
                              e.add("quantity"),
                              e.add("customAttributes", function(e) {
                                e.add("key"), e.add("value");
                              });
                          });
                      });
                  });
              }),
              e.add("lineItems", { args: { first: 250 } }, function(e) {
                e.add("pageInfo", function(e) {
                  e.add("hasNextPage"), e.add("hasPreviousPage");
                }),
                  e.add("edges", function(e) {
                    e.add("cursor"),
                      e.add("node", function(e) {
                        e.add("id"),
                          e.add("title"),
                          e.add("variant", function(e) {
                            e.addFragment(n.VariantWithProductFragment);
                          }),
                          e.add("quantity"),
                          e.add("customAttributes", function(e) {
                            e.add("key"), e.add("value");
                          }),
                          e.add("discountAllocations", function(e) {
                            e.add("allocatedAmount", function(e) {
                              e.add("amount"), e.add("currencyCode");
                            }),
                              e.add("discountApplication", function(e) {
                                e.addFragment(n.DiscountApplicationFragment);
                              });
                          });
                      });
                  });
              });
          }
        )),
        t.addMutation(
          [a.__defaultOperation__.checkoutId, a.__defaultOperation__.lineItems],
          function(e) {
            e.add(
              "checkoutLineItemsAdd",
              {
                args: {
                  checkoutId: a.__defaultOperation__.checkoutId,
                  lineItems: a.__defaultOperation__.lineItems
                }
              },
              function(e) {
                e.add("userErrors", function(e) {
                  e.addFragment(n.UserErrorFragment);
                }),
                  e.add("checkoutUserErrors", function(e) {
                    e.addFragment(n.CheckoutUserErrorFragment);
                  }),
                  e.add("checkout", function(e) {
                    e.addFragment(n.CheckoutFragment);
                  });
              }
            );
          }
        ),
        t
      );
    }
    function Te(e) {
      var t = e.document(),
        n = {},
        a = { __defaultOperation__: {} };
      return (
        (a.__defaultOperation__.checkoutId = e.variable("checkoutId", "ID!")),
        (a.__defaultOperation__.lineItemIds = e.variable(
          "lineItemIds",
          "[ID!]!"
        )),
        (n.VariantFragment = t.defineFragment(
          "VariantFragment",
          "ProductVariant",
          function(e) {
            e.add("id"),
              e.add("title"),
              e.add("price"),
              e.add("weight"),
              e.add("availableForSale", { alias: "available" }),
              e.add("sku"),
              e.add("compareAtPrice"),
              e.add("image", function(e) {
                e.add("id"),
                  e.add("originalSrc", { alias: "src" }),
                  e.add("altText");
              }),
              e.add("selectedOptions", function(e) {
                e.add("name"), e.add("value");
              });
          }
        )),
        (n.DiscountApplicationFragment = t.defineFragment(
          "DiscountApplicationFragment",
          "DiscountApplication",
          function(e) {
            e.add("targetSelection"),
              e.add("allocationMethod"),
              e.add("targetType"),
              e.addInlineFragmentOn("ManualDiscountApplication", function(e) {
                e.add("title"), e.add("description");
              }),
              e.addInlineFragmentOn("DiscountCodeApplication", function(e) {
                e.add("code"), e.add("applicable");
              }),
              e.addInlineFragmentOn("ScriptDiscountApplication", function(e) {
                e.add("description");
              }),
              e.addInlineFragmentOn("AutomaticDiscountApplication", function(
                e
              ) {
                e.add("title");
              });
          }
        )),
        (n.AppliedGiftCardFragment = t.defineFragment(
          "AppliedGiftCardFragment",
          "AppliedGiftCard",
          function(e) {
            e.add("amountUsedV2", function(e) {
              e.add("amount"), e.add("currencyCode");
            }),
              e.add("balanceV2", function(e) {
                e.add("amount"), e.add("currencyCode");
              }),
              e.add("id"),
              e.add("lastCharacters");
          }
        )),
        (n.VariantWithProductFragment = t.defineFragment(
          "VariantWithProductFragment",
          "ProductVariant",
          function(e) {
            e.addFragment(n.VariantFragment),
              e.add("product", function(e) {
                e.add("id");
              });
          }
        )),
        (n.UserErrorFragment = t.defineFragment(
          "UserErrorFragment",
          "UserError",
          function(e) {
            e.add("field"), e.add("message");
          }
        )),
        (n.CheckoutUserErrorFragment = t.defineFragment(
          "CheckoutUserErrorFragment",
          "CheckoutUserError",
          function(e) {
            e.add("field"), e.add("message"), e.add("code");
          }
        )),
        (n.MailingAddressFragment = t.defineFragment(
          "MailingAddressFragment",
          "MailingAddress",
          function(e) {
            e.add("id"),
              e.add("address1"),
              e.add("address2"),
              e.add("city"),
              e.add("company"),
              e.add("country"),
              e.add("firstName"),
              e.add("formatted"),
              e.add("lastName"),
              e.add("latitude"),
              e.add("longitude"),
              e.add("phone"),
              e.add("province"),
              e.add("zip"),
              e.add("name"),
              e.add("countryCodeV2", { alias: "countryCode" }),
              e.add("provinceCode");
          }
        )),
        (n.CheckoutFragment = t.defineFragment(
          "CheckoutFragment",
          "Checkout",
          function(e) {
            e.add("id"),
              e.add("ready"),
              e.add("requiresShipping"),
              e.add("note"),
              e.add("paymentDue"),
              e.add("webUrl"),
              e.add("orderStatusUrl"),
              e.add("taxExempt"),
              e.add("taxesIncluded"),
              e.add("currencyCode"),
              e.add("totalTax"),
              e.add("lineItemsSubtotalPrice", function(e) {
                e.add("amount"), e.add("currencyCode");
              }),
              e.add("subtotalPrice"),
              e.add("totalPrice"),
              e.add("completedAt"),
              e.add("createdAt"),
              e.add("updatedAt"),
              e.add("email"),
              e.add("discountApplications", { args: { first: 10 } }, function(
                e
              ) {
                e.add("pageInfo", function(e) {
                  e.add("hasNextPage"), e.add("hasPreviousPage");
                }),
                  e.add("edges", function(e) {
                    e.add("node", function(e) {
                      e.addFragment(n.DiscountApplicationFragment);
                    });
                  });
              }),
              e.add("appliedGiftCards", function(e) {
                e.addFragment(n.AppliedGiftCardFragment);
              }),
              e.add("shippingAddress", function(e) {
                e.addFragment(n.MailingAddressFragment);
              }),
              e.add("shippingLine", function(e) {
                e.add("handle"), e.add("price"), e.add("title");
              }),
              e.add("customAttributes", function(e) {
                e.add("key"), e.add("value");
              }),
              e.add("order", function(e) {
                e.add("id"),
                  e.add("processedAt"),
                  e.add("orderNumber"),
                  e.add("subtotalPrice"),
                  e.add("totalShippingPrice"),
                  e.add("totalTax"),
                  e.add("totalPrice"),
                  e.add("currencyCode"),
                  e.add("totalRefunded"),
                  e.add("customerUrl"),
                  e.add("shippingAddress", function(e) {
                    e.addFragment(n.MailingAddressFragment);
                  }),
                  e.add("lineItems", { args: { first: 250 } }, function(e) {
                    e.add("pageInfo", function(e) {
                      e.add("hasNextPage"), e.add("hasPreviousPage");
                    }),
                      e.add("edges", function(e) {
                        e.add("cursor"),
                          e.add("node", function(e) {
                            e.add("title"),
                              e.add("variant", function(e) {
                                e.addFragment(n.VariantWithProductFragment);
                              }),
                              e.add("quantity"),
                              e.add("customAttributes", function(e) {
                                e.add("key"), e.add("value");
                              });
                          });
                      });
                  });
              }),
              e.add("lineItems", { args: { first: 250 } }, function(e) {
                e.add("pageInfo", function(e) {
                  e.add("hasNextPage"), e.add("hasPreviousPage");
                }),
                  e.add("edges", function(e) {
                    e.add("cursor"),
                      e.add("node", function(e) {
                        e.add("id"),
                          e.add("title"),
                          e.add("variant", function(e) {
                            e.addFragment(n.VariantWithProductFragment);
                          }),
                          e.add("quantity"),
                          e.add("customAttributes", function(e) {
                            e.add("key"), e.add("value");
                          }),
                          e.add("discountAllocations", function(e) {
                            e.add("allocatedAmount", function(e) {
                              e.add("amount"), e.add("currencyCode");
                            }),
                              e.add("discountApplication", function(e) {
                                e.addFragment(n.DiscountApplicationFragment);
                              });
                          });
                      });
                  });
              });
          }
        )),
        t.addMutation(
          [
            a.__defaultOperation__.checkoutId,
            a.__defaultOperation__.lineItemIds
          ],
          function(e) {
            e.add(
              "checkoutLineItemsRemove",
              {
                args: {
                  checkoutId: a.__defaultOperation__.checkoutId,
                  lineItemIds: a.__defaultOperation__.lineItemIds
                }
              },
              function(e) {
                e.add("userErrors", function(e) {
                  e.addFragment(n.UserErrorFragment);
                }),
                  e.add("checkoutUserErrors", function(e) {
                    e.addFragment(n.CheckoutUserErrorFragment);
                  }),
                  e.add("checkout", function(e) {
                    e.addFragment(n.CheckoutFragment);
                  });
              }
            );
          }
        ),
        t
      );
    }
    function De(e) {
      var t = e.document(),
        n = {},
        a = { __defaultOperation__: {} };
      return (
        (a.__defaultOperation__.checkoutId = e.variable("checkoutId", "ID!")),
        (a.__defaultOperation__.lineItems = e.variable(
          "lineItems",
          "[CheckoutLineItemInput!]!"
        )),
        (n.VariantFragment = t.defineFragment(
          "VariantFragment",
          "ProductVariant",
          function(e) {
            e.add("id"),
              e.add("title"),
              e.add("price"),
              e.add("weight"),
              e.add("availableForSale", { alias: "available" }),
              e.add("sku"),
              e.add("compareAtPrice"),
              e.add("image", function(e) {
                e.add("id"),
                  e.add("originalSrc", { alias: "src" }),
                  e.add("altText");
              }),
              e.add("selectedOptions", function(e) {
                e.add("name"), e.add("value");
              });
          }
        )),
        (n.DiscountApplicationFragment = t.defineFragment(
          "DiscountApplicationFragment",
          "DiscountApplication",
          function(e) {
            e.add("targetSelection"),
              e.add("allocationMethod"),
              e.add("targetType"),
              e.addInlineFragmentOn("ManualDiscountApplication", function(e) {
                e.add("title"), e.add("description");
              }),
              e.addInlineFragmentOn("DiscountCodeApplication", function(e) {
                e.add("code"), e.add("applicable");
              }),
              e.addInlineFragmentOn("ScriptDiscountApplication", function(e) {
                e.add("description");
              }),
              e.addInlineFragmentOn("AutomaticDiscountApplication", function(
                e
              ) {
                e.add("title");
              });
          }
        )),
        (n.AppliedGiftCardFragment = t.defineFragment(
          "AppliedGiftCardFragment",
          "AppliedGiftCard",
          function(e) {
            e.add("amountUsedV2", function(e) {
              e.add("amount"), e.add("currencyCode");
            }),
              e.add("balanceV2", function(e) {
                e.add("amount"), e.add("currencyCode");
              }),
              e.add("id"),
              e.add("lastCharacters");
          }
        )),
        (n.VariantWithProductFragment = t.defineFragment(
          "VariantWithProductFragment",
          "ProductVariant",
          function(e) {
            e.addFragment(n.VariantFragment),
              e.add("product", function(e) {
                e.add("id");
              });
          }
        )),
        (n.CheckoutUserErrorFragment = t.defineFragment(
          "CheckoutUserErrorFragment",
          "CheckoutUserError",
          function(e) {
            e.add("field"), e.add("message"), e.add("code");
          }
        )),
        (n.MailingAddressFragment = t.defineFragment(
          "MailingAddressFragment",
          "MailingAddress",
          function(e) {
            e.add("id"),
              e.add("address1"),
              e.add("address2"),
              e.add("city"),
              e.add("company"),
              e.add("country"),
              e.add("firstName"),
              e.add("formatted"),
              e.add("lastName"),
              e.add("latitude"),
              e.add("longitude"),
              e.add("phone"),
              e.add("province"),
              e.add("zip"),
              e.add("name"),
              e.add("countryCodeV2", { alias: "countryCode" }),
              e.add("provinceCode");
          }
        )),
        (n.CheckoutFragment = t.defineFragment(
          "CheckoutFragment",
          "Checkout",
          function(e) {
            e.add("id"),
              e.add("ready"),
              e.add("requiresShipping"),
              e.add("note"),
              e.add("paymentDue"),
              e.add("webUrl"),
              e.add("orderStatusUrl"),
              e.add("taxExempt"),
              e.add("taxesIncluded"),
              e.add("currencyCode"),
              e.add("totalTax"),
              e.add("lineItemsSubtotalPrice", function(e) {
                e.add("amount"), e.add("currencyCode");
              }),
              e.add("subtotalPrice"),
              e.add("totalPrice"),
              e.add("completedAt"),
              e.add("createdAt"),
              e.add("updatedAt"),
              e.add("email"),
              e.add("discountApplications", { args: { first: 10 } }, function(
                e
              ) {
                e.add("pageInfo", function(e) {
                  e.add("hasNextPage"), e.add("hasPreviousPage");
                }),
                  e.add("edges", function(e) {
                    e.add("node", function(e) {
                      e.addFragment(n.DiscountApplicationFragment);
                    });
                  });
              }),
              e.add("appliedGiftCards", function(e) {
                e.addFragment(n.AppliedGiftCardFragment);
              }),
              e.add("shippingAddress", function(e) {
                e.addFragment(n.MailingAddressFragment);
              }),
              e.add("shippingLine", function(e) {
                e.add("handle"), e.add("price"), e.add("title");
              }),
              e.add("customAttributes", function(e) {
                e.add("key"), e.add("value");
              }),
              e.add("order", function(e) {
                e.add("id"),
                  e.add("processedAt"),
                  e.add("orderNumber"),
                  e.add("subtotalPrice"),
                  e.add("totalShippingPrice"),
                  e.add("totalTax"),
                  e.add("totalPrice"),
                  e.add("currencyCode"),
                  e.add("totalRefunded"),
                  e.add("customerUrl"),
                  e.add("shippingAddress", function(e) {
                    e.addFragment(n.MailingAddressFragment);
                  }),
                  e.add("lineItems", { args: { first: 250 } }, function(e) {
                    e.add("pageInfo", function(e) {
                      e.add("hasNextPage"), e.add("hasPreviousPage");
                    }),
                      e.add("edges", function(e) {
                        e.add("cursor"),
                          e.add("node", function(e) {
                            e.add("title"),
                              e.add("variant", function(e) {
                                e.addFragment(n.VariantWithProductFragment);
                              }),
                              e.add("quantity"),
                              e.add("customAttributes", function(e) {
                                e.add("key"), e.add("value");
                              });
                          });
                      });
                  });
              }),
              e.add("lineItems", { args: { first: 250 } }, function(e) {
                e.add("pageInfo", function(e) {
                  e.add("hasNextPage"), e.add("hasPreviousPage");
                }),
                  e.add("edges", function(e) {
                    e.add("cursor"),
                      e.add("node", function(e) {
                        e.add("id"),
                          e.add("title"),
                          e.add("variant", function(e) {
                            e.addFragment(n.VariantWithProductFragment);
                          }),
                          e.add("quantity"),
                          e.add("customAttributes", function(e) {
                            e.add("key"), e.add("value");
                          }),
                          e.add("discountAllocations", function(e) {
                            e.add("allocatedAmount", function(e) {
                              e.add("amount"), e.add("currencyCode");
                            }),
                              e.add("discountApplication", function(e) {
                                e.addFragment(n.DiscountApplicationFragment);
                              });
                          });
                      });
                  });
              });
          }
        )),
        t.addMutation(
          [a.__defaultOperation__.checkoutId, a.__defaultOperation__.lineItems],
          function(e) {
            e.add(
              "checkoutLineItemsReplace",
              {
                args: {
                  checkoutId: a.__defaultOperation__.checkoutId,
                  lineItems: a.__defaultOperation__.lineItems
                }
              },
              function(e) {
                e.add("userErrors", function(e) {
                  e.addFragment(n.CheckoutUserErrorFragment);
                }),
                  e.add("checkout", function(e) {
                    e.addFragment(n.CheckoutFragment);
                  });
              }
            );
          }
        ),
        t
      );
    }
    function Ve(e) {
      var t = e.document(),
        n = {},
        a = { __defaultOperation__: {} };
      return (
        (a.__defaultOperation__.checkoutId = e.variable("checkoutId", "ID!")),
        (a.__defaultOperation__.lineItems = e.variable(
          "lineItems",
          "[CheckoutLineItemUpdateInput!]!"
        )),
        (n.VariantFragment = t.defineFragment(
          "VariantFragment",
          "ProductVariant",
          function(e) {
            e.add("id"),
              e.add("title"),
              e.add("price"),
              e.add("weight"),
              e.add("availableForSale", { alias: "available" }),
              e.add("sku"),
              e.add("compareAtPrice"),
              e.add("image", function(e) {
                e.add("id"),
                  e.add("originalSrc", { alias: "src" }),
                  e.add("altText");
              }),
              e.add("selectedOptions", function(e) {
                e.add("name"), e.add("value");
              });
          }
        )),
        (n.DiscountApplicationFragment = t.defineFragment(
          "DiscountApplicationFragment",
          "DiscountApplication",
          function(e) {
            e.add("targetSelection"),
              e.add("allocationMethod"),
              e.add("targetType"),
              e.addInlineFragmentOn("ManualDiscountApplication", function(e) {
                e.add("title"), e.add("description");
              }),
              e.addInlineFragmentOn("DiscountCodeApplication", function(e) {
                e.add("code"), e.add("applicable");
              }),
              e.addInlineFragmentOn("ScriptDiscountApplication", function(e) {
                e.add("description");
              }),
              e.addInlineFragmentOn("AutomaticDiscountApplication", function(
                e
              ) {
                e.add("title");
              });
          }
        )),
        (n.AppliedGiftCardFragment = t.defineFragment(
          "AppliedGiftCardFragment",
          "AppliedGiftCard",
          function(e) {
            e.add("amountUsedV2", function(e) {
              e.add("amount"), e.add("currencyCode");
            }),
              e.add("balanceV2", function(e) {
                e.add("amount"), e.add("currencyCode");
              }),
              e.add("id"),
              e.add("lastCharacters");
          }
        )),
        (n.VariantWithProductFragment = t.defineFragment(
          "VariantWithProductFragment",
          "ProductVariant",
          function(e) {
            e.addFragment(n.VariantFragment),
              e.add("product", function(e) {
                e.add("id");
              });
          }
        )),
        (n.UserErrorFragment = t.defineFragment(
          "UserErrorFragment",
          "UserError",
          function(e) {
            e.add("field"), e.add("message");
          }
        )),
        (n.CheckoutUserErrorFragment = t.defineFragment(
          "CheckoutUserErrorFragment",
          "CheckoutUserError",
          function(e) {
            e.add("field"), e.add("message"), e.add("code");
          }
        )),
        (n.MailingAddressFragment = t.defineFragment(
          "MailingAddressFragment",
          "MailingAddress",
          function(e) {
            e.add("id"),
              e.add("address1"),
              e.add("address2"),
              e.add("city"),
              e.add("company"),
              e.add("country"),
              e.add("firstName"),
              e.add("formatted"),
              e.add("lastName"),
              e.add("latitude"),
              e.add("longitude"),
              e.add("phone"),
              e.add("province"),
              e.add("zip"),
              e.add("name"),
              e.add("countryCodeV2", { alias: "countryCode" }),
              e.add("provinceCode");
          }
        )),
        (n.CheckoutFragment = t.defineFragment(
          "CheckoutFragment",
          "Checkout",
          function(e) {
            e.add("id"),
              e.add("ready"),
              e.add("requiresShipping"),
              e.add("note"),
              e.add("paymentDue"),
              e.add("webUrl"),
              e.add("orderStatusUrl"),
              e.add("taxExempt"),
              e.add("taxesIncluded"),
              e.add("currencyCode"),
              e.add("totalTax"),
              e.add("lineItemsSubtotalPrice", function(e) {
                e.add("amount"), e.add("currencyCode");
              }),
              e.add("subtotalPrice"),
              e.add("totalPrice"),
              e.add("completedAt"),
              e.add("createdAt"),
              e.add("updatedAt"),
              e.add("email"),
              e.add("discountApplications", { args: { first: 10 } }, function(
                e
              ) {
                e.add("pageInfo", function(e) {
                  e.add("hasNextPage"), e.add("hasPreviousPage");
                }),
                  e.add("edges", function(e) {
                    e.add("node", function(e) {
                      e.addFragment(n.DiscountApplicationFragment);
                    });
                  });
              }),
              e.add("appliedGiftCards", function(e) {
                e.addFragment(n.AppliedGiftCardFragment);
              }),
              e.add("shippingAddress", function(e) {
                e.addFragment(n.MailingAddressFragment);
              }),
              e.add("shippingLine", function(e) {
                e.add("handle"), e.add("price"), e.add("title");
              }),
              e.add("customAttributes", function(e) {
                e.add("key"), e.add("value");
              }),
              e.add("order", function(e) {
                e.add("id"),
                  e.add("processedAt"),
                  e.add("orderNumber"),
                  e.add("subtotalPrice"),
                  e.add("totalShippingPrice"),
                  e.add("totalTax"),
                  e.add("totalPrice"),
                  e.add("currencyCode"),
                  e.add("totalRefunded"),
                  e.add("customerUrl"),
                  e.add("shippingAddress", function(e) {
                    e.addFragment(n.MailingAddressFragment);
                  }),
                  e.add("lineItems", { args: { first: 250 } }, function(e) {
                    e.add("pageInfo", function(e) {
                      e.add("hasNextPage"), e.add("hasPreviousPage");
                    }),
                      e.add("edges", function(e) {
                        e.add("cursor"),
                          e.add("node", function(e) {
                            e.add("title"),
                              e.add("variant", function(e) {
                                e.addFragment(n.VariantWithProductFragment);
                              }),
                              e.add("quantity"),
                              e.add("customAttributes", function(e) {
                                e.add("key"), e.add("value");
                              });
                          });
                      });
                  });
              }),
              e.add("lineItems", { args: { first: 250 } }, function(e) {
                e.add("pageInfo", function(e) {
                  e.add("hasNextPage"), e.add("hasPreviousPage");
                }),
                  e.add("edges", function(e) {
                    e.add("cursor"),
                      e.add("node", function(e) {
                        e.add("id"),
                          e.add("title"),
                          e.add("variant", function(e) {
                            e.addFragment(n.VariantWithProductFragment);
                          }),
                          e.add("quantity"),
                          e.add("customAttributes", function(e) {
                            e.add("key"), e.add("value");
                          }),
                          e.add("discountAllocations", function(e) {
                            e.add("allocatedAmount", function(e) {
                              e.add("amount"), e.add("currencyCode");
                            }),
                              e.add("discountApplication", function(e) {
                                e.addFragment(n.DiscountApplicationFragment);
                              });
                          });
                      });
                  });
              });
          }
        )),
        t.addMutation(
          [a.__defaultOperation__.checkoutId, a.__defaultOperation__.lineItems],
          function(e) {
            e.add(
              "checkoutLineItemsUpdate",
              {
                args: {
                  checkoutId: a.__defaultOperation__.checkoutId,
                  lineItems: a.__defaultOperation__.lineItems
                }
              },
              function(e) {
                e.add("userErrors", function(e) {
                  e.addFragment(n.UserErrorFragment);
                }),
                  e.add("checkoutUserErrors", function(e) {
                    e.addFragment(n.CheckoutUserErrorFragment);
                  }),
                  e.add("checkout", function(e) {
                    e.addFragment(n.CheckoutFragment);
                  });
              }
            );
          }
        ),
        t
      );
    }
    function Ue(e) {
      var t = e.document(),
        n = {},
        a = { checkoutAttributesUpdateV2: {} };
      return (
        (a.checkoutAttributesUpdateV2.checkoutId = e.variable(
          "checkoutId",
          "ID!"
        )),
        (a.checkoutAttributesUpdateV2.input = e.variable(
          "input",
          "CheckoutAttributesUpdateV2Input!"
        )),
        (n.VariantFragment = t.defineFragment(
          "VariantFragment",
          "ProductVariant",
          function(e) {
            e.add("id"),
              e.add("title"),
              e.add("price"),
              e.add("weight"),
              e.add("availableForSale", { alias: "available" }),
              e.add("sku"),
              e.add("compareAtPrice"),
              e.add("image", function(e) {
                e.add("id"),
                  e.add("originalSrc", { alias: "src" }),
                  e.add("altText");
              }),
              e.add("selectedOptions", function(e) {
                e.add("name"), e.add("value");
              });
          }
        )),
        (n.DiscountApplicationFragment = t.defineFragment(
          "DiscountApplicationFragment",
          "DiscountApplication",
          function(e) {
            e.add("targetSelection"),
              e.add("allocationMethod"),
              e.add("targetType"),
              e.addInlineFragmentOn("ManualDiscountApplication", function(e) {
                e.add("title"), e.add("description");
              }),
              e.addInlineFragmentOn("DiscountCodeApplication", function(e) {
                e.add("code"), e.add("applicable");
              }),
              e.addInlineFragmentOn("ScriptDiscountApplication", function(e) {
                e.add("description");
              }),
              e.addInlineFragmentOn("AutomaticDiscountApplication", function(
                e
              ) {
                e.add("title");
              });
          }
        )),
        (n.AppliedGiftCardFragment = t.defineFragment(
          "AppliedGiftCardFragment",
          "AppliedGiftCard",
          function(e) {
            e.add("amountUsedV2", function(e) {
              e.add("amount"), e.add("currencyCode");
            }),
              e.add("balanceV2", function(e) {
                e.add("amount"), e.add("currencyCode");
              }),
              e.add("id"),
              e.add("lastCharacters");
          }
        )),
        (n.VariantWithProductFragment = t.defineFragment(
          "VariantWithProductFragment",
          "ProductVariant",
          function(e) {
            e.addFragment(n.VariantFragment),
              e.add("product", function(e) {
                e.add("id");
              });
          }
        )),
        (n.UserErrorFragment = t.defineFragment(
          "UserErrorFragment",
          "UserError",
          function(e) {
            e.add("field"), e.add("message");
          }
        )),
        (n.CheckoutUserErrorFragment = t.defineFragment(
          "CheckoutUserErrorFragment",
          "CheckoutUserError",
          function(e) {
            e.add("field"), e.add("message"), e.add("code");
          }
        )),
        (n.MailingAddressFragment = t.defineFragment(
          "MailingAddressFragment",
          "MailingAddress",
          function(e) {
            e.add("id"),
              e.add("address1"),
              e.add("address2"),
              e.add("city"),
              e.add("company"),
              e.add("country"),
              e.add("firstName"),
              e.add("formatted"),
              e.add("lastName"),
              e.add("latitude"),
              e.add("longitude"),
              e.add("phone"),
              e.add("province"),
              e.add("zip"),
              e.add("name"),
              e.add("countryCodeV2", { alias: "countryCode" }),
              e.add("provinceCode");
          }
        )),
        (n.CheckoutFragment = t.defineFragment(
          "CheckoutFragment",
          "Checkout",
          function(e) {
            e.add("id"),
              e.add("ready"),
              e.add("requiresShipping"),
              e.add("note"),
              e.add("paymentDue"),
              e.add("webUrl"),
              e.add("orderStatusUrl"),
              e.add("taxExempt"),
              e.add("taxesIncluded"),
              e.add("currencyCode"),
              e.add("totalTax"),
              e.add("lineItemsSubtotalPrice", function(e) {
                e.add("amount"), e.add("currencyCode");
              }),
              e.add("subtotalPrice"),
              e.add("totalPrice"),
              e.add("completedAt"),
              e.add("createdAt"),
              e.add("updatedAt"),
              e.add("email"),
              e.add("discountApplications", { args: { first: 10 } }, function(
                e
              ) {
                e.add("pageInfo", function(e) {
                  e.add("hasNextPage"), e.add("hasPreviousPage");
                }),
                  e.add("edges", function(e) {
                    e.add("node", function(e) {
                      e.addFragment(n.DiscountApplicationFragment);
                    });
                  });
              }),
              e.add("appliedGiftCards", function(e) {
                e.addFragment(n.AppliedGiftCardFragment);
              }),
              e.add("shippingAddress", function(e) {
                e.addFragment(n.MailingAddressFragment);
              }),
              e.add("shippingLine", function(e) {
                e.add("handle"), e.add("price"), e.add("title");
              }),
              e.add("customAttributes", function(e) {
                e.add("key"), e.add("value");
              }),
              e.add("order", function(e) {
                e.add("id"),
                  e.add("processedAt"),
                  e.add("orderNumber"),
                  e.add("subtotalPrice"),
                  e.add("totalShippingPrice"),
                  e.add("totalTax"),
                  e.add("totalPrice"),
                  e.add("currencyCode"),
                  e.add("totalRefunded"),
                  e.add("customerUrl"),
                  e.add("shippingAddress", function(e) {
                    e.addFragment(n.MailingAddressFragment);
                  }),
                  e.add("lineItems", { args: { first: 250 } }, function(e) {
                    e.add("pageInfo", function(e) {
                      e.add("hasNextPage"), e.add("hasPreviousPage");
                    }),
                      e.add("edges", function(e) {
                        e.add("cursor"),
                          e.add("node", function(e) {
                            e.add("title"),
                              e.add("variant", function(e) {
                                e.addFragment(n.VariantWithProductFragment);
                              }),
                              e.add("quantity"),
                              e.add("customAttributes", function(e) {
                                e.add("key"), e.add("value");
                              });
                          });
                      });
                  });
              }),
              e.add("lineItems", { args: { first: 250 } }, function(e) {
                e.add("pageInfo", function(e) {
                  e.add("hasNextPage"), e.add("hasPreviousPage");
                }),
                  e.add("edges", function(e) {
                    e.add("cursor"),
                      e.add("node", function(e) {
                        e.add("id"),
                          e.add("title"),
                          e.add("variant", function(e) {
                            e.addFragment(n.VariantWithProductFragment);
                          }),
                          e.add("quantity"),
                          e.add("customAttributes", function(e) {
                            e.add("key"), e.add("value");
                          }),
                          e.add("discountAllocations", function(e) {
                            e.add("allocatedAmount", function(e) {
                              e.add("amount"), e.add("currencyCode");
                            }),
                              e.add("discountApplication", function(e) {
                                e.addFragment(n.DiscountApplicationFragment);
                              });
                          });
                      });
                  });
              });
          }
        )),
        t.addMutation(
          "checkoutAttributesUpdateV2",
          [
            a.checkoutAttributesUpdateV2.checkoutId,
            a.checkoutAttributesUpdateV2.input
          ],
          function(e) {
            e.add(
              "checkoutAttributesUpdateV2",
              {
                args: {
                  checkoutId: a.checkoutAttributesUpdateV2.checkoutId,
                  input: a.checkoutAttributesUpdateV2.input
                }
              },
              function(e) {
                e.add("userErrors", function(e) {
                  e.addFragment(n.UserErrorFragment);
                }),
                  e.add("checkoutUserErrors", function(e) {
                    e.addFragment(n.CheckoutUserErrorFragment);
                  }),
                  e.add("checkout", function(e) {
                    e.addFragment(n.CheckoutFragment);
                  });
              }
            );
          }
        ),
        t
      );
    }
    function Me(e) {
      var t = e.document(),
        n = {},
        a = { checkoutDiscountCodeApplyV2: {} };
      return (
        (a.checkoutDiscountCodeApplyV2.discountCode = e.variable(
          "discountCode",
          "String!"
        )),
        (a.checkoutDiscountCodeApplyV2.checkoutId = e.variable(
          "checkoutId",
          "ID!"
        )),
        (n.VariantFragment = t.defineFragment(
          "VariantFragment",
          "ProductVariant",
          function(e) {
            e.add("id"),
              e.add("title"),
              e.add("price"),
              e.add("weight"),
              e.add("availableForSale", { alias: "available" }),
              e.add("sku"),
              e.add("compareAtPrice"),
              e.add("image", function(e) {
                e.add("id"),
                  e.add("originalSrc", { alias: "src" }),
                  e.add("altText");
              }),
              e.add("selectedOptions", function(e) {
                e.add("name"), e.add("value");
              });
          }
        )),
        (n.DiscountApplicationFragment = t.defineFragment(
          "DiscountApplicationFragment",
          "DiscountApplication",
          function(e) {
            e.add("targetSelection"),
              e.add("allocationMethod"),
              e.add("targetType"),
              e.addInlineFragmentOn("ManualDiscountApplication", function(e) {
                e.add("title"), e.add("description");
              }),
              e.addInlineFragmentOn("DiscountCodeApplication", function(e) {
                e.add("code"), e.add("applicable");
              }),
              e.addInlineFragmentOn("ScriptDiscountApplication", function(e) {
                e.add("description");
              }),
              e.addInlineFragmentOn("AutomaticDiscountApplication", function(
                e
              ) {
                e.add("title");
              });
          }
        )),
        (n.AppliedGiftCardFragment = t.defineFragment(
          "AppliedGiftCardFragment",
          "AppliedGiftCard",
          function(e) {
            e.add("amountUsedV2", function(e) {
              e.add("amount"), e.add("currencyCode");
            }),
              e.add("balanceV2", function(e) {
                e.add("amount"), e.add("currencyCode");
              }),
              e.add("id"),
              e.add("lastCharacters");
          }
        )),
        (n.VariantWithProductFragment = t.defineFragment(
          "VariantWithProductFragment",
          "ProductVariant",
          function(e) {
            e.addFragment(n.VariantFragment),
              e.add("product", function(e) {
                e.add("id");
              });
          }
        )),
        (n.UserErrorFragment = t.defineFragment(
          "UserErrorFragment",
          "UserError",
          function(e) {
            e.add("field"), e.add("message");
          }
        )),
        (n.CheckoutUserErrorFragment = t.defineFragment(
          "CheckoutUserErrorFragment",
          "CheckoutUserError",
          function(e) {
            e.add("field"), e.add("message"), e.add("code");
          }
        )),
        (n.MailingAddressFragment = t.defineFragment(
          "MailingAddressFragment",
          "MailingAddress",
          function(e) {
            e.add("id"),
              e.add("address1"),
              e.add("address2"),
              e.add("city"),
              e.add("company"),
              e.add("country"),
              e.add("firstName"),
              e.add("formatted"),
              e.add("lastName"),
              e.add("latitude"),
              e.add("longitude"),
              e.add("phone"),
              e.add("province"),
              e.add("zip"),
              e.add("name"),
              e.add("countryCodeV2", { alias: "countryCode" }),
              e.add("provinceCode");
          }
        )),
        (n.CheckoutFragment = t.defineFragment(
          "CheckoutFragment",
          "Checkout",
          function(e) {
            e.add("id"),
              e.add("ready"),
              e.add("requiresShipping"),
              e.add("note"),
              e.add("paymentDue"),
              e.add("webUrl"),
              e.add("orderStatusUrl"),
              e.add("taxExempt"),
              e.add("taxesIncluded"),
              e.add("currencyCode"),
              e.add("totalTax"),
              e.add("lineItemsSubtotalPrice", function(e) {
                e.add("amount"), e.add("currencyCode");
              }),
              e.add("subtotalPrice"),
              e.add("totalPrice"),
              e.add("completedAt"),
              e.add("createdAt"),
              e.add("updatedAt"),
              e.add("email"),
              e.add("discountApplications", { args: { first: 10 } }, function(
                e
              ) {
                e.add("pageInfo", function(e) {
                  e.add("hasNextPage"), e.add("hasPreviousPage");
                }),
                  e.add("edges", function(e) {
                    e.add("node", function(e) {
                      e.addFragment(n.DiscountApplicationFragment);
                    });
                  });
              }),
              e.add("appliedGiftCards", function(e) {
                e.addFragment(n.AppliedGiftCardFragment);
              }),
              e.add("shippingAddress", function(e) {
                e.addFragment(n.MailingAddressFragment);
              }),
              e.add("shippingLine", function(e) {
                e.add("handle"), e.add("price"), e.add("title");
              }),
              e.add("customAttributes", function(e) {
                e.add("key"), e.add("value");
              }),
              e.add("order", function(e) {
                e.add("id"),
                  e.add("processedAt"),
                  e.add("orderNumber"),
                  e.add("subtotalPrice"),
                  e.add("totalShippingPrice"),
                  e.add("totalTax"),
                  e.add("totalPrice"),
                  e.add("currencyCode"),
                  e.add("totalRefunded"),
                  e.add("customerUrl"),
                  e.add("shippingAddress", function(e) {
                    e.addFragment(n.MailingAddressFragment);
                  }),
                  e.add("lineItems", { args: { first: 250 } }, function(e) {
                    e.add("pageInfo", function(e) {
                      e.add("hasNextPage"), e.add("hasPreviousPage");
                    }),
                      e.add("edges", function(e) {
                        e.add("cursor"),
                          e.add("node", function(e) {
                            e.add("title"),
                              e.add("variant", function(e) {
                                e.addFragment(n.VariantWithProductFragment);
                              }),
                              e.add("quantity"),
                              e.add("customAttributes", function(e) {
                                e.add("key"), e.add("value");
                              });
                          });
                      });
                  });
              }),
              e.add("lineItems", { args: { first: 250 } }, function(e) {
                e.add("pageInfo", function(e) {
                  e.add("hasNextPage"), e.add("hasPreviousPage");
                }),
                  e.add("edges", function(e) {
                    e.add("cursor"),
                      e.add("node", function(e) {
                        e.add("id"),
                          e.add("title"),
                          e.add("variant", function(e) {
                            e.addFragment(n.VariantWithProductFragment);
                          }),
                          e.add("quantity"),
                          e.add("customAttributes", function(e) {
                            e.add("key"), e.add("value");
                          }),
                          e.add("discountAllocations", function(e) {
                            e.add("allocatedAmount", function(e) {
                              e.add("amount"), e.add("currencyCode");
                            }),
                              e.add("discountApplication", function(e) {
                                e.addFragment(n.DiscountApplicationFragment);
                              });
                          });
                      });
                  });
              });
          }
        )),
        t.addMutation(
          "checkoutDiscountCodeApplyV2",
          [
            a.checkoutDiscountCodeApplyV2.discountCode,
            a.checkoutDiscountCodeApplyV2.checkoutId
          ],
          function(e) {
            e.add(
              "checkoutDiscountCodeApplyV2",
              {
                args: {
                  discountCode: a.checkoutDiscountCodeApplyV2.discountCode,
                  checkoutId: a.checkoutDiscountCodeApplyV2.checkoutId
                }
              },
              function(e) {
                e.add("userErrors", function(e) {
                  e.addFragment(n.UserErrorFragment);
                }),
                  e.add("checkoutUserErrors", function(e) {
                    e.addFragment(n.CheckoutUserErrorFragment);
                  }),
                  e.add("checkout", function(e) {
                    e.addFragment(n.CheckoutFragment);
                  });
              }
            );
          }
        ),
        t
      );
    }
    function Ne(e) {
      var t = e.document(),
        n = {},
        a = { checkoutDiscountCodeRemove: {} };
      return (
        (a.checkoutDiscountCodeRemove.checkoutId = e.variable(
          "checkoutId",
          "ID!"
        )),
        (n.VariantFragment = t.defineFragment(
          "VariantFragment",
          "ProductVariant",
          function(e) {
            e.add("id"),
              e.add("title"),
              e.add("price"),
              e.add("weight"),
              e.add("availableForSale", { alias: "available" }),
              e.add("sku"),
              e.add("compareAtPrice"),
              e.add("image", function(e) {
                e.add("id"),
                  e.add("originalSrc", { alias: "src" }),
                  e.add("altText");
              }),
              e.add("selectedOptions", function(e) {
                e.add("name"), e.add("value");
              });
          }
        )),
        (n.DiscountApplicationFragment = t.defineFragment(
          "DiscountApplicationFragment",
          "DiscountApplication",
          function(e) {
            e.add("targetSelection"),
              e.add("allocationMethod"),
              e.add("targetType"),
              e.addInlineFragmentOn("ManualDiscountApplication", function(e) {
                e.add("title"), e.add("description");
              }),
              e.addInlineFragmentOn("DiscountCodeApplication", function(e) {
                e.add("code"), e.add("applicable");
              }),
              e.addInlineFragmentOn("ScriptDiscountApplication", function(e) {
                e.add("description");
              }),
              e.addInlineFragmentOn("AutomaticDiscountApplication", function(
                e
              ) {
                e.add("title");
              });
          }
        )),
        (n.AppliedGiftCardFragment = t.defineFragment(
          "AppliedGiftCardFragment",
          "AppliedGiftCard",
          function(e) {
            e.add("amountUsedV2", function(e) {
              e.add("amount"), e.add("currencyCode");
            }),
              e.add("balanceV2", function(e) {
                e.add("amount"), e.add("currencyCode");
              }),
              e.add("id"),
              e.add("lastCharacters");
          }
        )),
        (n.VariantWithProductFragment = t.defineFragment(
          "VariantWithProductFragment",
          "ProductVariant",
          function(e) {
            e.addFragment(n.VariantFragment),
              e.add("product", function(e) {
                e.add("id");
              });
          }
        )),
        (n.UserErrorFragment = t.defineFragment(
          "UserErrorFragment",
          "UserError",
          function(e) {
            e.add("field"), e.add("message");
          }
        )),
        (n.CheckoutUserErrorFragment = t.defineFragment(
          "CheckoutUserErrorFragment",
          "CheckoutUserError",
          function(e) {
            e.add("field"), e.add("message"), e.add("code");
          }
        )),
        (n.MailingAddressFragment = t.defineFragment(
          "MailingAddressFragment",
          "MailingAddress",
          function(e) {
            e.add("id"),
              e.add("address1"),
              e.add("address2"),
              e.add("city"),
              e.add("company"),
              e.add("country"),
              e.add("firstName"),
              e.add("formatted"),
              e.add("lastName"),
              e.add("latitude"),
              e.add("longitude"),
              e.add("phone"),
              e.add("province"),
              e.add("zip"),
              e.add("name"),
              e.add("countryCodeV2", { alias: "countryCode" }),
              e.add("provinceCode");
          }
        )),
        (n.CheckoutFragment = t.defineFragment(
          "CheckoutFragment",
          "Checkout",
          function(e) {
            e.add("id"),
              e.add("ready"),
              e.add("requiresShipping"),
              e.add("note"),
              e.add("paymentDue"),
              e.add("webUrl"),
              e.add("orderStatusUrl"),
              e.add("taxExempt"),
              e.add("taxesIncluded"),
              e.add("currencyCode"),
              e.add("totalTax"),
              e.add("lineItemsSubtotalPrice", function(e) {
                e.add("amount"), e.add("currencyCode");
              }),
              e.add("subtotalPrice"),
              e.add("totalPrice"),
              e.add("completedAt"),
              e.add("createdAt"),
              e.add("updatedAt"),
              e.add("email"),
              e.add("discountApplications", { args: { first: 10 } }, function(
                e
              ) {
                e.add("pageInfo", function(e) {
                  e.add("hasNextPage"), e.add("hasPreviousPage");
                }),
                  e.add("edges", function(e) {
                    e.add("node", function(e) {
                      e.addFragment(n.DiscountApplicationFragment);
                    });
                  });
              }),
              e.add("appliedGiftCards", function(e) {
                e.addFragment(n.AppliedGiftCardFragment);
              }),
              e.add("shippingAddress", function(e) {
                e.addFragment(n.MailingAddressFragment);
              }),
              e.add("shippingLine", function(e) {
                e.add("handle"), e.add("price"), e.add("title");
              }),
              e.add("customAttributes", function(e) {
                e.add("key"), e.add("value");
              }),
              e.add("order", function(e) {
                e.add("id"),
                  e.add("processedAt"),
                  e.add("orderNumber"),
                  e.add("subtotalPrice"),
                  e.add("totalShippingPrice"),
                  e.add("totalTax"),
                  e.add("totalPrice"),
                  e.add("currencyCode"),
                  e.add("totalRefunded"),
                  e.add("customerUrl"),
                  e.add("shippingAddress", function(e) {
                    e.addFragment(n.MailingAddressFragment);
                  }),
                  e.add("lineItems", { args: { first: 250 } }, function(e) {
                    e.add("pageInfo", function(e) {
                      e.add("hasNextPage"), e.add("hasPreviousPage");
                    }),
                      e.add("edges", function(e) {
                        e.add("cursor"),
                          e.add("node", function(e) {
                            e.add("title"),
                              e.add("variant", function(e) {
                                e.addFragment(n.VariantWithProductFragment);
                              }),
                              e.add("quantity"),
                              e.add("customAttributes", function(e) {
                                e.add("key"), e.add("value");
                              });
                          });
                      });
                  });
              }),
              e.add("lineItems", { args: { first: 250 } }, function(e) {
                e.add("pageInfo", function(e) {
                  e.add("hasNextPage"), e.add("hasPreviousPage");
                }),
                  e.add("edges", function(e) {
                    e.add("cursor"),
                      e.add("node", function(e) {
                        e.add("id"),
                          e.add("title"),
                          e.add("variant", function(e) {
                            e.addFragment(n.VariantWithProductFragment);
                          }),
                          e.add("quantity"),
                          e.add("customAttributes", function(e) {
                            e.add("key"), e.add("value");
                          }),
                          e.add("discountAllocations", function(e) {
                            e.add("allocatedAmount", function(e) {
                              e.add("amount"), e.add("currencyCode");
                            }),
                              e.add("discountApplication", function(e) {
                                e.addFragment(n.DiscountApplicationFragment);
                              });
                          });
                      });
                  });
              });
          }
        )),
        t.addMutation(
          "checkoutDiscountCodeRemove",
          [a.checkoutDiscountCodeRemove.checkoutId],
          function(e) {
            e.add(
              "checkoutDiscountCodeRemove",
              { args: { checkoutId: a.checkoutDiscountCodeRemove.checkoutId } },
              function(e) {
                e.add("userErrors", function(e) {
                  e.addFragment(n.UserErrorFragment);
                }),
                  e.add("checkoutUserErrors", function(e) {
                    e.addFragment(n.CheckoutUserErrorFragment);
                  }),
                  e.add("checkout", function(e) {
                    e.addFragment(n.CheckoutFragment);
                  });
              }
            );
          }
        ),
        t
      );
    }
    function Le(e) {
      var t = e.document(),
        n = {},
        a = { checkoutGiftCardsAppend: {} };
      return (
        (a.checkoutGiftCardsAppend.giftCardCodes = e.variable(
          "giftCardCodes",
          "[String!]!"
        )),
        (a.checkoutGiftCardsAppend.checkoutId = e.variable(
          "checkoutId",
          "ID!"
        )),
        (n.VariantFragment = t.defineFragment(
          "VariantFragment",
          "ProductVariant",
          function(e) {
            e.add("id"),
              e.add("title"),
              e.add("price"),
              e.add("weight"),
              e.add("availableForSale", { alias: "available" }),
              e.add("sku"),
              e.add("compareAtPrice"),
              e.add("image", function(e) {
                e.add("id"),
                  e.add("originalSrc", { alias: "src" }),
                  e.add("altText");
              }),
              e.add("selectedOptions", function(e) {
                e.add("name"), e.add("value");
              });
          }
        )),
        (n.DiscountApplicationFragment = t.defineFragment(
          "DiscountApplicationFragment",
          "DiscountApplication",
          function(e) {
            e.add("targetSelection"),
              e.add("allocationMethod"),
              e.add("targetType"),
              e.addInlineFragmentOn("ManualDiscountApplication", function(e) {
                e.add("title"), e.add("description");
              }),
              e.addInlineFragmentOn("DiscountCodeApplication", function(e) {
                e.add("code"), e.add("applicable");
              }),
              e.addInlineFragmentOn("ScriptDiscountApplication", function(e) {
                e.add("description");
              }),
              e.addInlineFragmentOn("AutomaticDiscountApplication", function(
                e
              ) {
                e.add("title");
              });
          }
        )),
        (n.AppliedGiftCardFragment = t.defineFragment(
          "AppliedGiftCardFragment",
          "AppliedGiftCard",
          function(e) {
            e.add("amountUsedV2", function(e) {
              e.add("amount"), e.add("currencyCode");
            }),
              e.add("balanceV2", function(e) {
                e.add("amount"), e.add("currencyCode");
              }),
              e.add("id"),
              e.add("lastCharacters");
          }
        )),
        (n.VariantWithProductFragment = t.defineFragment(
          "VariantWithProductFragment",
          "ProductVariant",
          function(e) {
            e.addFragment(n.VariantFragment),
              e.add("product", function(e) {
                e.add("id");
              });
          }
        )),
        (n.UserErrorFragment = t.defineFragment(
          "UserErrorFragment",
          "UserError",
          function(e) {
            e.add("field"), e.add("message");
          }
        )),
        (n.CheckoutUserErrorFragment = t.defineFragment(
          "CheckoutUserErrorFragment",
          "CheckoutUserError",
          function(e) {
            e.add("field"), e.add("message"), e.add("code");
          }
        )),
        (n.MailingAddressFragment = t.defineFragment(
          "MailingAddressFragment",
          "MailingAddress",
          function(e) {
            e.add("id"),
              e.add("address1"),
              e.add("address2"),
              e.add("city"),
              e.add("company"),
              e.add("country"),
              e.add("firstName"),
              e.add("formatted"),
              e.add("lastName"),
              e.add("latitude"),
              e.add("longitude"),
              e.add("phone"),
              e.add("province"),
              e.add("zip"),
              e.add("name"),
              e.add("countryCodeV2", { alias: "countryCode" }),
              e.add("provinceCode");
          }
        )),
        (n.CheckoutFragment = t.defineFragment(
          "CheckoutFragment",
          "Checkout",
          function(e) {
            e.add("id"),
              e.add("ready"),
              e.add("requiresShipping"),
              e.add("note"),
              e.add("paymentDue"),
              e.add("webUrl"),
              e.add("orderStatusUrl"),
              e.add("taxExempt"),
              e.add("taxesIncluded"),
              e.add("currencyCode"),
              e.add("totalTax"),
              e.add("lineItemsSubtotalPrice", function(e) {
                e.add("amount"), e.add("currencyCode");
              }),
              e.add("subtotalPrice"),
              e.add("totalPrice"),
              e.add("completedAt"),
              e.add("createdAt"),
              e.add("updatedAt"),
              e.add("email"),
              e.add("discountApplications", { args: { first: 10 } }, function(
                e
              ) {
                e.add("pageInfo", function(e) {
                  e.add("hasNextPage"), e.add("hasPreviousPage");
                }),
                  e.add("edges", function(e) {
                    e.add("node", function(e) {
                      e.addFragment(n.DiscountApplicationFragment);
                    });
                  });
              }),
              e.add("appliedGiftCards", function(e) {
                e.addFragment(n.AppliedGiftCardFragment);
              }),
              e.add("shippingAddress", function(e) {
                e.addFragment(n.MailingAddressFragment);
              }),
              e.add("shippingLine", function(e) {
                e.add("handle"), e.add("price"), e.add("title");
              }),
              e.add("customAttributes", function(e) {
                e.add("key"), e.add("value");
              }),
              e.add("order", function(e) {
                e.add("id"),
                  e.add("processedAt"),
                  e.add("orderNumber"),
                  e.add("subtotalPrice"),
                  e.add("totalShippingPrice"),
                  e.add("totalTax"),
                  e.add("totalPrice"),
                  e.add("currencyCode"),
                  e.add("totalRefunded"),
                  e.add("customerUrl"),
                  e.add("shippingAddress", function(e) {
                    e.addFragment(n.MailingAddressFragment);
                  }),
                  e.add("lineItems", { args: { first: 250 } }, function(e) {
                    e.add("pageInfo", function(e) {
                      e.add("hasNextPage"), e.add("hasPreviousPage");
                    }),
                      e.add("edges", function(e) {
                        e.add("cursor"),
                          e.add("node", function(e) {
                            e.add("title"),
                              e.add("variant", function(e) {
                                e.addFragment(n.VariantWithProductFragment);
                              }),
                              e.add("quantity"),
                              e.add("customAttributes", function(e) {
                                e.add("key"), e.add("value");
                              });
                          });
                      });
                  });
              }),
              e.add("lineItems", { args: { first: 250 } }, function(e) {
                e.add("pageInfo", function(e) {
                  e.add("hasNextPage"), e.add("hasPreviousPage");
                }),
                  e.add("edges", function(e) {
                    e.add("cursor"),
                      e.add("node", function(e) {
                        e.add("id"),
                          e.add("title"),
                          e.add("variant", function(e) {
                            e.addFragment(n.VariantWithProductFragment);
                          }),
                          e.add("quantity"),
                          e.add("customAttributes", function(e) {
                            e.add("key"), e.add("value");
                          }),
                          e.add("discountAllocations", function(e) {
                            e.add("allocatedAmount", function(e) {
                              e.add("amount"), e.add("currencyCode");
                            }),
                              e.add("discountApplication", function(e) {
                                e.addFragment(n.DiscountApplicationFragment);
                              });
                          });
                      });
                  });
              });
          }
        )),
        t.addMutation(
          "checkoutGiftCardsAppend",
          [
            a.checkoutGiftCardsAppend.giftCardCodes,
            a.checkoutGiftCardsAppend.checkoutId
          ],
          function(e) {
            e.add(
              "checkoutGiftCardsAppend",
              {
                args: {
                  giftCardCodes: a.checkoutGiftCardsAppend.giftCardCodes,
                  checkoutId: a.checkoutGiftCardsAppend.checkoutId
                }
              },
              function(e) {
                e.add("userErrors", function(e) {
                  e.addFragment(n.UserErrorFragment);
                }),
                  e.add("checkoutUserErrors", function(e) {
                    e.addFragment(n.CheckoutUserErrorFragment);
                  }),
                  e.add("checkout", function(e) {
                    e.addFragment(n.CheckoutFragment);
                  });
              }
            );
          }
        ),
        t
      );
    }
    function Be(e) {
      var t = e.document(),
        n = {},
        a = { checkoutGiftCardRemoveV2: {} };
      return (
        (a.checkoutGiftCardRemoveV2.appliedGiftCardId = e.variable(
          "appliedGiftCardId",
          "ID!"
        )),
        (a.checkoutGiftCardRemoveV2.checkoutId = e.variable(
          "checkoutId",
          "ID!"
        )),
        (n.VariantFragment = t.defineFragment(
          "VariantFragment",
          "ProductVariant",
          function(e) {
            e.add("id"),
              e.add("title"),
              e.add("price"),
              e.add("weight"),
              e.add("availableForSale", { alias: "available" }),
              e.add("sku"),
              e.add("compareAtPrice"),
              e.add("image", function(e) {
                e.add("id"),
                  e.add("originalSrc", { alias: "src" }),
                  e.add("altText");
              }),
              e.add("selectedOptions", function(e) {
                e.add("name"), e.add("value");
              });
          }
        )),
        (n.DiscountApplicationFragment = t.defineFragment(
          "DiscountApplicationFragment",
          "DiscountApplication",
          function(e) {
            e.add("targetSelection"),
              e.add("allocationMethod"),
              e.add("targetType"),
              e.addInlineFragmentOn("ManualDiscountApplication", function(e) {
                e.add("title"), e.add("description");
              }),
              e.addInlineFragmentOn("DiscountCodeApplication", function(e) {
                e.add("code"), e.add("applicable");
              }),
              e.addInlineFragmentOn("ScriptDiscountApplication", function(e) {
                e.add("description");
              }),
              e.addInlineFragmentOn("AutomaticDiscountApplication", function(
                e
              ) {
                e.add("title");
              });
          }
        )),
        (n.AppliedGiftCardFragment = t.defineFragment(
          "AppliedGiftCardFragment",
          "AppliedGiftCard",
          function(e) {
            e.add("amountUsedV2", function(e) {
              e.add("amount"), e.add("currencyCode");
            }),
              e.add("balanceV2", function(e) {
                e.add("amount"), e.add("currencyCode");
              }),
              e.add("id"),
              e.add("lastCharacters");
          }
        )),
        (n.VariantWithProductFragment = t.defineFragment(
          "VariantWithProductFragment",
          "ProductVariant",
          function(e) {
            e.addFragment(n.VariantFragment),
              e.add("product", function(e) {
                e.add("id");
              });
          }
        )),
        (n.UserErrorFragment = t.defineFragment(
          "UserErrorFragment",
          "UserError",
          function(e) {
            e.add("field"), e.add("message");
          }
        )),
        (n.CheckoutUserErrorFragment = t.defineFragment(
          "CheckoutUserErrorFragment",
          "CheckoutUserError",
          function(e) {
            e.add("field"), e.add("message"), e.add("code");
          }
        )),
        (n.MailingAddressFragment = t.defineFragment(
          "MailingAddressFragment",
          "MailingAddress",
          function(e) {
            e.add("id"),
              e.add("address1"),
              e.add("address2"),
              e.add("city"),
              e.add("company"),
              e.add("country"),
              e.add("firstName"),
              e.add("formatted"),
              e.add("lastName"),
              e.add("latitude"),
              e.add("longitude"),
              e.add("phone"),
              e.add("province"),
              e.add("zip"),
              e.add("name"),
              e.add("countryCodeV2", { alias: "countryCode" }),
              e.add("provinceCode");
          }
        )),
        (n.CheckoutFragment = t.defineFragment(
          "CheckoutFragment",
          "Checkout",
          function(e) {
            e.add("id"),
              e.add("ready"),
              e.add("requiresShipping"),
              e.add("note"),
              e.add("paymentDue"),
              e.add("webUrl"),
              e.add("orderStatusUrl"),
              e.add("taxExempt"),
              e.add("taxesIncluded"),
              e.add("currencyCode"),
              e.add("totalTax"),
              e.add("lineItemsSubtotalPrice", function(e) {
                e.add("amount"), e.add("currencyCode");
              }),
              e.add("subtotalPrice"),
              e.add("totalPrice"),
              e.add("completedAt"),
              e.add("createdAt"),
              e.add("updatedAt"),
              e.add("email"),
              e.add("discountApplications", { args: { first: 10 } }, function(
                e
              ) {
                e.add("pageInfo", function(e) {
                  e.add("hasNextPage"), e.add("hasPreviousPage");
                }),
                  e.add("edges", function(e) {
                    e.add("node", function(e) {
                      e.addFragment(n.DiscountApplicationFragment);
                    });
                  });
              }),
              e.add("appliedGiftCards", function(e) {
                e.addFragment(n.AppliedGiftCardFragment);
              }),
              e.add("shippingAddress", function(e) {
                e.addFragment(n.MailingAddressFragment);
              }),
              e.add("shippingLine", function(e) {
                e.add("handle"), e.add("price"), e.add("title");
              }),
              e.add("customAttributes", function(e) {
                e.add("key"), e.add("value");
              }),
              e.add("order", function(e) {
                e.add("id"),
                  e.add("processedAt"),
                  e.add("orderNumber"),
                  e.add("subtotalPrice"),
                  e.add("totalShippingPrice"),
                  e.add("totalTax"),
                  e.add("totalPrice"),
                  e.add("currencyCode"),
                  e.add("totalRefunded"),
                  e.add("customerUrl"),
                  e.add("shippingAddress", function(e) {
                    e.addFragment(n.MailingAddressFragment);
                  }),
                  e.add("lineItems", { args: { first: 250 } }, function(e) {
                    e.add("pageInfo", function(e) {
                      e.add("hasNextPage"), e.add("hasPreviousPage");
                    }),
                      e.add("edges", function(e) {
                        e.add("cursor"),
                          e.add("node", function(e) {
                            e.add("title"),
                              e.add("variant", function(e) {
                                e.addFragment(n.VariantWithProductFragment);
                              }),
                              e.add("quantity"),
                              e.add("customAttributes", function(e) {
                                e.add("key"), e.add("value");
                              });
                          });
                      });
                  });
              }),
              e.add("lineItems", { args: { first: 250 } }, function(e) {
                e.add("pageInfo", function(e) {
                  e.add("hasNextPage"), e.add("hasPreviousPage");
                }),
                  e.add("edges", function(e) {
                    e.add("cursor"),
                      e.add("node", function(e) {
                        e.add("id"),
                          e.add("title"),
                          e.add("variant", function(e) {
                            e.addFragment(n.VariantWithProductFragment);
                          }),
                          e.add("quantity"),
                          e.add("customAttributes", function(e) {
                            e.add("key"), e.add("value");
                          }),
                          e.add("discountAllocations", function(e) {
                            e.add("allocatedAmount", function(e) {
                              e.add("amount"), e.add("currencyCode");
                            }),
                              e.add("discountApplication", function(e) {
                                e.addFragment(n.DiscountApplicationFragment);
                              });
                          });
                      });
                  });
              });
          }
        )),
        t.addMutation(
          "checkoutGiftCardRemoveV2",
          [
            a.checkoutGiftCardRemoveV2.appliedGiftCardId,
            a.checkoutGiftCardRemoveV2.checkoutId
          ],
          function(e) {
            e.add(
              "checkoutGiftCardRemoveV2",
              {
                args: {
                  appliedGiftCardId:
                    a.checkoutGiftCardRemoveV2.appliedGiftCardId,
                  checkoutId: a.checkoutGiftCardRemoveV2.checkoutId
                }
              },
              function(e) {
                e.add("userErrors", function(e) {
                  e.addFragment(n.UserErrorFragment);
                }),
                  e.add("checkoutUserErrors", function(e) {
                    e.addFragment(n.CheckoutUserErrorFragment);
                  }),
                  e.add("checkout", function(e) {
                    e.addFragment(n.CheckoutFragment);
                  });
              }
            );
          }
        ),
        t
      );
    }
    function je(e) {
      var t = e.document(),
        n = {},
        a = { checkoutEmailUpdateV2: {} };
      return (
        (a.checkoutEmailUpdateV2.checkoutId = e.variable("checkoutId", "ID!")),
        (a.checkoutEmailUpdateV2.email = e.variable("email", "String!")),
        (n.VariantFragment = t.defineFragment(
          "VariantFragment",
          "ProductVariant",
          function(e) {
            e.add("id"),
              e.add("title"),
              e.add("price"),
              e.add("weight"),
              e.add("availableForSale", { alias: "available" }),
              e.add("sku"),
              e.add("compareAtPrice"),
              e.add("image", function(e) {
                e.add("id"),
                  e.add("originalSrc", { alias: "src" }),
                  e.add("altText");
              }),
              e.add("selectedOptions", function(e) {
                e.add("name"), e.add("value");
              });
          }
        )),
        (n.DiscountApplicationFragment = t.defineFragment(
          "DiscountApplicationFragment",
          "DiscountApplication",
          function(e) {
            e.add("targetSelection"),
              e.add("allocationMethod"),
              e.add("targetType"),
              e.addInlineFragmentOn("ManualDiscountApplication", function(e) {
                e.add("title"), e.add("description");
              }),
              e.addInlineFragmentOn("DiscountCodeApplication", function(e) {
                e.add("code"), e.add("applicable");
              }),
              e.addInlineFragmentOn("ScriptDiscountApplication", function(e) {
                e.add("description");
              }),
              e.addInlineFragmentOn("AutomaticDiscountApplication", function(
                e
              ) {
                e.add("title");
              });
          }
        )),
        (n.AppliedGiftCardFragment = t.defineFragment(
          "AppliedGiftCardFragment",
          "AppliedGiftCard",
          function(e) {
            e.add("amountUsedV2", function(e) {
              e.add("amount"), e.add("currencyCode");
            }),
              e.add("balanceV2", function(e) {
                e.add("amount"), e.add("currencyCode");
              }),
              e.add("id"),
              e.add("lastCharacters");
          }
        )),
        (n.VariantWithProductFragment = t.defineFragment(
          "VariantWithProductFragment",
          "ProductVariant",
          function(e) {
            e.addFragment(n.VariantFragment),
              e.add("product", function(e) {
                e.add("id");
              });
          }
        )),
        (n.UserErrorFragment = t.defineFragment(
          "UserErrorFragment",
          "UserError",
          function(e) {
            e.add("field"), e.add("message");
          }
        )),
        (n.CheckoutUserErrorFragment = t.defineFragment(
          "CheckoutUserErrorFragment",
          "CheckoutUserError",
          function(e) {
            e.add("field"), e.add("message"), e.add("code");
          }
        )),
        (n.MailingAddressFragment = t.defineFragment(
          "MailingAddressFragment",
          "MailingAddress",
          function(e) {
            e.add("id"),
              e.add("address1"),
              e.add("address2"),
              e.add("city"),
              e.add("company"),
              e.add("country"),
              e.add("firstName"),
              e.add("formatted"),
              e.add("lastName"),
              e.add("latitude"),
              e.add("longitude"),
              e.add("phone"),
              e.add("province"),
              e.add("zip"),
              e.add("name"),
              e.add("countryCodeV2", { alias: "countryCode" }),
              e.add("provinceCode");
          }
        )),
        (n.CheckoutFragment = t.defineFragment(
          "CheckoutFragment",
          "Checkout",
          function(e) {
            e.add("id"),
              e.add("ready"),
              e.add("requiresShipping"),
              e.add("note"),
              e.add("paymentDue"),
              e.add("webUrl"),
              e.add("orderStatusUrl"),
              e.add("taxExempt"),
              e.add("taxesIncluded"),
              e.add("currencyCode"),
              e.add("totalTax"),
              e.add("lineItemsSubtotalPrice", function(e) {
                e.add("amount"), e.add("currencyCode");
              }),
              e.add("subtotalPrice"),
              e.add("totalPrice"),
              e.add("completedAt"),
              e.add("createdAt"),
              e.add("updatedAt"),
              e.add("email"),
              e.add("discountApplications", { args: { first: 10 } }, function(
                e
              ) {
                e.add("pageInfo", function(e) {
                  e.add("hasNextPage"), e.add("hasPreviousPage");
                }),
                  e.add("edges", function(e) {
                    e.add("node", function(e) {
                      e.addFragment(n.DiscountApplicationFragment);
                    });
                  });
              }),
              e.add("appliedGiftCards", function(e) {
                e.addFragment(n.AppliedGiftCardFragment);
              }),
              e.add("shippingAddress", function(e) {
                e.addFragment(n.MailingAddressFragment);
              }),
              e.add("shippingLine", function(e) {
                e.add("handle"), e.add("price"), e.add("title");
              }),
              e.add("customAttributes", function(e) {
                e.add("key"), e.add("value");
              }),
              e.add("order", function(e) {
                e.add("id"),
                  e.add("processedAt"),
                  e.add("orderNumber"),
                  e.add("subtotalPrice"),
                  e.add("totalShippingPrice"),
                  e.add("totalTax"),
                  e.add("totalPrice"),
                  e.add("currencyCode"),
                  e.add("totalRefunded"),
                  e.add("customerUrl"),
                  e.add("shippingAddress", function(e) {
                    e.addFragment(n.MailingAddressFragment);
                  }),
                  e.add("lineItems", { args: { first: 250 } }, function(e) {
                    e.add("pageInfo", function(e) {
                      e.add("hasNextPage"), e.add("hasPreviousPage");
                    }),
                      e.add("edges", function(e) {
                        e.add("cursor"),
                          e.add("node", function(e) {
                            e.add("title"),
                              e.add("variant", function(e) {
                                e.addFragment(n.VariantWithProductFragment);
                              }),
                              e.add("quantity"),
                              e.add("customAttributes", function(e) {
                                e.add("key"), e.add("value");
                              });
                          });
                      });
                  });
              }),
              e.add("lineItems", { args: { first: 250 } }, function(e) {
                e.add("pageInfo", function(e) {
                  e.add("hasNextPage"), e.add("hasPreviousPage");
                }),
                  e.add("edges", function(e) {
                    e.add("cursor"),
                      e.add("node", function(e) {
                        e.add("id"),
                          e.add("title"),
                          e.add("variant", function(e) {
                            e.addFragment(n.VariantWithProductFragment);
                          }),
                          e.add("quantity"),
                          e.add("customAttributes", function(e) {
                            e.add("key"), e.add("value");
                          }),
                          e.add("discountAllocations", function(e) {
                            e.add("allocatedAmount", function(e) {
                              e.add("amount"), e.add("currencyCode");
                            }),
                              e.add("discountApplication", function(e) {
                                e.addFragment(n.DiscountApplicationFragment);
                              });
                          });
                      });
                  });
              });
          }
        )),
        t.addMutation(
          "checkoutEmailUpdateV2",
          [a.checkoutEmailUpdateV2.checkoutId, a.checkoutEmailUpdateV2.email],
          function(e) {
            e.add(
              "checkoutEmailUpdateV2",
              {
                args: {
                  checkoutId: a.checkoutEmailUpdateV2.checkoutId,
                  email: a.checkoutEmailUpdateV2.email
                }
              },
              function(e) {
                e.add("userErrors", function(e) {
                  e.addFragment(n.UserErrorFragment);
                }),
                  e.add("checkoutUserErrors", function(e) {
                    e.addFragment(n.CheckoutUserErrorFragment);
                  }),
                  e.add("checkout", function(e) {
                    e.addFragment(n.CheckoutFragment);
                  });
              }
            );
          }
        ),
        t
      );
    }
    function qe(e) {
      var t = e.document(),
        n = {},
        a = { checkoutShippingAddressUpdateV2: {} };
      return (
        (a.checkoutShippingAddressUpdateV2.shippingAddress = e.variable(
          "shippingAddress",
          "MailingAddressInput!"
        )),
        (a.checkoutShippingAddressUpdateV2.checkoutId = e.variable(
          "checkoutId",
          "ID!"
        )),
        (n.VariantFragment = t.defineFragment(
          "VariantFragment",
          "ProductVariant",
          function(e) {
            e.add("id"),
              e.add("title"),
              e.add("price"),
              e.add("weight"),
              e.add("availableForSale", { alias: "available" }),
              e.add("sku"),
              e.add("compareAtPrice"),
              e.add("image", function(e) {
                e.add("id"),
                  e.add("originalSrc", { alias: "src" }),
                  e.add("altText");
              }),
              e.add("selectedOptions", function(e) {
                e.add("name"), e.add("value");
              });
          }
        )),
        (n.DiscountApplicationFragment = t.defineFragment(
          "DiscountApplicationFragment",
          "DiscountApplication",
          function(e) {
            e.add("targetSelection"),
              e.add("allocationMethod"),
              e.add("targetType"),
              e.addInlineFragmentOn("ManualDiscountApplication", function(e) {
                e.add("title"), e.add("description");
              }),
              e.addInlineFragmentOn("DiscountCodeApplication", function(e) {
                e.add("code"), e.add("applicable");
              }),
              e.addInlineFragmentOn("ScriptDiscountApplication", function(e) {
                e.add("description");
              }),
              e.addInlineFragmentOn("AutomaticDiscountApplication", function(
                e
              ) {
                e.add("title");
              });
          }
        )),
        (n.AppliedGiftCardFragment = t.defineFragment(
          "AppliedGiftCardFragment",
          "AppliedGiftCard",
          function(e) {
            e.add("amountUsedV2", function(e) {
              e.add("amount"), e.add("currencyCode");
            }),
              e.add("balanceV2", function(e) {
                e.add("amount"), e.add("currencyCode");
              }),
              e.add("id"),
              e.add("lastCharacters");
          }
        )),
        (n.VariantWithProductFragment = t.defineFragment(
          "VariantWithProductFragment",
          "ProductVariant",
          function(e) {
            e.addFragment(n.VariantFragment),
              e.add("product", function(e) {
                e.add("id");
              });
          }
        )),
        (n.UserErrorFragment = t.defineFragment(
          "UserErrorFragment",
          "UserError",
          function(e) {
            e.add("field"), e.add("message");
          }
        )),
        (n.CheckoutUserErrorFragment = t.defineFragment(
          "CheckoutUserErrorFragment",
          "CheckoutUserError",
          function(e) {
            e.add("field"), e.add("message"), e.add("code");
          }
        )),
        (n.MailingAddressFragment = t.defineFragment(
          "MailingAddressFragment",
          "MailingAddress",
          function(e) {
            e.add("id"),
              e.add("address1"),
              e.add("address2"),
              e.add("city"),
              e.add("company"),
              e.add("country"),
              e.add("firstName"),
              e.add("formatted"),
              e.add("lastName"),
              e.add("latitude"),
              e.add("longitude"),
              e.add("phone"),
              e.add("province"),
              e.add("zip"),
              e.add("name"),
              e.add("countryCodeV2", { alias: "countryCode" }),
              e.add("provinceCode");
          }
        )),
        (n.CheckoutFragment = t.defineFragment(
          "CheckoutFragment",
          "Checkout",
          function(e) {
            e.add("id"),
              e.add("ready"),
              e.add("requiresShipping"),
              e.add("note"),
              e.add("paymentDue"),
              e.add("webUrl"),
              e.add("orderStatusUrl"),
              e.add("taxExempt"),
              e.add("taxesIncluded"),
              e.add("currencyCode"),
              e.add("totalTax"),
              e.add("lineItemsSubtotalPrice", function(e) {
                e.add("amount"), e.add("currencyCode");
              }),
              e.add("subtotalPrice"),
              e.add("totalPrice"),
              e.add("completedAt"),
              e.add("createdAt"),
              e.add("updatedAt"),
              e.add("email"),
              e.add("discountApplications", { args: { first: 10 } }, function(
                e
              ) {
                e.add("pageInfo", function(e) {
                  e.add("hasNextPage"), e.add("hasPreviousPage");
                }),
                  e.add("edges", function(e) {
                    e.add("node", function(e) {
                      e.addFragment(n.DiscountApplicationFragment);
                    });
                  });
              }),
              e.add("appliedGiftCards", function(e) {
                e.addFragment(n.AppliedGiftCardFragment);
              }),
              e.add("shippingAddress", function(e) {
                e.addFragment(n.MailingAddressFragment);
              }),
              e.add("shippingLine", function(e) {
                e.add("handle"), e.add("price"), e.add("title");
              }),
              e.add("customAttributes", function(e) {
                e.add("key"), e.add("value");
              }),
              e.add("order", function(e) {
                e.add("id"),
                  e.add("processedAt"),
                  e.add("orderNumber"),
                  e.add("subtotalPrice"),
                  e.add("totalShippingPrice"),
                  e.add("totalTax"),
                  e.add("totalPrice"),
                  e.add("currencyCode"),
                  e.add("totalRefunded"),
                  e.add("customerUrl"),
                  e.add("shippingAddress", function(e) {
                    e.addFragment(n.MailingAddressFragment);
                  }),
                  e.add("lineItems", { args: { first: 250 } }, function(e) {
                    e.add("pageInfo", function(e) {
                      e.add("hasNextPage"), e.add("hasPreviousPage");
                    }),
                      e.add("edges", function(e) {
                        e.add("cursor"),
                          e.add("node", function(e) {
                            e.add("title"),
                              e.add("variant", function(e) {
                                e.addFragment(n.VariantWithProductFragment);
                              }),
                              e.add("quantity"),
                              e.add("customAttributes", function(e) {
                                e.add("key"), e.add("value");
                              });
                          });
                      });
                  });
              }),
              e.add("lineItems", { args: { first: 250 } }, function(e) {
                e.add("pageInfo", function(e) {
                  e.add("hasNextPage"), e.add("hasPreviousPage");
                }),
                  e.add("edges", function(e) {
                    e.add("cursor"),
                      e.add("node", function(e) {
                        e.add("id"),
                          e.add("title"),
                          e.add("variant", function(e) {
                            e.addFragment(n.VariantWithProductFragment);
                          }),
                          e.add("quantity"),
                          e.add("customAttributes", function(e) {
                            e.add("key"), e.add("value");
                          }),
                          e.add("discountAllocations", function(e) {
                            e.add("allocatedAmount", function(e) {
                              e.add("amount"), e.add("currencyCode");
                            }),
                              e.add("discountApplication", function(e) {
                                e.addFragment(n.DiscountApplicationFragment);
                              });
                          });
                      });
                  });
              });
          }
        )),
        t.addMutation(
          "checkoutShippingAddressUpdateV2",
          [
            a.checkoutShippingAddressUpdateV2.shippingAddress,
            a.checkoutShippingAddressUpdateV2.checkoutId
          ],
          function(e) {
            e.add(
              "checkoutShippingAddressUpdateV2",
              {
                args: {
                  shippingAddress:
                    a.checkoutShippingAddressUpdateV2.shippingAddress,
                  checkoutId: a.checkoutShippingAddressUpdateV2.checkoutId
                }
              },
              function(e) {
                e.add("userErrors", function(e) {
                  e.addFragment(n.UserErrorFragment);
                }),
                  e.add("checkoutUserErrors", function(e) {
                    e.addFragment(n.CheckoutUserErrorFragment);
                  }),
                  e.add("checkout", function(e) {
                    e.addFragment(n.CheckoutFragment);
                  });
              }
            );
          }
        ),
        t
      );
    }
    var Re = (function(e) {
        function t() {
          return (
            d(this, t),
            o(
              this,
              (t.__proto__ || Object.getPrototypeOf(t)).apply(this, arguments)
            )
          );
        }
        return (
          r(t, oe),
          i(t, [
            {
              key: "fetch",
              value: function(e) {
                var t = this;
                return this.graphQLClient
                  .send(Ee, { id: e })
                  .then(se("node"))
                  .then(function(e) {
                    return e
                      ? t.graphQLClient
                          .fetchAllPages(e.lineItems, { pageSize: 250 })
                          .then(function(t) {
                            return (e.attrs.lineItems = t), e;
                          })
                      : null;
                  });
              }
            },
            {
              key: "create",
              value: function() {
                var e =
                  arguments.length > 0 && void 0 !== arguments[0]
                    ? arguments[0]
                    : {};
                return this.graphQLClient
                  .send(we, { input: e })
                  .then(Ie("checkoutCreate", this.graphQLClient));
              }
            },
            {
              key: "updateAttributes",
              value: function(e) {
                var t =
                  arguments.length > 1 && void 0 !== arguments[1]
                    ? arguments[1]
                    : {};
                return this.graphQLClient
                  .send(Ue, { checkoutId: e, input: t })
                  .then(Ie("checkoutAttributesUpdateV2", this.graphQLClient));
              }
            },
            {
              key: "updateEmail",
              value: function(e, t) {
                return this.graphQLClient
                  .send(je, { checkoutId: e, email: t })
                  .then(Ie("checkoutEmailUpdateV2", this.graphQLClient));
              }
            },
            {
              key: "addLineItems",
              value: function(e, t) {
                return this.graphQLClient
                  .send(xe, { checkoutId: e, lineItems: t })
                  .then(Ie("checkoutLineItemsAdd", this.graphQLClient));
              }
            },
            {
              key: "addDiscount",
              value: function(e, t) {
                return this.graphQLClient
                  .send(Me, { checkoutId: e, discountCode: t })
                  .then(Ie("checkoutDiscountCodeApplyV2", this.graphQLClient));
              }
            },
            {
              key: "removeDiscount",
              value: function(e) {
                return this.graphQLClient
                  .send(Ne, { checkoutId: e })
                  .then(Ie("checkoutDiscountCodeRemove", this.graphQLClient));
              }
            },
            {
              key: "addGiftCards",
              value: function(e, t) {
                return this.graphQLClient
                  .send(Le, { checkoutId: e, giftCardCodes: t })
                  .then(Ie("checkoutGiftCardsAppend", this.graphQLClient));
              }
            },
            {
              key: "removeGiftCard",
              value: function(e, t) {
                return this.graphQLClient
                  .send(Be, { checkoutId: e, appliedGiftCardId: t })
                  .then(Ie("checkoutGiftCardRemoveV2", this.graphQLClient));
              }
            },
            {
              key: "removeLineItems",
              value: function(e, t) {
                return this.graphQLClient
                  .send(Te, { checkoutId: e, lineItemIds: t })
                  .then(Ie("checkoutLineItemsRemove", this.graphQLClient));
              }
            },
            {
              key: "replaceLineItems",
              value: function(e, t) {
                return this.graphQLClient
                  .send(De, { checkoutId: e, lineItems: t })
                  .then(Ie("checkoutLineItemsReplace", this.graphQLClient));
              }
            },
            {
              key: "updateLineItems",
              value: function(e, t) {
                return this.graphQLClient
                  .send(Ve, { checkoutId: e, lineItems: t })
                  .then(Ie("checkoutLineItemsUpdate", this.graphQLClient));
              }
            },
            {
              key: "updateShippingAddress",
              value: function(e, t) {
                return this.graphQLClient
                  .send(qe, { checkoutId: e, shippingAddress: t })
                  .then(
                    Ie("checkoutShippingAddressUpdateV2", this.graphQLClient)
                  );
              }
            }
          ]),
          t
        );
      })(),
      Ge = {
        imageForSize: function(e, t) {
          var n = t.maxWidth,
            a = t.maxHeight,
            d = e.src.split("?"),
            i = d[0],
            r = d[1] ? "?" + d[1] : "",
            o = i.split("."),
            c = o.length - 2;
          return (o[c] = o[c] + "_" + n + "x" + a), "" + o.join(".") + r;
        }
      },
      Qe = (function(e) {
        function t() {
          return (
            d(this, t),
            o(
              this,
              (t.__proto__ || Object.getPrototypeOf(t)).apply(this, arguments)
            )
          );
        }
        return (
          r(t, oe),
          i(t, [
            {
              key: "helpers",
              get: function() {
                return Ge;
              }
            }
          ]),
          t
        );
      })(),
      He = "2.2.3",
      We = { types: {} };
    (We.types.Boolean = { name: "Boolean", kind: "SCALAR" }),
      (We.types.String = { name: "String", kind: "SCALAR" }),
      (We.types.QueryRoot = {
        name: "QueryRoot",
        kind: "OBJECT",
        fieldBaseTypes: {
          collectionByHandle: "Collection",
          collections: "CollectionConnection",
          node: "Node",
          nodes: "Node",
          productByHandle: "Product",
          products: "ProductConnection",
          shop: "Shop"
        },
        implementsNode: !1
      }),
      (We.types.Node = {
        name: "Node",
        kind: "INTERFACE",
        fieldBaseTypes: {},
        possibleTypes: [
          "AppliedGiftCard",
          "Article",
          "Blog",
          "Checkout",
          "CheckoutLineItem",
          "Collection",
          "Comment",
          "MailingAddress",
          "Order",
          "Page",
          "Payment",
          "Product",
          "ProductOption",
          "ProductVariant",
          "ShopPolicy"
        ]
      }),
      (We.types.ID = { name: "ID", kind: "SCALAR" }),
      (We.types.DateTime = { name: "DateTime", kind: "SCALAR" }),
      (We.types.MailingAddress = {
        name: "MailingAddress",
        kind: "OBJECT",
        fieldBaseTypes: {
          address1: "String",
          address2: "String",
          city: "String",
          company: "String",
          country: "String",
          countryCodeV2: "CountryCode",
          firstName: "String",
          formatted: "String",
          id: "ID",
          lastName: "String",
          latitude: "Float",
          longitude: "Float",
          name: "String",
          phone: "String",
          province: "String",
          provinceCode: "String",
          zip: "String"
        },
        implementsNode: !0
      }),
      (We.types.Float = { name: "Float", kind: "SCALAR" }),
      (We.types.CountryCode = { name: "CountryCode", kind: "ENUM" }),
      (We.types.PageInfo = {
        name: "PageInfo",
        kind: "OBJECT",
        fieldBaseTypes: { hasNextPage: "Boolean", hasPreviousPage: "Boolean" },
        implementsNode: !1
      }),
      (We.types.Int = { name: "Int", kind: "SCALAR" }),
      (We.types.Order = {
        name: "Order",
        kind: "OBJECT",
        fieldBaseTypes: {
          currencyCode: "CurrencyCode",
          customerUrl: "URL",
          id: "ID",
          lineItems: "OrderLineItemConnection",
          orderNumber: "Int",
          processedAt: "DateTime",
          shippingAddress: "MailingAddress",
          subtotalPrice: "Money",
          totalPrice: "Money",
          totalRefunded: "Money",
          totalShippingPrice: "Money",
          totalTax: "Money"
        },
        implementsNode: !0
      }),
      (We.types.Money = { name: "Money", kind: "SCALAR" }),
      (We.types.MoneyV2 = {
        name: "MoneyV2",
        kind: "OBJECT",
        fieldBaseTypes: { amount: "Decimal", currencyCode: "CurrencyCode" },
        implementsNode: !1
      }),
      (We.types.Decimal = { name: "Decimal", kind: "SCALAR" }),
      (We.types.CurrencyCode = { name: "CurrencyCode", kind: "ENUM" }),
      (We.types.URL = { name: "URL", kind: "SCALAR" }),
      (We.types.DiscountAllocation = {
        name: "DiscountAllocation",
        kind: "OBJECT",
        fieldBaseTypes: {
          allocatedAmount: "MoneyV2",
          discountApplication: "DiscountApplication"
        },
        implementsNode: !1
      }),
      (We.types.DiscountApplication = {
        name: "DiscountApplication",
        kind: "INTERFACE",
        fieldBaseTypes: {
          allocationMethod: "DiscountApplicationAllocationMethod",
          targetSelection: "DiscountApplicationTargetSelection",
          targetType: "DiscountApplicationTargetType"
        },
        possibleTypes: [
          "AutomaticDiscountApplication",
          "DiscountCodeApplication",
          "ManualDiscountApplication",
          "ScriptDiscountApplication"
        ]
      }),
      (We.types.DiscountApplicationAllocationMethod = {
        name: "DiscountApplicationAllocationMethod",
        kind: "ENUM"
      }),
      (We.types.DiscountApplicationTargetSelection = {
        name: "DiscountApplicationTargetSelection",
        kind: "ENUM"
      }),
      (We.types.DiscountApplicationTargetType = {
        name: "DiscountApplicationTargetType",
        kind: "ENUM"
      }),
      (We.types.OrderLineItemConnection = {
        name: "OrderLineItemConnection",
        kind: "OBJECT",
        fieldBaseTypes: { edges: "OrderLineItemEdge", pageInfo: "PageInfo" },
        implementsNode: !1
      }),
      (We.types.OrderLineItemEdge = {
        name: "OrderLineItemEdge",
        kind: "OBJECT",
        fieldBaseTypes: { cursor: "String", node: "OrderLineItem" },
        implementsNode: !1
      }),
      (We.types.OrderLineItem = {
        name: "OrderLineItem",
        kind: "OBJECT",
        fieldBaseTypes: {
          customAttributes: "Attribute",
          quantity: "Int",
          title: "String",
          variant: "ProductVariant"
        },
        implementsNode: !1
      }),
      (We.types.ProductVariant = {
        name: "ProductVariant",
        kind: "OBJECT",
        fieldBaseTypes: {
          availableForSale: "Boolean",
          compareAtPrice: "Money",
          id: "ID",
          image: "Image",
          price: "Money",
          product: "Product",
          selectedOptions: "SelectedOption",
          sku: "String",
          title: "String",
          weight: "Float"
        },
        implementsNode: !0
      }),
      (We.types.Product = {
        name: "Product",
        kind: "OBJECT",
        fieldBaseTypes: {
          availableForSale: "Boolean",
          createdAt: "DateTime",
          description: "String",
          descriptionHtml: "HTML",
          handle: "String",
          id: "ID",
          images: "ImageConnection",
          onlineStoreUrl: "URL",
          options: "ProductOption",
          productType: "String",
          publishedAt: "DateTime",
          title: "String",
          updatedAt: "DateTime",
          variants: "ProductVariantConnection",
          vendor: "String"
        },
        implementsNode: !0
      }),
      (We.types.CollectionConnection = {
        name: "CollectionConnection",
        kind: "OBJECT",
        fieldBaseTypes: { edges: "CollectionEdge", pageInfo: "PageInfo" },
        implementsNode: !1
      }),
      (We.types.CollectionEdge = {
        name: "CollectionEdge",
        kind: "OBJECT",
        fieldBaseTypes: { cursor: "String", node: "Collection" },
        implementsNode: !1
      }),
      (We.types.Collection = {
        name: "Collection",
        kind: "OBJECT",
        fieldBaseTypes: {
          description: "String",
          descriptionHtml: "HTML",
          handle: "String",
          id: "ID",
          image: "Image",
          products: "ProductConnection",
          title: "String",
          updatedAt: "DateTime"
        },
        implementsNode: !0
      }),
      (We.types.HTML = { name: "HTML", kind: "SCALAR" }),
      (We.types.Image = {
        name: "Image",
        kind: "OBJECT",
        fieldBaseTypes: {
          altText: "String",
          id: "ID",
          originalSrc: "URL",
          src: "URL"
        },
        implementsNode: !1
      }),
      (We.types.ProductConnection = {
        name: "ProductConnection",
        kind: "OBJECT",
        fieldBaseTypes: { edges: "ProductEdge", pageInfo: "PageInfo" },
        implementsNode: !1
      }),
      (We.types.ProductEdge = {
        name: "ProductEdge",
        kind: "OBJECT",
        fieldBaseTypes: { cursor: "String", node: "Product" },
        implementsNode: !1
      }),
      (We.types.ImageConnection = {
        name: "ImageConnection",
        kind: "OBJECT",
        fieldBaseTypes: { edges: "ImageEdge", pageInfo: "PageInfo" },
        implementsNode: !1
      }),
      (We.types.ImageEdge = {
        name: "ImageEdge",
        kind: "OBJECT",
        fieldBaseTypes: { cursor: "String", node: "Image" },
        implementsNode: !1
      }),
      (We.types.ProductOption = {
        name: "ProductOption",
        kind: "OBJECT",
        fieldBaseTypes: { name: "String", values: "String" },
        implementsNode: !0
      }),
      (We.types.ProductVariantConnection = {
        name: "ProductVariantConnection",
        kind: "OBJECT",
        fieldBaseTypes: { edges: "ProductVariantEdge", pageInfo: "PageInfo" },
        implementsNode: !1
      }),
      (We.types.ProductVariantEdge = {
        name: "ProductVariantEdge",
        kind: "OBJECT",
        fieldBaseTypes: { cursor: "String", node: "ProductVariant" },
        implementsNode: !1
      }),
      (We.types.SelectedOption = {
        name: "SelectedOption",
        kind: "OBJECT",
        fieldBaseTypes: { name: "String", value: "String" },
        implementsNode: !1
      }),
      (We.types.Attribute = {
        name: "Attribute",
        kind: "OBJECT",
        fieldBaseTypes: { key: "String", value: "String" },
        implementsNode: !1
      }),
      (We.types.DiscountApplicationConnection = {
        name: "DiscountApplicationConnection",
        kind: "OBJECT",
        fieldBaseTypes: {
          edges: "DiscountApplicationEdge",
          pageInfo: "PageInfo"
        },
        implementsNode: !1
      }),
      (We.types.DiscountApplicationEdge = {
        name: "DiscountApplicationEdge",
        kind: "OBJECT",
        fieldBaseTypes: { node: "DiscountApplication" },
        implementsNode: !1
      }),
      (We.types.Checkout = {
        name: "Checkout",
        kind: "OBJECT",
        fieldBaseTypes: {
          appliedGiftCards: "AppliedGiftCard",
          completedAt: "DateTime",
          createdAt: "DateTime",
          currencyCode: "CurrencyCode",
          customAttributes: "Attribute",
          discountApplications: "DiscountApplicationConnection",
          email: "String",
          id: "ID",
          lineItems: "CheckoutLineItemConnection",
          lineItemsSubtotalPrice: "MoneyV2",
          note: "String",
          order: "Order",
          orderStatusUrl: "URL",
          paymentDue: "Money",
          ready: "Boolean",
          requiresShipping: "Boolean",
          shippingAddress: "MailingAddress",
          shippingLine: "ShippingRate",
          subtotalPrice: "Money",
          taxExempt: "Boolean",
          taxesIncluded: "Boolean",
          totalPrice: "Money",
          totalTax: "Money",
          updatedAt: "DateTime",
          webUrl: "URL"
        },
        implementsNode: !0
      }),
      (We.types.CheckoutLineItemConnection = {
        name: "CheckoutLineItemConnection",
        kind: "OBJECT",
        fieldBaseTypes: { edges: "CheckoutLineItemEdge", pageInfo: "PageInfo" },
        implementsNode: !1
      }),
      (We.types.CheckoutLineItemEdge = {
        name: "CheckoutLineItemEdge",
        kind: "OBJECT",
        fieldBaseTypes: { cursor: "String", node: "CheckoutLineItem" },
        implementsNode: !1
      }),
      (We.types.CheckoutLineItem = {
        name: "CheckoutLineItem",
        kind: "OBJECT",
        fieldBaseTypes: {
          customAttributes: "Attribute",
          discountAllocations: "DiscountAllocation",
          id: "ID",
          quantity: "Int",
          title: "String",
          variant: "ProductVariant"
        },
        implementsNode: !0
      }),
      (We.types.ShippingRate = {
        name: "ShippingRate",
        kind: "OBJECT",
        fieldBaseTypes: { handle: "String", price: "Money", title: "String" },
        implementsNode: !1
      }),
      (We.types.AppliedGiftCard = {
        name: "AppliedGiftCard",
        kind: "OBJECT",
        fieldBaseTypes: {
          amountUsedV2: "MoneyV2",
          balanceV2: "MoneyV2",
          id: "ID",
          lastCharacters: "String"
        },
        implementsNode: !0
      }),
      (We.types.Shop = {
        name: "Shop",
        kind: "OBJECT",
        fieldBaseTypes: {
          currencyCode: "CurrencyCode",
          description: "String",
          moneyFormat: "String",
          name: "String",
          primaryDomain: "Domain",
          privacyPolicy: "ShopPolicy",
          refundPolicy: "ShopPolicy",
          termsOfService: "ShopPolicy"
        },
        implementsNode: !1
      }),
      (We.types.Domain = {
        name: "Domain",
        kind: "OBJECT",
        fieldBaseTypes: { host: "String", sslEnabled: "Boolean", url: "URL" },
        implementsNode: !1
      }),
      (We.types.ShopPolicy = {
        name: "ShopPolicy",
        kind: "OBJECT",
        fieldBaseTypes: {
          body: "String",
          id: "ID",
          title: "String",
          url: "URL"
        },
        implementsNode: !0
      }),
      (We.types.Mutation = {
        name: "Mutation",
        kind: "OBJECT",
        fieldBaseTypes: {
          checkoutAttributesUpdateV2: "CheckoutAttributesUpdateV2Payload",
          checkoutCreate: "CheckoutCreatePayload",
          checkoutDiscountCodeApplyV2: "CheckoutDiscountCodeApplyV2Payload",
          checkoutDiscountCodeRemove: "CheckoutDiscountCodeRemovePayload",
          checkoutEmailUpdateV2: "CheckoutEmailUpdateV2Payload",
          checkoutGiftCardRemoveV2: "CheckoutGiftCardRemoveV2Payload",
          checkoutGiftCardsAppend: "CheckoutGiftCardsAppendPayload",
          checkoutLineItemsAdd: "CheckoutLineItemsAddPayload",
          checkoutLineItemsRemove: "CheckoutLineItemsRemovePayload",
          checkoutLineItemsReplace: "CheckoutLineItemsReplacePayload",
          checkoutLineItemsUpdate: "CheckoutLineItemsUpdatePayload",
          checkoutShippingAddressUpdateV2:
            "CheckoutShippingAddressUpdateV2Payload"
        },
        implementsNode: !1,
        relayInputObjectBaseTypes: {
          checkoutAttributesUpdate: "CheckoutAttributesUpdateInput",
          checkoutAttributesUpdateV2: "CheckoutAttributesUpdateV2Input",
          checkoutCreate: "CheckoutCreateInput",
          customerAccessTokenCreate: "CustomerAccessTokenCreateInput",
          customerActivate: "CustomerActivateInput",
          customerCreate: "CustomerCreateInput",
          customerReset: "CustomerResetInput"
        }
      }),
      (We.types.UserError = {
        name: "UserError",
        kind: "OBJECT",
        fieldBaseTypes: { field: "String", message: "String" },
        implementsNode: !1
      }),
      (We.types.CheckoutUserError = {
        name: "CheckoutUserError",
        kind: "OBJECT",
        fieldBaseTypes: {
          code: "CheckoutErrorCode",
          field: "String",
          message: "String"
        },
        implementsNode: !1
      }),
      (We.types.CheckoutErrorCode = {
        name: "CheckoutErrorCode",
        kind: "ENUM"
      }),
      (We.types.CheckoutAttributesUpdateV2Payload = {
        name: "CheckoutAttributesUpdateV2Payload",
        kind: "OBJECT",
        fieldBaseTypes: {
          checkout: "Checkout",
          checkoutUserErrors: "CheckoutUserError",
          userErrors: "UserError"
        },
        implementsNode: !1
      }),
      (We.types.CheckoutDiscountCodeApplyV2Payload = {
        name: "CheckoutDiscountCodeApplyV2Payload",
        kind: "OBJECT",
        fieldBaseTypes: {
          checkout: "Checkout",
          checkoutUserErrors: "CheckoutUserError",
          userErrors: "UserError"
        },
        implementsNode: !1
      }),
      (We.types.CheckoutCreatePayload = {
        name: "CheckoutCreatePayload",
        kind: "OBJECT",
        fieldBaseTypes: {
          checkout: "Checkout",
          checkoutUserErrors: "CheckoutUserError",
          userErrors: "UserError"
        },
        implementsNode: !1
      }),
      (We.types.CheckoutEmailUpdateV2Payload = {
        name: "CheckoutEmailUpdateV2Payload",
        kind: "OBJECT",
        fieldBaseTypes: {
          checkout: "Checkout",
          checkoutUserErrors: "CheckoutUserError",
          userErrors: "UserError"
        },
        implementsNode: !1
      }),
      (We.types.CheckoutDiscountCodeRemovePayload = {
        name: "CheckoutDiscountCodeRemovePayload",
        kind: "OBJECT",
        fieldBaseTypes: {
          checkout: "Checkout",
          checkoutUserErrors: "CheckoutUserError",
          userErrors: "UserError"
        },
        implementsNode: !1
      }),
      (We.types.CheckoutGiftCardsAppendPayload = {
        name: "CheckoutGiftCardsAppendPayload",
        kind: "OBJECT",
        fieldBaseTypes: {
          checkout: "Checkout",
          checkoutUserErrors: "CheckoutUserError",
          userErrors: "UserError"
        },
        implementsNode: !1
      }),
      (We.types.CheckoutGiftCardRemoveV2Payload = {
        name: "CheckoutGiftCardRemoveV2Payload",
        kind: "OBJECT",
        fieldBaseTypes: {
          checkout: "Checkout",
          checkoutUserErrors: "CheckoutUserError",
          userErrors: "UserError"
        },
        implementsNode: !1
      }),
      (We.types.CheckoutLineItemsAddPayload = {
        name: "CheckoutLineItemsAddPayload",
        kind: "OBJECT",
        fieldBaseTypes: {
          checkout: "Checkout",
          checkoutUserErrors: "CheckoutUserError",
          userErrors: "UserError"
        },
        implementsNode: !1
      }),
      (We.types.CheckoutLineItemsRemovePayload = {
        name: "CheckoutLineItemsRemovePayload",
        kind: "OBJECT",
        fieldBaseTypes: {
          checkout: "Checkout",
          checkoutUserErrors: "CheckoutUserError",
          userErrors: "UserError"
        },
        implementsNode: !1
      }),
      (We.types.CheckoutLineItemsUpdatePayload = {
        name: "CheckoutLineItemsUpdatePayload",
        kind: "OBJECT",
        fieldBaseTypes: {
          checkout: "Checkout",
          checkoutUserErrors: "CheckoutUserError",
          userErrors: "UserError"
        },
        implementsNode: !1
      }),
      (We.types.CheckoutLineItemsReplacePayload = {
        name: "CheckoutLineItemsReplacePayload",
        kind: "OBJECT",
        fieldBaseTypes: {
          checkout: "Checkout",
          userErrors: "CheckoutUserError"
        },
        implementsNode: !1
      }),
      (We.types.CheckoutShippingAddressUpdateV2Payload = {
        name: "CheckoutShippingAddressUpdateV2Payload",
        kind: "OBJECT",
        fieldBaseTypes: {
          checkout: "Checkout",
          checkoutUserErrors: "CheckoutUserError",
          userErrors: "UserError"
        },
        implementsNode: !1
      }),
      (We.types.DiscountCodeApplication = {
        name: "DiscountCodeApplication",
        kind: "OBJECT",
        fieldBaseTypes: { applicable: "Boolean", code: "String" },
        implementsNode: !1
      }),
      (We.types.ManualDiscountApplication = {
        name: "ManualDiscountApplication",
        kind: "OBJECT",
        fieldBaseTypes: { description: "String", title: "String" },
        implementsNode: !1
      }),
      (We.types.ScriptDiscountApplication = {
        name: "ScriptDiscountApplication",
        kind: "OBJECT",
        fieldBaseTypes: { description: "String" },
        implementsNode: !1
      }),
      (We.types.AutomaticDiscountApplication = {
        name: "AutomaticDiscountApplication",
        kind: "OBJECT",
        fieldBaseTypes: { title: "String" },
        implementsNode: !1
      }),
      (We.queryType = "QueryRoot"),
      (We.mutationType = "Mutation"),
      (We.subscriptionType = null);
    var $e = (function e(t) {
        return (
          Object.getOwnPropertyNames(t).forEach(function(n) {
            var d = t[n];
            d && "object" === (void 0 === d ? "undefined" : a(d)) && e(d);
          }),
          Object.freeze(t),
          t
        );
      })(We),
      Je = (function() {
        function e(t) {
          var n =
              arguments.length > 1 && void 0 !== arguments[1]
                ? arguments[1]
                : ie,
            a = arguments[2];
          d(this, e);
          var i = "https://" + t.domain + "/api/graphql",
            r = {
              "X-SDK-Variant": "javascript",
              "X-SDK-Version": He,
              "X-Shopify-Storefront-Access-Token": t.storefrontAccessToken
            };
          a
            ? ((r["Content-Type"] = "application/json"),
              (r.Accept = "application/json"),
              (this.graphQLClient = new n($e, {
                fetcher: function(e) {
                  return a(i, {
                    body: JSON.stringify(e),
                    method: "POST",
                    mode: "cors",
                    headers: r
                  }).then(function(e) {
                    return e.json();
                  });
                }
              })))
            : (this.graphQLClient = new n($e, {
                url: i,
                fetcherOptions: { headers: r }
              })),
            (this.product = new ve(this.graphQLClient)),
            (this.collection = new Pe(this.graphQLClient)),
            (this.shop = new Oe(this.graphQLClient)),
            (this.checkout = new Re(this.graphQLClient)),
            (this.image = new Qe(this.graphQLClient));
        }
        return (
          i(e, null, [
            {
              key: "buildClient",
              value: function(t, n) {
                var a = new re(t),
                  d = new e(a, ie, n);
                return (d.config = a), d;
              }
            }
          ]),
          i(e, [
            {
              key: "fetchNextPage",
              value: function(e) {
                return this.graphQLClient.fetchNextPage(e);
              }
            }
          ]),
          e
        );
      })();
    e.exports = Je;
  },
  cz0s: function(e, t) {
    !(function(e) {
      if (!e.hasInitialised) {
        var t = {
          escapeRegExp: function(e) {
            return e.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, "\\$&");
          },
          hasClass: function(e, t) {
            var n = " ";
            return (
              1 === e.nodeType &&
              (n + e.className + n).replace(/[\n\t]/g, n).indexOf(n + t + n) >=
                0
            );
          },
          addClass: function(e, t) {
            e.className += " " + t;
          },
          removeClass: function(e, t) {
            var n = new RegExp("\\b" + this.escapeRegExp(t) + "\\b");
            e.className = e.className.replace(n, "");
          },
          interpolateString: function(e, t) {
            return e.replace(/{{([a-z][a-z0-9\-_]*)}}/gi, function(e) {
              return t(arguments[1]) || "";
            });
          },
          getCookie: function(e) {
            var t = ("; " + document.cookie).split("; " + e + "=");
            return t.length < 2
              ? void 0
              : t
                  .pop()
                  .split(";")
                  .shift();
          },
          setCookie: function(e, t, n, a, d, i) {
            var r = new Date();
            r.setDate(r.getDate() + (n || 365));
            var o = [
              e + "=" + t,
              "expires=" + r.toUTCString(),
              "path=" + (d || "/")
            ];
            a && o.push("domain=" + a),
              i && o.push("secure"),
              (document.cookie = o.join(";"));
          },
          deepExtend: function(e, t) {
            for (var n in t)
              t.hasOwnProperty(n) &&
                (n in e && this.isPlainObject(e[n]) && this.isPlainObject(t[n])
                  ? this.deepExtend(e[n], t[n])
                  : (e[n] = t[n]));
            return e;
          },
          throttle: function(e, t) {
            var n = !1;
            return function() {
              n ||
                (e.apply(this, arguments),
                (n = !0),
                setTimeout(function() {
                  n = !1;
                }, t));
            };
          },
          hash: function(e) {
            var t,
              n,
              a = 0;
            if (0 === e.length) return a;
            for (t = 0, n = e.length; t < n; ++t)
              (a = (a << 5) - a + e.charCodeAt(t)), (a |= 0);
            return a;
          },
          normaliseHex: function(e) {
            return (
              "#" == e[0] && (e = e.substr(1)),
              3 == e.length && (e = e[0] + e[0] + e[1] + e[1] + e[2] + e[2]),
              e
            );
          },
          getContrast: function(e) {
            return (
              (e = this.normaliseHex(e)),
              (299 * parseInt(e.substr(0, 2), 16) +
                587 * parseInt(e.substr(2, 2), 16) +
                114 * parseInt(e.substr(4, 2), 16)) /
                1e3 >=
              128
                ? "#000"
                : "#fff"
            );
          },
          getLuminance: function(e) {
            var t = parseInt(this.normaliseHex(e), 16),
              n = 38 + (t >> 16),
              a = 38 + ((t >> 8) & 255),
              d = 38 + (255 & t);
            return (
              "#" +
              (
                16777216 +
                65536 * (n < 255 ? (n < 1 ? 0 : n) : 255) +
                256 * (a < 255 ? (a < 1 ? 0 : a) : 255) +
                (d < 255 ? (d < 1 ? 0 : d) : 255)
              )
                .toString(16)
                .slice(1)
            );
          },
          isMobile: function() {
            return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
              navigator.userAgent
            );
          },
          isPlainObject: function(e) {
            return (
              "object" == typeof e && null !== e && e.constructor == Object
            );
          },
          traverseDOMPath: function(e, n) {
            return e && e.parentNode
              ? t.hasClass(e, n)
                ? e
                : this.traverseDOMPath(e.parentNode, n)
              : null;
          }
        };
        (e.status = { deny: "deny", allow: "allow", dismiss: "dismiss" }),
          (e.transitionEnd = (function() {
            var e = document.createElement("div"),
              t = {
                t: "transitionend",
                OT: "oTransitionEnd",
                msT: "MSTransitionEnd",
                MozT: "transitionend",
                WebkitT: "webkitTransitionEnd"
              };
            for (var n in t)
              if (t.hasOwnProperty(n) && void 0 !== e.style[n + "ransition"])
                return t[n];
            return "";
          })()),
          (e.hasTransition = !!e.transitionEnd);
        var n = Object.keys(e.status).map(t.escapeRegExp);
        (e.customStyles = {}),
          (e.Popup = (function() {
            function a() {
              this.initialise.apply(this, arguments);
            }
            function d(e) {
              (this.openingTimeout = null), t.removeClass(e, "cc-invisible");
            }
            function i(t) {
              (t.style.display = "none"),
                t.removeEventListener(e.transitionEnd, this.afterTransition),
                (this.afterTransition = null);
            }
            function r() {
              var t = this.options.onInitialise.bind(this);
              if (!window.navigator.cookieEnabled) return t(e.status.deny), !0;
              if (window.CookiesOK || window.navigator.CookiesOK)
                return t(e.status.allow), !0;
              var n = Object.keys(e.status),
                a = this.getStatus(),
                d = n.indexOf(a) >= 0;
              return d && t(a), d;
            }
            function o() {
              var e = [];
              return (
                this.options.position.split("-").forEach(function(t) {
                  e.push("cc-" + t);
                }),
                e
              );
            }
            function c() {
              var e = this.options,
                n =
                  "top" == e.position || "bottom" == e.position
                    ? "banner"
                    : "floating";
              t.isMobile() && (n = "floating");
              var a = ["cc-" + n, "cc-type-" + e.type, "cc-theme-" + e.theme];
              return (
                e.static && a.push("cc-static"),
                a.push.apply(a, o.call(this)),
                function(e) {
                  var n = t.hash(JSON.stringify(e)),
                    a = "cc-color-override-" + n,
                    d = t.isPlainObject(e);
                  return (
                    (this.customStyleSelector = d ? a : null),
                    d && l(n, e, "." + a),
                    d
                  );
                }.call(this, this.options.palette),
                this.customStyleSelector && a.push(this.customStyleSelector),
                a
              );
            }
            function s(n) {
              var a = this.options,
                d = document.createElement("div"),
                i =
                  a.container && 1 === a.container.nodeType
                    ? a.container
                    : document.body;
              d.innerHTML = n;
              var r = d.children[0];
              return (
                (r.style.display = "none"),
                t.hasClass(r, "cc-window") &&
                  e.hasTransition &&
                  t.addClass(r, "cc-invisible"),
                (this.onButtonClick = u.bind(this)),
                r.addEventListener("click", this.onButtonClick),
                a.autoAttach &&
                  (i.firstChild
                    ? i.insertBefore(r, i.firstChild)
                    : i.appendChild(r)),
                r
              );
            }
            function u(a) {
              var d = t.traverseDOMPath(a.target, "cc-btn") || a.target;
              if (t.hasClass(d, "cc-btn")) {
                var i = d.className.match(
                    new RegExp("\\bcc-(" + n.join("|") + ")\\b")
                  ),
                  r = (i && i[1]) || !1;
                r && (this.setStatus(r), this.close(!0));
              }
              t.hasClass(d, "cc-close") &&
                (this.setStatus(e.status.dismiss), this.close(!0)),
                t.hasClass(d, "cc-revoke") && this.revokeChoice();
            }
            function l(n, a, d) {
              if (e.customStyles[n]) ++e.customStyles[n].references;
              else {
                var i = {},
                  r = a.popup,
                  o = a.button,
                  c = a.highlight;
                r &&
                  ((r.text = r.text ? r.text : t.getContrast(r.background)),
                  (r.link = r.link ? r.link : r.text),
                  (i[d + ".cc-window"] = [
                    "color: " + r.text,
                    "background-color: " + r.background
                  ]),
                  (i[d + ".cc-revoke"] = [
                    "color: " + r.text,
                    "background-color: " + r.background
                  ]),
                  (i[
                    d +
                      " .cc-link," +
                      d +
                      " .cc-link:active," +
                      d +
                      " .cc-link:visited"
                  ] = ["color: " + r.link]),
                  o &&
                    ((o.text = o.text ? o.text : t.getContrast(o.background)),
                    (o.border = o.border ? o.border : "transparent"),
                    (i[d + " .cc-btn"] = [
                      "color: " + o.text,
                      "border-color: " + o.border,
                      "background-color: " + o.background
                    ]),
                    o.padding &&
                      i[d + " .cc-btn"].push("padding: " + o.padding),
                    "transparent" != o.background &&
                      (i[d + " .cc-btn:hover, " + d + " .cc-btn:focus"] = [
                        "background-color: " +
                          (o.hover ||
                            (function(e) {
                              return "000000" == (e = t.normaliseHex(e))
                                ? "#222"
                                : t.getLuminance(e);
                            })(o.background))
                      ]),
                    c
                      ? ((c.text = c.text
                          ? c.text
                          : t.getContrast(c.background)),
                        (c.border = c.border ? c.border : "transparent"),
                        (i[d + " .cc-highlight .cc-btn:first-child"] = [
                          "color: " + c.text,
                          "border-color: " + c.border,
                          "background-color: " + c.background
                        ]))
                      : (i[d + " .cc-highlight .cc-btn:first-child"] = [
                          "color: " + r.text
                        ])));
                var s = document.createElement("style");
                document.head.appendChild(s),
                  (e.customStyles[n] = { references: 1, element: s.sheet });
                var u = -1;
                for (var l in i)
                  i.hasOwnProperty(l) &&
                    s.sheet.insertRule(l + "{" + i[l].join(";") + "}", ++u);
              }
            }
            function f(e, t) {
              for (var n = 0, a = e.length; n < a; ++n) {
                var d = e[n];
                if (
                  (d instanceof RegExp && d.test(t)) ||
                  ("string" == typeof d && d.length && d === t)
                )
                  return !0;
              }
              return !1;
            }
            function p() {
              var n = this.setStatus.bind(this),
                a = this.close.bind(this),
                d = this.options.dismissOnTimeout;
              "number" == typeof d &&
                d >= 0 &&
                (this.dismissTimeout = window.setTimeout(function() {
                  n(e.status.dismiss), a(!0);
                }, Math.floor(d)));
              var i = this.options.dismissOnScroll;
              if ("number" == typeof i && i >= 0) {
                var r = function(t) {
                  window.pageYOffset > Math.floor(i) &&
                    (n(e.status.dismiss),
                    a(!0),
                    window.removeEventListener("scroll", r),
                    (this.onWindowScroll = null));
                };
                this.options.enabled &&
                  ((this.onWindowScroll = r),
                  window.addEventListener("scroll", r));
              }
              var o = this.options.dismissOnWindowClick,
                c = this.options.ignoreClicksFrom;
              if (o) {
                var s = function(d) {
                  for (
                    var i = !1, r = d.path.length, o = c.length, u = 0;
                    u < r;
                    u++
                  )
                    if (!i)
                      for (var l = 0; l < o; l++)
                        i || (i = t.hasClass(d.path[u], c[l]));
                  i ||
                    (n(e.status.dismiss),
                    a(!0),
                    window.removeEventListener("click", s),
                    (this.onWindowClick = null));
                }.bind(this);
                this.options.enabled &&
                  ((this.onWindowClick = s),
                  window.addEventListener("click", s));
              }
            }
            var m = {
              enabled: !0,
              container: null,
              cookie: {
                name: "cookieconsent_status",
                path: "/",
                domain: "",
                expiryDays: 365,
                secure: !1
              },
              onPopupOpen: function() {},
              onPopupClose: function() {},
              onInitialise: function(e) {},
              onStatusChange: function(e, t) {},
              onRevokeChoice: function() {},
              onNoCookieLaw: function(e, t) {},
              content: {
                header: "Cookies used on the website!",
                message:
                  "This website uses cookies to ensure you get the best experience on our website.",
                dismiss: "Got it!",
                allow: "Allow cookies",
                deny: "Decline",
                link: "Learn more",
                href: "https://cookiesandyou.com",
                close: "&#x274c;",
                target: "_blank",
                policy: "Cookie Policy"
              },
              elements: {
                header: '<span class="cc-header">{{header}}</span>&nbsp;',
                message:
                  '<span id="cookieconsent:desc" class="cc-message">{{message}}</span>',
                messagelink:
                  '<span id="cookieconsent:desc" class="cc-message">{{message}} <a aria-label="learn more about cookies" role=button tabindex="0" class="cc-link" href="{{href}}" rel="noopener noreferrer nofollow" target="{{target}}">{{link}}</a></span>',
                dismiss:
                  '<a aria-label="dismiss cookie message" role=button tabindex="0" class="cc-btn cc-dismiss">{{dismiss}}</a>',
                allow:
                  '<a aria-label="allow cookies" role=button tabindex="0"  class="cc-btn cc-allow">{{allow}}</a>',
                deny:
                  '<a aria-label="deny cookies" role=button tabindex="0" class="cc-btn cc-deny">{{deny}}</a>',
                link:
                  '<a aria-label="learn more about cookies" role=button tabindex="0" class="cc-link" href="{{href}}" rel="noopener noreferrer nofollow" target="{{target}}">{{link}}</a>',
                close:
                  '<span aria-label="dismiss cookie message" role=button tabindex="0" class="cc-close">{{close}}</span>'
              },
              window:
                '<div role="dialog" aria-live="polite" aria-label="cookieconsent" aria-describedby="cookieconsent:desc" class="cc-window {{classes}}">\x3c!--googleoff: all--\x3e{{children}}\x3c!--googleon: all--\x3e</div>',
              revokeBtn: '<div class="cc-revoke {{classes}}">{{policy}}</div>',
              compliance: {
                info: '<div class="cc-compliance">{{dismiss}}</div>',
                "opt-in":
                  '<div class="cc-compliance cc-highlight">{{deny}}{{allow}}</div>',
                "opt-out":
                  '<div class="cc-compliance cc-highlight">{{deny}}{{allow}}</div>'
              },
              type: "info",
              layouts: {
                basic: "{{messagelink}}{{compliance}}",
                "basic-close": "{{messagelink}}{{compliance}}{{close}}",
                "basic-header": "{{header}}{{message}}{{link}}{{compliance}}"
              },
              layout: "basic",
              position: "bottom",
              theme: "block",
              static: !1,
              palette: null,
              revokable: !1,
              animateRevokable: !0,
              showLink: !0,
              dismissOnScroll: !1,
              dismissOnTimeout: !1,
              dismissOnWindowClick: !1,
              ignoreClicksFrom: ["cc-revoke", "cc-btn"],
              autoOpen: !0,
              autoAttach: !0,
              whitelistPage: [],
              blacklistPage: [],
              overrideHTML: null
            };
            return (
              (a.prototype.initialise = function(e) {
                this.options && this.destroy(),
                  t.deepExtend((this.options = {}), m),
                  t.isPlainObject(e) && t.deepExtend(this.options, e),
                  r.call(this) && (this.options.enabled = !1),
                  f(this.options.blacklistPage, location.pathname) &&
                    (this.options.enabled = !1),
                  f(this.options.whitelistPage, location.pathname) &&
                    (this.options.enabled = !0);
                var n = this.options.window
                    .replace("{{classes}}", c.call(this).join(" "))
                    .replace(
                      "{{children}}",
                      function() {
                        var e = {},
                          n = this.options;
                        n.showLink ||
                          ((n.elements.link = ""),
                          (n.elements.messagelink = n.elements.message)),
                          Object.keys(n.elements).forEach(function(a) {
                            e[a] = t.interpolateString(n.elements[a], function(
                              e
                            ) {
                              var t = n.content[e];
                              return e && "string" == typeof t && t.length
                                ? t
                                : "";
                            });
                          });
                        var a = n.compliance[n.type];
                        a || (a = n.compliance.info),
                          (e.compliance = t.interpolateString(a, function(t) {
                            return e[t];
                          }));
                        var d = n.layouts[n.layout];
                        return (
                          d || (d = n.layouts.basic),
                          t.interpolateString(d, function(t) {
                            return e[t];
                          })
                        );
                      }.call(this)
                    ),
                  a = this.options.overrideHTML;
                if (
                  ("string" == typeof a && a.length && (n = a),
                  this.options.static)
                ) {
                  var d = s.call(
                    this,
                    '<div class="cc-grower">' + n + "</div>"
                  );
                  (d.style.display = ""),
                    (this.element = d.firstChild),
                    (this.element.style.display = "none"),
                    t.addClass(this.element, "cc-invisible");
                } else this.element = s.call(this, n);
                p.call(this),
                  function() {
                    if (
                      ("info" != this.options.type &&
                        (this.options.revokable = !0),
                      t.isMobile() && (this.options.animateRevokable = !1),
                      this.options.revokable)
                    ) {
                      var e = o.call(this);
                      this.options.animateRevokable && e.push("cc-animate"),
                        this.customStyleSelector &&
                          e.push(this.customStyleSelector);
                      var n = this.options.revokeBtn
                        .replace("{{classes}}", e.join(" "))
                        .replace("{{policy}}", this.options.content.policy);
                      this.revokeBtn = s.call(this, n);
                      var a = this.revokeBtn;
                      if (this.options.animateRevokable) {
                        var d = t.throttle(function(e) {
                          var n = !1,
                            d = window.innerHeight - 20;
                          t.hasClass(a, "cc-top") && e.clientY < 20 && (n = !0),
                            t.hasClass(a, "cc-bottom") &&
                              e.clientY > d &&
                              (n = !0),
                            n
                              ? t.hasClass(a, "cc-active") ||
                                t.addClass(a, "cc-active")
                              : t.hasClass(a, "cc-active") &&
                                t.removeClass(a, "cc-active");
                        }, 200);
                        (this.onMouseMove = d),
                          window.addEventListener("mousemove", d);
                      }
                    }
                  }.call(this),
                  this.options.autoOpen && this.autoOpen();
              }),
              (a.prototype.destroy = function() {
                this.onButtonClick &&
                  this.element &&
                  (this.element.removeEventListener(
                    "click",
                    this.onButtonClick
                  ),
                  (this.onButtonClick = null)),
                  this.dismissTimeout &&
                    (clearTimeout(this.dismissTimeout),
                    (this.dismissTimeout = null)),
                  this.onWindowScroll &&
                    (window.removeEventListener("scroll", this.onWindowScroll),
                    (this.onWindowScroll = null)),
                  this.onWindowClick &&
                    (window.removeEventListener("click", this.onWindowClick),
                    (this.onWindowClick = null)),
                  this.onMouseMove &&
                    (window.removeEventListener("mousemove", this.onMouseMove),
                    (this.onMouseMove = null)),
                  this.element &&
                    this.element.parentNode &&
                    this.element.parentNode.removeChild(this.element),
                  (this.element = null),
                  this.revokeBtn &&
                    this.revokeBtn.parentNode &&
                    this.revokeBtn.parentNode.removeChild(this.revokeBtn),
                  (this.revokeBtn = null),
                  (function(n) {
                    if (t.isPlainObject(n)) {
                      var a = t.hash(JSON.stringify(n)),
                        d = e.customStyles[a];
                      if (d && !--d.references) {
                        var i = d.element.ownerNode;
                        i && i.parentNode && i.parentNode.removeChild(i),
                          (e.customStyles[a] = null);
                      }
                    }
                  })(this.options.palette),
                  (this.options = null);
              }),
              (a.prototype.open = function(t) {
                if (this.element)
                  return (
                    this.isOpen() ||
                      (e.hasTransition
                        ? this.fadeIn()
                        : (this.element.style.display = ""),
                      this.options.revokable && this.toggleRevokeButton(),
                      this.options.onPopupOpen.call(this)),
                    this
                  );
              }),
              (a.prototype.close = function(t) {
                if (this.element)
                  return (
                    this.isOpen() &&
                      (e.hasTransition
                        ? this.fadeOut()
                        : (this.element.style.display = "none"),
                      t &&
                        this.options.revokable &&
                        this.toggleRevokeButton(!0),
                      this.options.onPopupClose.call(this)),
                    this
                  );
              }),
              (a.prototype.fadeIn = function() {
                var n = this.element;
                if (
                  e.hasTransition &&
                  n &&
                  (this.afterTransition && i.call(this, n),
                  t.hasClass(n, "cc-invisible"))
                ) {
                  if (((n.style.display = ""), this.options.static)) {
                    var a = this.element.clientHeight;
                    this.element.parentNode.style.maxHeight = a + "px";
                  }
                  this.openingTimeout = setTimeout(d.bind(this, n), 20);
                }
              }),
              (a.prototype.fadeOut = function() {
                var n = this.element;
                e.hasTransition &&
                  n &&
                  (this.openingTimeout &&
                    (clearTimeout(this.openingTimeout), d.bind(this, n)),
                  t.hasClass(n, "cc-invisible") ||
                    (this.options.static &&
                      (this.element.parentNode.style.maxHeight = ""),
                    (this.afterTransition = i.bind(this, n)),
                    n.addEventListener(e.transitionEnd, this.afterTransition),
                    t.addClass(n, "cc-invisible")));
              }),
              (a.prototype.isOpen = function() {
                return (
                  this.element &&
                  "" == this.element.style.display &&
                  (!e.hasTransition ||
                    !t.hasClass(this.element, "cc-invisible"))
                );
              }),
              (a.prototype.toggleRevokeButton = function(e) {
                this.revokeBtn &&
                  (this.revokeBtn.style.display = e ? "" : "none");
              }),
              (a.prototype.revokeChoice = function(e) {
                (this.options.enabled = !0),
                  this.clearStatus(),
                  this.options.onRevokeChoice.call(this),
                  e || this.autoOpen();
              }),
              (a.prototype.hasAnswered = function(t) {
                return Object.keys(e.status).indexOf(this.getStatus()) >= 0;
              }),
              (a.prototype.hasConsented = function(t) {
                var n = this.getStatus();
                return n == e.status.allow || n == e.status.dismiss;
              }),
              (a.prototype.autoOpen = function(e) {
                !this.hasAnswered() && this.options.enabled
                  ? this.open()
                  : this.hasAnswered() &&
                    this.options.revokable &&
                    this.toggleRevokeButton(!0);
              }),
              (a.prototype.setStatus = function(n) {
                var a = this.options.cookie,
                  d = t.getCookie(a.name),
                  i = Object.keys(e.status).indexOf(d) >= 0;
                Object.keys(e.status).indexOf(n) >= 0
                  ? (t.setCookie(
                      a.name,
                      n,
                      a.expiryDays,
                      a.domain,
                      a.path,
                      a.secure
                    ),
                    this.options.onStatusChange.call(this, n, i))
                  : this.clearStatus();
              }),
              (a.prototype.getStatus = function() {
                return t.getCookie(this.options.cookie.name);
              }),
              (a.prototype.clearStatus = function() {
                var e = this.options.cookie;
                t.setCookie(e.name, "", -1, e.domain, e.path);
              }),
              a
            );
          })()),
          (e.Location = (function() {
            function e(e) {
              t.deepExtend((this.options = {}), i),
                t.isPlainObject(e) && t.deepExtend(this.options, e),
                (this.currentServiceIndex = -1);
            }
            function n(e, t, n) {
              var a,
                d = document.createElement("script");
              (d.type = "text/" + (e.type || "javascript")),
                (d.src = e.src || e),
                (d.async = !1),
                (d.onreadystatechange = d.onload = function() {
                  var e = d.readyState;
                  clearTimeout(a),
                    t.done ||
                      (e && !/loaded|complete/.test(e)) ||
                      ((t.done = !0),
                      t(),
                      (d.onreadystatechange = d.onload = null));
                }),
                document.body.appendChild(d),
                (a = setTimeout(function() {
                  (t.done = !0), t(), (d.onreadystatechange = d.onload = null);
                }, n));
            }
            function a(e, t, n, a, d) {
              var i = new (window.XMLHttpRequest || window.ActiveXObject)(
                "MSXML2.XMLHTTP.3.0"
              );
              if (
                (i.open(a ? "POST" : "GET", e, 1),
                i.setRequestHeader(
                  "Content-type",
                  "application/x-www-form-urlencoded"
                ),
                Array.isArray(d))
              )
                for (var r = 0, o = d.length; r < o; ++r) {
                  var c = d[r].split(":", 2);
                  i.setRequestHeader(
                    c[0].replace(/^\s+|\s+$/g, ""),
                    c[1].replace(/^\s+|\s+$/g, "")
                  );
                }
              "function" == typeof t &&
                (i.onreadystatechange = function() {
                  i.readyState > 3 && t(i);
                }),
                i.send(a);
            }
            function d(e) {
              return new Error(
                "Error [" + (e.code || "UNKNOWN") + "]: " + e.error
              );
            }
            var i = {
              timeout: 5e3,
              services: ["ipinfo"],
              serviceDefinitions: {
                ipinfo: function() {
                  return {
                    url: "//ipinfo.io",
                    headers: ["Accept: application/json"],
                    callback: function(e, t) {
                      try {
                        var n = JSON.parse(t);
                        return n.error ? d(n) : { code: n.country };
                      } catch (e) {
                        return d({ error: "Invalid response (" + e + ")" });
                      }
                    }
                  };
                },
                ipinfodb: function(e) {
                  return {
                    url:
                      "//api.ipinfodb.com/v3/ip-country/?key={api_key}&format=json&callback={callback}",
                    isScript: !0,
                    callback: function(e, t) {
                      try {
                        var n = JSON.parse(t);
                        return "ERROR" == n.statusCode
                          ? d({ error: n.statusMessage })
                          : { code: n.countryCode };
                      } catch (e) {
                        return d({ error: "Invalid response (" + e + ")" });
                      }
                    }
                  };
                },
                maxmind: function() {
                  return {
                    url: "//js.maxmind.com/js/apis/geoip2/v2.1/geoip2.js",
                    isScript: !0,
                    callback: function(e) {
                      return window.geoip2
                        ? void geoip2.country(
                            function(t) {
                              try {
                                e({ code: t.country.iso_code });
                              } catch (t) {
                                e(d(t));
                              }
                            },
                            function(t) {
                              e(d(t));
                            }
                          )
                        : void e(
                            new Error(
                              "Unexpected response format. The downloaded script should have exported `geoip2` to the global scope"
                            )
                          );
                    }
                  };
                }
              }
            };
            return (
              (e.prototype.getNextService = function() {
                var e;
                do {
                  e = this.getServiceByIdx(++this.currentServiceIndex);
                } while (
                  this.currentServiceIndex < this.options.services.length &&
                  !e
                );
                return e;
              }),
              (e.prototype.getServiceByIdx = function(e) {
                var n = this.options.services[e];
                if ("function" == typeof n) {
                  var a = n();
                  return (
                    a.name &&
                      t.deepExtend(
                        a,
                        this.options.serviceDefinitions[a.name](a)
                      ),
                    a
                  );
                }
                return "string" == typeof n
                  ? this.options.serviceDefinitions[n]()
                  : t.isPlainObject(n)
                  ? this.options.serviceDefinitions[n.name](n)
                  : null;
              }),
              (e.prototype.locate = function(e, t) {
                var n = this.getNextService();
                return n
                  ? ((this.callbackComplete = e),
                    (this.callbackError = t),
                    void this.runService(
                      n,
                      this.runNextServiceOnError.bind(this)
                    ))
                  : void t(new Error("No services to run"));
              }),
              (e.prototype.setupUrl = function(e) {
                var t = this.getCurrentServiceOpts();
                return e.url.replace(/\{(.*?)\}/g, function(n, a) {
                  if ("callback" === a) {
                    var d = "callback" + Date.now();
                    return (
                      (window[d] = function(t) {
                        e.__JSONP_DATA = JSON.stringify(t);
                      }),
                      d
                    );
                  }
                  if (a in t.interpolateUrl) return t.interpolateUrl[a];
                });
              }),
              (e.prototype.runService = function(e, t) {
                var d = this;
                e &&
                  e.url &&
                  e.callback &&
                  (e.isScript ? n : a)(
                    this.setupUrl(e),
                    function(n) {
                      var a = n ? n.responseText : "";
                      e.__JSONP_DATA &&
                        ((a = e.__JSONP_DATA), delete e.__JSONP_DATA),
                        d.runServiceCallback.call(d, t, e, a);
                    },
                    this.options.timeout,
                    e.data,
                    e.headers
                  );
              }),
              (e.prototype.runServiceCallback = function(e, t, n) {
                var a = this,
                  d = t.callback(function(t) {
                    d || a.onServiceResult.call(a, e, t);
                  }, n);
                d && this.onServiceResult.call(this, e, d);
              }),
              (e.prototype.onServiceResult = function(e, t) {
                t instanceof Error || (t && t.error)
                  ? e.call(this, t, null)
                  : e.call(this, null, t);
              }),
              (e.prototype.runNextServiceOnError = function(e, t) {
                if (e) {
                  this.logError(e);
                  var n = this.getNextService();
                  n
                    ? this.runService(n, this.runNextServiceOnError.bind(this))
                    : this.completeService.call(
                        this,
                        this.callbackError,
                        new Error("All services failed")
                      );
                } else
                  this.completeService.call(this, this.callbackComplete, t);
              }),
              (e.prototype.getCurrentServiceOpts = function() {
                var e = this.options.services[this.currentServiceIndex];
                return "string" == typeof e
                  ? { name: e }
                  : "function" == typeof e
                  ? e()
                  : t.isPlainObject(e)
                  ? e
                  : {};
              }),
              (e.prototype.completeService = function(e, t) {
                (this.currentServiceIndex = -1), e && e(t);
              }),
              (e.prototype.logError = function(e) {
                var t = this.currentServiceIndex,
                  n = this.getServiceByIdx(t);
                console.warn(
                  "The service[" +
                    t +
                    "] (" +
                    n.url +
                    ") responded with the following error",
                  e
                );
              }),
              e
            );
          })()),
          (e.Law = (function() {
            function e(e) {
              this.initialise.apply(this, arguments);
            }
            var n = {
              regionalLaw: !0,
              hasLaw: [
                "AT",
                "BE",
                "BG",
                "HR",
                "CZ",
                "CY",
                "DK",
                "EE",
                "FI",
                "FR",
                "DE",
                "EL",
                "HU",
                "IE",
                "IT",
                "LV",
                "LT",
                "LU",
                "MT",
                "NL",
                "PL",
                "PT",
                "SK",
                "ES",
                "SE",
                "GB",
                "UK",
                "GR",
                "EU"
              ],
              revokable: [
                "HR",
                "CY",
                "DK",
                "EE",
                "FR",
                "DE",
                "LV",
                "LT",
                "NL",
                "PT",
                "ES"
              ],
              explicitAction: ["HR", "IT", "ES"]
            };
            return (
              (e.prototype.initialise = function(e) {
                t.deepExtend((this.options = {}), n),
                  t.isPlainObject(e) && t.deepExtend(this.options, e);
              }),
              (e.prototype.get = function(e) {
                var t = this.options;
                return {
                  hasLaw: t.hasLaw.indexOf(e) >= 0,
                  revokable: t.revokable.indexOf(e) >= 0,
                  explicitAction: t.explicitAction.indexOf(e) >= 0
                };
              }),
              (e.prototype.applyLaw = function(e, t) {
                var n = this.get(t);
                return (
                  n.hasLaw ||
                    ((e.enabled = !1),
                    "function" == typeof e.onNoCookieLaw &&
                      e.onNoCookieLaw(t, n)),
                  this.options.regionalLaw &&
                    (n.revokable && (e.revokable = !0),
                    n.explicitAction &&
                      ((e.dismissOnScroll = !1), (e.dismissOnTimeout = !1))),
                  e
                );
              }),
              e
            );
          })()),
          (e.initialise = function(n, a, d) {
            var i = new e.Law(n.law);
            a || (a = function() {}), d || (d = function() {});
            var r = Object.keys(e.status),
              o = t.getCookie("cookieconsent_status");
            return r.indexOf(o) >= 0
              ? void a(new e.Popup(n))
              : void e.getCountryCode(
                  n,
                  function(t) {
                    delete n.law,
                      delete n.location,
                      t.code && (n = i.applyLaw(n, t.code)),
                      a(new e.Popup(n));
                  },
                  function(t) {
                    delete n.law, delete n.location, d(t, new e.Popup(n));
                  }
                );
          }),
          (e.getCountryCode = function(t, n, a) {
            t.law && t.law.countryCode
              ? n({ code: t.law.countryCode })
              : t.location
              ? new e.Location(t.location).locate(function(e) {
                  n(e || {});
                }, a)
              : n({});
          }),
          (e.utils = t),
          (e.hasInitialised = !0),
          (window.cookieconsent = e);
      }
    })(window.cookieconsent || {});
  },
  lunf: function(e, t, n) {
    "use strict";
    Object.defineProperty(t, "__esModule", { value: !0 });
    var a = n("/jrT"),
      d = function(e, t, n) {
        var a = new Date();
        a.setTime(a.getTime() + 864e5 * n),
          (document.cookie =
            e + "=" + t + ";path=/;expires=" + a.toGMTString());
      },
      i = function(e) {
        var t = document.cookie.match("(^|;) ?" + e + "=([^;]*)(;|$)");
        return t ? t[2] : null;
      },
      r = function() {
        return i("shopify-checkout")
          ? a.a.checkout.fetch(i("shopify-checkout")).then(function(e) {
              var t = 0;
              return e && e.lineItems
                ? (e.lineItems.map(function(e) {
                    t += e.quantity;
                  }),
                  {
                    id: e.id,
                    totalItems: t,
                    lineItems: e.lineItems,
                    url: e.webUrl,
                    subtotalPrice: e.subtotalPrice
                  })
                : a.a.checkout.create().then(function(e) {
                    return (
                      d("shopify-checkout", e.id),
                      {
                        id: e.id,
                        totalItems: 0,
                        lineItems: e.lineItems,
                        url: e.webUrl
                      }
                    );
                  });
            })
          : a.a.checkout.create().then(function(e) {
              return (
                d("shopify-checkout", e.id),
                {
                  id: e.id,
                  totalItems: 0,
                  lineItems: e.lineItems,
                  url: e.webUrl
                }
              );
            });
      };
    t.getProductData = k;
    var o = n("och6"),
      c = o.disableBodyScroll,
      s = o.enableBodyScroll,
      u = document.getElementById("cart");
    i("shopify-checkout") &&
      a.a.checkout
        .fetch(i("shopify-checkout"))
        .then(function(e) {
          e &&
            e.completedAt &&
            (console.log("checkout complete! clearing cart..."),
            d("shopify-checkout", ""));
        })
        .then(function() {
          C();
        });
    var l = function(e) {
        return p
          ? (p.moneyFormat ? p.moneyFormat : "${{amount}}")
              .split(" ")
              .join("")
              .replace(/{{amount}}/, Number.parseFloat(e).toFixed(2))
          : "$" + Number.parseFloat(e).toFixed(2);
      },
      f =
        document.querySelector("#product") &&
        document.querySelector("#product").dataset.product,
      p = null,
      m = null,
      g = { products: [] },
      h = !1;
    function y(e) {
      (m = { variant: { id: e.variants[0].id } }),
        sessionStorage.setItem("shopify-data-" + e.id, JSON.stringify(e)),
        (function(e) {
          var t = document.querySelector("#product-price");
          t &&
            (e.variants[0].compareAtPrice
              ? (t.innerHTML =
                  "<del>" +
                  l(e.variants[0].compareAtPrice) +
                  "</del>\n    " +
                  l(e.variants[0].price))
              : (t.innerHTML = l(e.variants[0].price)));
        })(e);
    }
    function v(e) {
      a.a.product.fetch(e).then(function(e) {
        y(e);
      });
    }
    function k(e) {
      var t = sessionStorage.getItem("shopify-data-" + e);
      t
        ? (y(JSON.parse(t)),
          setTimeout(function() {
            v(e);
          }, 1e3))
        : v(e);
    }
    function C(e, t) {
      var n = document.querySelectorAll(".cart-total");
      r().then(function(a) {
        // if (a.totalItems > 0) {
        //   var d = "" + a.totalItems;
        //   n.forEach(function(e) {
        //     (e.innerHTML = d), e.classList.add("active");
        //   });
        // } else {
        //   var i = "" + a.totalItems;
        //   n.forEach(function(e) {
        //     // (e.innerHTML = i),
        //     e.classList.remove("active");
        //   });
        // }
        if ((e && P("", !0), t)) {
          var r = document.querySelectorAll(".add-to-cart");
          r &&
            r.forEach(function(e) {
              e.classList.contains("adding-active") &&
                setTimeout(function() {
                  (e.innerHTML = e.dataset.text),
                    e.classList.remove("adding-active");
                }, 450);
            });
        }
        var o, c, s;
        (o = a.lineItems),
          (c = document.querySelector("#cart")),
          (s = document.querySelector("#cart-items")),
          (g = { products: [] }),
          o.map(function(e) {
            g.products.push({
              lineId: e.id,
              availableForSale: e.availableForSale,
              title: e.title,
              quantity: e.quantity,
              price: e.variant.price,
              image: e.variant.image ? e.variant.image.src : "#"
            });
          }),
          (s.innerHTML = ""),
          g.products.map(function(e) {
            var t = document.querySelector(
                '#cart-items li[data-lineid~="' + e.lineId + '"]'
              ),
              n = document.querySelector("#cart-subtotal");
            if ((n && n.classList.remove("loading"), t)) {
              document.querySelector("#cart-items li.updating") &&
                document
                  .querySelector("#cart-items li.updating")
                  .classList.remove("updating");
              var a = t.querySelectorAll(".item-price");
              a &&
                a.forEach(function(e) {
                  e.classList.remove("loading");
                }),
                (t.querySelector(".item-quantity").value = e.quantity),
                (t.querySelector(".item-price").innerHTML = l(
                  e.price * e.quantity
                ));
            } else {
              s.innerHTML +=
                '<li data-lineid="' +
                e.lineId +
                '">\n      <div class="item-25">\n      <img src=' +
                e.image +
                " alt=" +
                e.title +
                ' />\n      </div>\n      <div class="item-75">\n      <p class="item-title">' +
                e.title +
                '</p>\n      <div class="item-modifiers">\n      <div class="ajaxcart__qty">\n        <button type="button" class="ajaxcart__qty-adjust ajaxcart__qty--minus icon-fallback-text" data-update-line="true" data-qty="0" data-line="1" aria-label="Reduce item quantity by one">\n          <span class="icon icon-minus" aria-hidden="true"></span>\n          <span class="fallback-text" aria-hidden="true">−</span>\n        </button>\n        <input type="text" name="item-quantity" class="item-quantity ajaxcart__qty-num" value="' +
                e.quantity +
                '" data-lineid="' +
                e.lineId +
                '" min="0" data-line="1" aria-label="quantity" pattern="[0-9]*">\n        <button type="button" class="ajaxcart__qty-adjust ajaxcart__qty--plus icon-fallback-text" data-update-line="true" data-line="1" data-qty="2" aria-label="Increase item quantity by one">\n          <span class="icon icon-plus" aria-hidden="true"></span>\n          <span class="fallback-text" aria-hidden="true">+</span>\n        </button>\n      </div>\n      <span class="item-price">' +
                l(e.price * e.quantity) +
                "</span>\n      </div>\n      </div>\n      </li>";
              var d = void 0,
                i = function(e, t) {
                  t
                    ? (window.clearTimeout(d),
                      (d = window.setTimeout(function() {
                        b(e);
                      }, 250)))
                    : b(e);
                },
                r = document.querySelectorAll("#cart .item-quantity");
              Array.from(r).forEach(function(e) {
                e.addEventListener("input", function(e) {
                  i(e.target.dataset.lineid, !0);
                });
              });
              var o = document.querySelectorAll("#cart .ajaxcart__qty-adjust");
              Array.from(o).forEach(function(e) {
                var t = e.parentNode.querySelector(".ajaxcart__qty-num"),
                  n = t.dataset.lineid;
                e.addEventListener("mouseup", function(a) {
                  if (F) return !1;
                  e.classList.contains("ajaxcart__qty--minus")
                    ? t.value > 0 && (t.value = Math.abs(t.value) - 1)
                    : (t.value = Math.abs(t.value) + 1),
                    e.dataset.updateLine && i(n, !0);
                });
              });
              var c = document
                .querySelector(
                  '#cart-items li[data-lineid~="' + e.lineId + '"]'
                )
                .querySelector(".item-price");
              c && c.classList.remove("loading");
            }
          }),
          g.products < 1
            ? (c.classList.remove("filled"), c.classList.add("empty"))
            : (c.classList.remove("empty"), c.classList.add("filled"));
        var u = document.querySelector("#cart-subtotal");
        u && (u.innerHTML = l(a.subtotalPrice));
      });
    }
    a.a.shop.fetchInfo().then(function(e) {
      p = {
        name: e.name,
        moneyFormat: e.moneyFormat,
        description: e.description,
        currencyCode: e.currencyCode,
        primaryDomain: e.primaryDomain.url
      };
    }),
      r().then(function(e) {
        var t = document.querySelector("#checkout");
        t && t.setAttribute("href", e.url);
      }),
      f && k(f);
    var F = !1,
      b = function(e) {
        if (F) return !1;
        F = !0;
        var t = document.querySelector('li[data-lineid~="' + e + '"]'),
          n = parseInt(
            document.querySelector('.item-quantity[data-lineid~="' + e + '"]')
              .value,
            10
          ),
          d = document.querySelector("#cart-subtotal"),
          i = t.querySelector(".item-price");
        d && d.classList.add("loading"),
          i && i.classList.add("loading"),
          t.classList.add("updating"),
          0 === n
            ? r().then(function(t) {
                t.lineItems.map(function(n) {
                  n.id === e &&
                    a.a.checkout.removeLineItems(t.id, n.id).then(function(e) {
                      C(), (F = !1);
                    });
                });
              })
            : r().then(function(t) {
                t.lineItems.map(function(d) {
                  if (d.id === e) {
                    var i = [{ id: d.id, quantity: n }];
                    a.a.checkout.updateLineItems(t.id, i).then(function(e) {
                      C(), (F = !1);
                    });
                  }
                });
              });
      },
      A = function(e) {
        var t = e.target.dataset.product
            ? e.target.dataset.product
            : m.variant.id,
          n = e.target;
        (n.dataset.text = n.innerHTML),
          (n.innerHTML = "Adding..."),
          n.classList.add("adding-active");
        var d = Math.abs(document.querySelector("#quantity").value);
        r().then(function(e) {
          a.a.checkout
            .addLineItems(e.id, [{ variantId: t, quantity: d }])
            .then(function(e) {
              C(!0, !0);
            })
            .catch(function(e) {
              return e;
            });
        });
      },
      P = function(e, t) {
        var n = document.body,
          a = document.querySelector("#body-overlay");
        h && !t
          ? (n.classList.remove("cart-open"),
            (h = !1),
            a.classList.add("active-out"),
            s(u),
            setTimeout(function() {
              a.classList.remove("active"), a.classList.remove("active-out");
            }, 750))
          : (n.classList.add("cart-open"),
            a.classList.add("active"),
            (h = !0),
            c(u));
      },
      S = document.querySelectorAll("#buy-container .ajaxcart__qty-adjust");
    S &&
      Array.from(S).forEach(function(e) {
        var t = e.parentNode.querySelector(".ajaxcart__qty-num"),
          n = t.dataset.lineid;
        e.addEventListener("mouseup", function(a) {
          e.classList.contains("ajaxcart__qty--minus")
            ? t.value > 1 && (t.value = Math.abs(t.value) - 1)
            : (t.value = Math.abs(t.value) + 1),
            e.dataset.updateLine && updateItemQuantity(n, !0);
        });
      });
    var _ = document.querySelectorAll(".add-to-cart");
    _ &&
      _.forEach(function(e) {
        "buy-container" === e.parentElement.id && document.querySelector(".utility-nav .add-to-cart") &&
          (document.querySelector(".utility-nav .add-to-cart").dataset.variant =
            e.dataset.variant),
          e.addEventListener("click", A, !1);
      });
    var O = document.querySelectorAll(".cart-toggle");
    O &&
      O.forEach(function(e) {
        e.addEventListener("click", P, !1);
      });
  },
  och6: function(e, t, n) {
    var a, d, i, r;
    (r = function(e) {
      "use strict";
      function t(e) {
        if (Array.isArray(e)) {
          for (var t = 0, n = Array(e.length); t < e.length; t++) n[t] = e[t];
          return n;
        }
        return Array.from(e);
      }
      Object.defineProperty(e, "__esModule", { value: !0 });
      var n = !1;
      if ("undefined" != typeof window) {
        var a = {
          get passive() {
            n = !0;
          }
        };
        window.addEventListener("testPassive", null, a),
          window.removeEventListener("testPassive", null, a);
      }
      var d =
          "undefined" != typeof window &&
          window.navigator &&
          window.navigator.platform &&
          /iP(ad|hone|od)/.test(window.navigator.platform),
        i = [],
        r = !1,
        o = -1,
        c = void 0,
        s = void 0,
        u = function(e) {
          return i.some(function(t) {
            return !(!t.options.allowTouchMove || !t.options.allowTouchMove(e));
          });
        },
        l = function(e) {
          var t = e || window.event;
          return (
            !!u(t.target) ||
            1 < t.touches.length ||
            (t.preventDefault && t.preventDefault(), !1)
          );
        },
        f = function() {
          setTimeout(function() {
            void 0 !== s &&
              ((document.body.style.paddingRight = s), (s = void 0)),
              void 0 !== c &&
                ((document.body.style.overflow = c), (c = void 0));
          });
        };
      (e.disableBodyScroll = function(e, a) {
        if (d) {
          if (!e)
            return void console.error(
              "disableBodyScroll unsuccessful - targetElement must be provided when calling disableBodyScroll on IOS devices."
            );
          if (
            e &&
            !i.some(function(t) {
              return t.targetElement === e;
            })
          ) {
            var f = { targetElement: e, options: a || {} };
            (i = [].concat(t(i), [f])),
              (e.ontouchstart = function(e) {
                1 === e.targetTouches.length &&
                  (o = e.targetTouches[0].clientY);
              }),
              (e.ontouchmove = function(t) {
                var n, a, d, i;
                1 === t.targetTouches.length &&
                  ((a = e),
                  (i = (n = t).targetTouches[0].clientY - o),
                  !u(n.target) &&
                    (a && 0 === a.scrollTop && 0 < i
                      ? l(n)
                      : (d = a) &&
                        d.scrollHeight - d.scrollTop <= d.clientHeight &&
                        i < 0
                      ? l(n)
                      : n.stopPropagation()));
              }),
              r ||
                (document.addEventListener(
                  "touchmove",
                  l,
                  n ? { passive: !1 } : void 0
                ),
                (r = !0));
          }
        } else {
          (m = a),
            setTimeout(function() {
              if (void 0 === s) {
                var e = !!m && !0 === m.reserveScrollBarGap,
                  t = window.innerWidth - document.documentElement.clientWidth;
                e &&
                  0 < t &&
                  ((s = document.body.style.paddingRight),
                  (document.body.style.paddingRight = t + "px"));
              }
              void 0 === c &&
                ((c = document.body.style.overflow),
                (document.body.style.overflow = "hidden"));
            });
          var p = { targetElement: e, options: a || {} };
          i = [].concat(t(i), [p]);
        }
        var m;
      }),
        (e.clearAllBodyScrollLocks = function() {
          d
            ? (i.forEach(function(e) {
                (e.targetElement.ontouchstart = null),
                  (e.targetElement.ontouchmove = null);
              }),
              r &&
                (document.removeEventListener(
                  "touchmove",
                  l,
                  n ? { passive: !1 } : void 0
                ),
                (r = !1)),
              (i = []),
              (o = -1))
            : (f(), (i = []));
        }),
        (e.enableBodyScroll = function(e) {
          if (d) {
            if (!e)
              return void console.error(
                "enableBodyScroll unsuccessful - targetElement must be provided when calling enableBodyScroll on IOS devices."
              );
            (e.ontouchstart = null),
              (e.ontouchmove = null),
              (i = i.filter(function(t) {
                return t.targetElement !== e;
              })),
              r &&
                0 === i.length &&
                (document.removeEventListener(
                  "touchmove",
                  l,
                  n ? { passive: !1 } : void 0
                ),
                (r = !1));
          } else
            1 === i.length && i[0].targetElement === e
              ? (f(), (i = []))
              : (i = i.filter(function(t) {
                  return t.targetElement !== e;
                }));
        });
    }),
      (d = [t]),
      void 0 === (i = "function" == typeof (a = r) ? a.apply(t, d) : a) ||
        (e.exports = i);
  },
  wa6o: function(e, t, n) {
    var a = n("657T");
    $(".nav-tabs .nav-link").on("click", function(e) {
      e.preventDefault();
      var t = $(this).attr("href");
      $(".nav-tabs .active").removeClass("active"),
        $(this).addClass("active"),
        a({
          targets: $(".tab-content .active")[0],
          opacity: { value: [1, 0], duration: 300, easing: "easeOutSine" },
          complete: function(e) {
            $(".tab-content .active").removeClass("active"),
              $(t).addClass("active"),
              a({
                targets: $(".container", t)[0],
                translateY: {
                  value: [15, 0],
                  duration: 450,
                  easing: "cubicBezier(0.385, 0.035, 0.330, 1)"
                }
              }),
              a({
                targets: $(t)[0],
                opacity: {
                  value: [0, 1],
                  duration: 850,
                  easing: "cubicBezier(0.385, 0.035, 0.330, 1)"
                }
              });
          }
        });
    });
  }
});
//# sourceMappingURL=meetcircle-v3.js.map
